/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a3ae53e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a3ae53e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"181bb5ac-c818-459f-a92f-9c0206d193be","title":"Änderungsverlauf","link":"change-history.html","desc":"August 2022 Zusatzinformationen zu folgenden Themen:","descFull":"August 2022 Zusatzinformationen zu folgenden Themen: Enrollment over Secure Transport (EST)-Protokoll, wie in RFC 7030 definiert Sicherheits-Dashboard Automatische Zuweisung von Schlüsselwörtern während der Erkennung Unterstützung für E-Mails über SSL/TLS Unterstützung für Windows Server 2022 Aktualisierte Informationen zu folgenden Themen: Unterstützte Druckermodelle Verwalten von Zertifikaten unter Verwendung von Microsoft CA über Microsoft Certificate Enrollment Web Services (MSCEWS) Konfigurieren des OpenXPKI CA-Servers Verwalten von MVE-Konfigurationen März 2022 Aktualisierte Informationen zu den unterstützten Druckermodellen. Zusätzliche Informationen zum Erstellen eines Clientzertifikats. Mai 2021 Aktualisierte Informationen zu folgenden Themen: Unterstützte Druckermodelle Verwalten der Microsoft Certificate Authority (CA) Konfigurieren von  Markvision  Enterprise (MVE) für die automatische Zertifikatsverwaltung Konfigurieren der Microsoft Enterprise Certificate Authority (CA) unter Verwendung des Network Device Enrollment Service (NDES) Zusatzinformationen zu folgenden Themen: Verwalten von Zertifikaten unter Verwendung von Microsoft CA über Microsoft Certificate Enrollment Web Services (MSCEWS) Erstellen eines SSL-Zertifikats für Certificate Enrollment Policy Web Service-Server (CEP) und Certificate Enrollment Web Service-Server (CES) Authentifizierungsmethoden für CEP und CES Benanntes Gerätezertifikat November 2020 Aktualisierte Informationen zu folgenden Themen: Unterstützte Druckermodelle Unterstützte Datenbanken Zusatzinformationen zu folgenden Themen: Verwalten und Bereitstellen von Konfigurationen Sichern und Wiederherstellen der Datenbank Verwalten von Zertifikaten mit OpenXPKI und Microsoft Certificate Authority Zusätzlicher Support für Folgendes: Verwalten und Bereitstellen von Konfigurationen für eine Gruppe von Druckermodellen Erstellen benutzerdefinierter Datenbanknamen Februar 2020 Aktualisierte Informationen zu folgenden Themen: Unterstützte Druckermodelle Unterstützte Server Unterstützte Datenbanken Gültiger MVE-Upgradepfad Zusatzinformationen zu folgenden Themen: Anweisungen für Best Practices Anweisungen zur Verwaltung automatisierter Zertifikate Standardmäßige erweiterte Sicherheitskomponenten und deren Einstellungen Andere Möglichkeiten zum Sichern von Druckern Beispielszenarien Juni 2019 Aktualisierte Informationen zu folgenden Themen: Fußnoten zu Druckermodellen hinzugefügt, für die Zertifikate erforderlich sind Zuweisen von DBO-Rechten beim Einrichten der Datenbank Gültiger Upgradepfad beim Upgrade auf Version 3.4 Dateien, die beim Sichern und Wiederherstellen der Datenbank benötigt werden LDAP-Server-Authentifizierungseinstellungen Zertifikatgültigkeitsstatus, Datumsangaben und Zeitzonenparameter werden den Einstellungen für Suchkriterien hinzugefügt. Konfigurieren der Berechtigungen und Funktionszugriffssteuerungen in den Sicherheitseinstellungen des Druckers Auswählen einer Firmware-Datei aus der Ressourcenbibliothek beim Aktualisieren der Druckerfirmware Auswählen des Startdatums, der Start- und Pausenzeit sowie der Wochentage beim Aktualisieren der Druckerfirmware Verwalten von Konfigurationen Zusatzinformationen zu folgenden Themen: Bedeutung des Druckersicherheitsstatus Konfigurieren erweiterter Sicherheitskomponenten Erstellen einer erweiterten Sicherheitskomponente von einem Drucker Erstellen einer druckbaren Version der Konfigurationseinstellungen Hochladen einer Druckerflottenzertifizierungsstelle Entfernen von Benutzerinformationen und Verweisen Bedeutung von Berechtigungen und Funktionszugriffssteuerungen Schritte zur Fehlerbehebung, wenn das Durchsetzen von Konfigurationen mit mehreren Anwendungen fehlschlägt Schritte zur Fehlerbehebung, wenn ein  Admin -Benutzer das Kennwort vergessen hat August 2018 Aktualisierte Informationen zu folgenden Themen: Unterstützte Druckermodelle Einrichten der Datenbank Aktualisieren auf MVE 3.3 Häufig gestellte Fragen Erstellen einer Aktion Erstellen eines Zeitplans Zusatzinformationen zu folgenden Themen: Einrichten eines Dömänenbenutzerkontos Exportieren von Protokollen Schritte zur Fehlerbehebung, wenn MVE gesicherte Drucker nicht erkennt Juli 2018 Aktualisierte Informationen zur Aktualisierung auf MVE 3.2. April 2018 Aktualisierte Informationen zu folgenden Themen: Unterstützte Druckermodelle Einrichten der Datenbank Sichern und Wiederherstellen von Datenbankdateien Die URL für den Zugriff auf MVE Grundlagen zu Variableneinstellungen Zusatzinformationen zu folgenden Themen: Konfigurieren der Druckerzertifikate Anhalten von Aufgaben Aktualisieren der Druckerfirmware September 2017 Aktualisierte Informationen zu folgenden Themen: Systemvoraussetzungen Kommunikation zwischen MVE und den Formulardruckermodellen 2580, 2581, 2590 und 2591 von  Lexmark Manuelles Verwerfen von Microsoft SQL Server-Datenbanken Sichern und Wiederherstellen von Datenbankdateien Erforderliche Sicherheitseinstellungen für Funktionszugriffssteuerungen beim Bereitstellen von Firmware- und Lösungsdateien für Drucker Unterstützung für Lizenzen beim Bereitstellen von Anwendungen Druckerwarnungen und die zugehörigen Maßnahmen Druckerstatus automatisch wiederherstellen Zuordnung von Ereignissen und Schlüsselwörtern Juni 2017 Erste Dokumentversion für MVE 3.0 Änderungsverlauf"},{"UUID":"13bb0bc3-cc01-4698-9e36-d205bc338780","title":"Übersicht","link":"overview-chapter.html","desc":"Grundlagen zu  Markvision ","descFull":"Grundlagen zu  Markvision  Enterprise Markvision  Enterprise (MVE) ist ein webbasiertes Dienstprogramm zur Druckerverwaltung für IT-Mitarbeiter. MVE ermöglicht das effiziente Verwalten einer großen Flotte von Druckern in einem Unternehmen mithilfe der folgenden Funktionen: Eine Druckerflotte suchen, organisieren und verfolgen. Sie können eine Druckerprüfung durchführen, um Daten wie Status, Einstellungen und Zubehör zu erfassen. Konfigurationen erstellen und Druckern zuweisen. Firmware, Druckerzertifikate, CA-Zertifikate und Anwendungen den Druckern bereitstellen. Druckerereignisse und Warnungen überwachen. Dieses Dokument bietet Informationen zu Konfiguration und Verwendung der Anwendung sowie zur Fehlerbehebung dafür. Dieses Dokument richtet sich an Administratoren. Übersicht Markvision Enterprise Markvision Enterprise Grundlagen"},{"UUID":"196585a2-e310-405f-bf48-692abeba82a6","title":"Erste Schritte","link":"best-practices-topic.html","desc":"Best Practices In diesem Thema","descFull":"Best Practices In diesem Thema werden die empfohlenen Schritte beschrieben, um MVE bei der effektiven Verwaltung Ihrer Flotte zu verwenden. Installieren Sie MVE in Ihrer Umgebung. Erstellen Sie einen Server mit der neuesten Windows Server-Umgebung. Verwandte Inhalte: Web-Server-Anforderungen Erstellen Sie ein Domänenbenutzerkonto, das keinen Administratorzugriff hat. Verwandte Inhalte: Einrichten einer Benutzeranmeldung Erstellen Sie eine Microsoft SQL Server-Datenbank, richten Sie die Verschlüsselung ein, und gewähren Sie dem neuen Benutzerkonto Zugriff auf die Datenbanken. Verwandte Inhalte: Datenbankanforderungen Einrichten der Datenbank Installieren Sie MVE unter Verwendung des Domänenbenutzerkontos und des SQL-Servers mit Windows-Authentifizierung. Verwandte Inhalte: Installation von MVE Richten Sie MVE ein, und suchen und organisieren Sie dann Ihre Flotte. Signieren Sie das Serverzertifikat. Verwandte Inhalte: Signieren des MVE-Zertifikats Einrichten von MVE zur automatischen Verwaltung von Zertifikaten Richten Sie die LDAP-Einstellungen ein. Verwandte Inhalte: Aktivieren der LDAP-Serverauthentifizierung Installieren von LDAP-Zertifikaten Stellen Sie eine Verbindung mit einem E-Mail-Server her. Verwandte Inhalte: Konfigurieren der E-Mail-Einstellungen Suchen Sie Ihre Flotte. Verwandte Inhalte: Erkennen von Druckern Planen Sie Prüfungen und Statusaktualisierungen. Verwandte Inhalte: Überprüfen von Druckern Aktualisieren des Druckerstatus Richten Sie grundlegende Einstellungen wie Kontaktnamen, Standorte, Asset-Tags und Zeitzonen ein. Organisieren Sie Ihre Flotte. Verwenden Sie Schlüsselwörter, zum Beispiel Standorte, um die Drucker zu kategorisieren. Verwandte Inhalte: Zuweisen von Stichwörtern zu Druckern Erstellen eines gespeicherten Suchvorgangs Sichern Sie Ihre Flotte. Sichern Sie den Druckerzugriff mit den standardmäßigen erweiterten Sicherheitskomponenten. Verwandte Inhalte: Sichern von Druckern unter Verwendung der Standardkonfigurationen Bedeutung von Berechtigungen und Funktionszugriffssteuerungen Andere Möglichkeiten, Ihre Drucker zu schützen Erstellen Sie eine gesicherte Konfiguration, die Zertifikate enthält. Verwandte Inhalte: Erstellen einer Konfiguration Importieren von Dateien in die Ressourcenbibliothek Setzen Sie die Konfiguration für Ihre aktuelle Flotte durch. Verwandte Inhalte: Zuweisen von Konfigurationen zu Druckern Durchsetzen von Konfigurationen Planen Sie Durchsetzungen und Konformitätsprüfungen. Verwandte Inhalte: Erstellen eines Zeitplans Fügen Sie Konfigurationen zu Suchprofilen hinzu, um neue Drucker zu sichern. Verwandte Inhalte: Erstellen von Suchprofilen Signieren Sie Druckerzertifikate. Verwandte Inhalte: Signieren des MVE-Zertifikats Halten Sie Ihre Firmware auf dem neuesten Stand. Verwandte Inhalte: Aktualisieren der Drucker-Firmware Installieren und konfigurieren Sie Anwendungen. Verwandte Inhalte: Erstellen einer Konfiguration Importieren von Dateien in die Ressourcenbibliothek Überwachen Sie Ihre Flotte. Verwandte Inhalte: Erstellen eines gespeicherten Suchvorgangs Best Practices"},{"UUID":"ea22f509-8c55-4b44-81bc-c7466e54b9db","title":"Erste Schritte","link":"system-requirements-topic.html","desc":"Systemvoraussetzungen MVE ist wie ein","descFull":"Systemvoraussetzungen MVE ist wie ein Webserver installiert, auf den auf jedem Computer im Netzwerk über einen Web-Browser zugegriffen werden kann. MVE verwendet außerdem eine Datenbank zum Speichern von Informationen über die Druckerflotte. Folgende Listen stellen die Anforderungen für Web-Server, Datenbank und Benutzersystem dar: Web-Server-Anforderungen Systemvoraussetzungen Prozessor Mindestens 2 GHz Dual-Core-Prozessor mit Hyper-Threading Technology (HTT) RAM Mindestens 4 GB Festplattenlaufwerk Mindestens 60 GB MVE Lexmark Document Distributor (LDD-) und das Gerätebereitstellungs-Dienstprogramm (DDU) können nicht auf demselben Server ausgeführt werden. Unterstützte Server Windows Server 2022 Standard Edition Windows Server 2019 Windows Server 2016 Standard Edition Windows Server 2012 Standard Edition Windows Server 2012 R2 MVE unterstützt die Virtualisierung der unterstützten Server in einer lokalen Umgebung. Datenbankanforderungen Unterstützte Datenbanken Firebird  Datenbank (integriert) Microsoft SQL Server 2019 Microsoft SQL Server 2017 Microsoft SQL Server 2016 Microsoft SQL Server 2014 Microsoft SQL Server 2012 Die empfohlene Mindestgröße der Datenbank beträgt 60 GB für die Zuteilung von 20 MB für FRAMEWORK und von 4,5 MB für MONITOR und QUARTZ. Weitere Informationen finden Sie unter  . Benutzer-Systemvoraussetzungen Unterstützte Webbrowser Microsoft Edge Mozilla Firefox (neueste Version) Google Chrome  (neueste Version) Apple Safari (neueste Version) Bildschirmauflösung Mindestens 1.280 x 768 Pixel Webserver-Anforderungen Webserver Anforderungen Datenbankanforderungen Datenbank Anforderungen Benutzer-Systemvoraussetzungen Benutzersystem Anforderungen Unterstützte Betriebssysteme Unterstützte Webbrowser Unterstützte Datenbanken Unterstützte Server"},{"UUID":"ac648283-b08d-41ca-968b-c3fdcddf7705","title":"Erste Schritte","link":"supported-languages-topic.html","desc":"Unterstützte Sprachen Brasilianisches Portugiesisch English","descFull":"Unterstützte Sprachen Brasilianisches Portugiesisch English Französisch Deutsch Italienisch Vereinfachtes Chinesisch Spanisch unterstützte Sprachen Sprachen (unterstützte)"},{"UUID":"6c0244d2-b5c1-47c3-a15d-5d5515a4969e","title":"Erste Schritte","link":"supported-printer-models-topic.html","desc":"Unterstützte Druckermodelle Lexmark 6500 Lexmark","descFull":"Unterstützte Druckermodelle Lexmark 6500 Lexmark B2236 2 Lexmark B2338 2 , B2442 2 , B2546 2 , B2650 2 , B2865 1 Lexmark B3440 2 , B3442 2 Lexmark C2132 Lexmark C2240 2 , C2325 2 , C2425 2 , C2535 2 Lexmark C2335 2 Lexmark C3224 2 Lexmark C3326 2 Lexmark C3426 2 Lexmark C4150 2 , C6160 2 , C9235 2 Lexmark C4342 2 , C4352 2 Lexmark C746, C748 Lexmark C792 Lexmark C925 1 , C950 Lexmark CS310, CS410, CS510 Lexmark CS317, CS417, CS517 Lexmark CS331 2 Lexmark CS421 2 , CS521 2 , CS622 2 Lexmark CS431 2 Lexmark CS531 2 , CS632 2 Lexmark CS720 2 , CS725 2 Lexmark CS727 2 , CS728 2 Lexmark CS730 2 Lexmark CS735 2 Lexmark CS820 2 , CS827 2 Lexmark CS921 2 , CS923 2 , CS927 2 Lexmark CS943 2 Lexmark CX310, CX410, CX510 Lexmark CX317, CX417, CX517 Lexmark CX331 2 Lexmark CX421 2 , CX522 2 , CX622 2 , CX625 2 Lexmark CX431 2 Lexmark CX532 2 Lexmark CX625 2 Lexmark CX635 2 Lexmark CX725 2 Lexmark CX728 2 Lexmark CX730 2 Lexmark CX735 2 Lexmark CX820 2 , CX825 2 , CX827 2 , CX860 2 Lexmark CX920 2 , CX921 2 , CX922 2 , CX923 2 , CX924 2 , CX927 2 Lexmark CX930 2 , CX931 2 Lexmark CX942 2 , CX943 2 , CX944 2 Lexmark Formulardrucker 2580 4 , 2581 4 , 2590 4 , 2591 4 Lexmark M1140, M1145, M3150 Lexmark M1242 2 , M1246 2 , M3250 2 , M5255 2 , M5265 2 , M5270 2 Lexmark M3350 2 Lexmark M5155, M5163, M5170 Lexmark M5255 2 , M5265 2 , M5270 2 Lexmark MB2236 2 Lexmark MB2338 2 , MB2442 2 , MB2546 2 , MB2650 2 , MB2770 2 Lexmark MB3442 2 Lexmark MC2325 2 , MC2425 2 , MC2535 2 , MC2640 2 Lexmark MC3224 2 Lexmark MC3326 2 Lexmark MC3426 2 Lexmark MS310, MS312, MS315, MS410, MS415, MS510, MS610 Lexmark MS317, MS417, MS517 Lexmark MS321 2 , MS421 2 , MS521 2 , MS621 2 , MS622 2 Lexmark MS331 2 , MS431 2 Lexmark MS531 2 , MS631 2 , MS632 2 Lexmark MS617, MS817, MS818 Lexmark MS710, MS711, MS810, MS811, MS812 Lexmark MS725 2 , MS821 2 , MS822 2 , MS823 2 , MS824 2 , MS825 2 , MS826 2 Lexmark MS911 Lexmark MX310, MX410, MX510, MX511, MX610, MX611 Lexmark MX317, MX417, MX517 Lexmark MX321 2 , MX421 2 , MX521 2 , MX522 2 , MX622 2 Lexmark MX331 2 , MX431 2 Lexmark MX432 2 Lexmark MX532 2 , MX632 2 Lexmark MX617, MX717, MX718 Lexmark MX6500 Lexmark MX710, MX711, MX810, MX811, MX812 Lexmark MX721 2 , MX722 2 , MX725 2 , MX822 2 , MX824 2 , MX826 2 Lexmark MX910, MX911, MX912 Lexmark MX931 2 Lexmark T650 1 , T652 1 , T654 1 , T656 1 Lexmark X651 1 , X652 1 , X654 1 , X656 1 , X658 1 , XS651 1 , XS652 1 , XS654 1 , XS658 1 Lexmark X746, X748, X792 Lexmark X850 1 , X852 1 , X854 1 , X860 1 , X862 1 , X864 1 , XS864 1 Lexmark X925, X950, X952, X954 Lexmark XC2130, XC2132 Lexmark XC2235 2 , XC2240 2 , XC4240 2 Lexmark XC2335 2 Lexmark XC4140 2 , XC4150 2 , XC6152 2 , XC8155 2 , XC8160 2 Lexmark XC9225 2 , XC9235 2 , XC9245 2 , XC9255 2 , XC9265 2 Lexmark XC9325 2 , XC9335 2 Lexmark XC9445 2 , XC9455 2 , XC9465 2 Lexmark XM1135, XM1140, XM1145, XM3150 Lexmark XM1242 2 , XM1246 2 , XM3250 2 Lexmark XM3142 2 Lexmark XM3350 2 Lexmark XM5163, XM5170, XM5263, XM5270 Lexmark XM5365 2 , XM5370 2 Lexmark XM7155, XM7163, XM7170, XM7263, XM7270 Lexmark XM7355 2 , MX7365 2 , MX7370 2 Lexmark XM9145, XM9155, XM9165 Lexmark XM9335 2 Lexmark XC2326 Lexmark XC2326 Lexmark XC4342 2 , XC4352 2 1  Eine Aktualisierung des Druckerzertifikats ist erforderlich. In dieser Version wird durch ein Sicherheits- und Leistungs-Update der Java-Plattform Support für manche Algorithmen zur Zertifikatsregistrierung wie beispielsweise MD5 und SHA1 entfernt. Diese Änderung verhindert die Kompatibilität von MVE mit einigen Druckern. Weitere Informationen erhalten Sie in den  Hilfeinformationen . 2  SNMPv3-Unterstützung muss auf dem Drucker aktiviert sein. 3  Wenn ein erweitertes Sicherheitskennwort für den Drucker festgelegt wird, kann MVE den Drucker nicht unterstützen. 4  MVE kann nicht mit den Lexmark-Formulardruckermodellen 2580, 2581, 2590 und 2591 kommunizieren, wenn diese den Status \"Nicht bereit\" aufweisen. Die Kommunikation funktioniert nur, wenn MVE zuvor mit dem Drucker im Status \"Bereit\" kommuniziert hat. Der Drucker kann im Status \"Nicht bereit\" sein, wenn Fehler- oder Warnmeldungen vorliegen, wie wenn z. B. das Verbrauchsmaterial erschöpft ist. Um den Status zu ändern, beheben Sie die Ursache der Fehler- oder Warnmeldung, und drücken anschließend auf  Bereit . Unterstützte Druckermodelle"},{"UUID":"55eb9b08-495f-47e9-8cba-b06e6511dad8","title":"Erste Schritte","link":"setting-up-database-topic.html","desc":"Einrichten der Datenbank Sie können","descFull":"Einrichten der Datenbank Sie können entweder Firebird oder Microsoft SQL Server als Backend-Datenbank verwenden. Die folgende Tabelle kann Ihnen bei der Wahl der zu verwendenden Datenbank helfen. Firebird Microsoft SQL Server Server-Installation Muss auf demselben Server wie MVE installiert sein. Kann von einem beliebigen Server aus ausgeführt werden. Kommunikation Auf localhost begrenzt. Kommuniziert über einen statischen Port oder eine dynamische benannte Instanz. SSL/TLS-Kommunikation mit einem gesicherten Microsoft SQL-Server wird unterstützt. Leistung Zeigt Leistungsprobleme bei großen Flotten. Zeigt die beste Leistung für große Flotten. Größe der Datenbank Die Standardgrößen für Datenbanken betragen 6 MB für FRAMEWORK und 1 MB für MONITOR und QUARTZ. Die FRAMEWORK-Tabelle wächst mit jedem hinzugefügten Drucker-Datensatz um 1 KB. Die Standardgrößen für Datenbanken betragen 20 MB für FRAMEWORK und 4,5 MB für MONITOR und QUARTZ. Die FRAMEWORK-Tabelle wächst mit jedem hinzugefügten Drucker-Datensatz um 1 KB. Konfiguration Automatische Konfiguration während der Installation. Erfordert eine Einrichtung im Vorfeld der Installation. Bei Verwendung von Firebird wird Firebird vom MVE Installationsprogramm installiert und konfiguriert, ohne dass eine weitere Konfiguration erforderlich wäre. Wenn Sie Microsoft SQL Server verwenden, müssen Sie vor der Installation von MVE die folgenden Schritte ausführen: Erlauben Sie die automatische Ausführung der Anwendung. Richten Sie die Netzwerkbibliotheken so ein, dass sie TCP/IP-Sockets verwenden. Richten Sie die folgenden Datenbanken ein: Im Folgenden sind die standardmäßigen Datenbanknamen aufgeführt. Sie können auch benutzerdefinierte Datenbanknamen angeben. FRAMEWORK MONITOR QUARTZ Bei Verwendung einer benannten Instanz legen Sie fest, dass der Microsoft SQL Server-Browser automatisch gestartet werden soll. Andernfalls legen einen statischen Port auf die TCP/IP-Sockets. Erstellen Sie ein Benutzerkonto mit db-Owner-Rechten (Datenbankbesitzer-Rechten) in Bezug auf alle drei Datenbanken, die MVE verwendet, und richten Sie die Datenbank ein. Wenn der Benutzer ein Microsoft SQL Server-Konto ist, müssen Sie den Microsoft SQL Server und die Windows-Authentifizierungsmodi auf dem Microsoft SQL Server aktivieren. Wenn Markvision Enterprise (MVE), welches zur Verwendung von MS SQL Server konfiguriert wurde, deinstalliert wird, werden die erstellten Tabellen oder Datenbanken nicht gelöscht. Nach der Deinstallation müssen die Datenbanken von FRAMEWORK, MONITOR und QUARTZ manuell verschoben werden. Weisen Sie dem Datenbankbenutzer die DBO-Rechte zu, und legen Sie anschließend das DBO-Schema als Standardschema fest. Einrichten der Datenbank Datenbank einrichten Firebird-Datenbank Microsoft SQL Server"},{"UUID":"a7fb29c7-17f2-452d-ab62-e0df5576627a","title":"Erste Schritte","link":"setting-mve-run-as-user-topic.html","desc":"Einrichten einer Benutzeranmeldung Während der","descFull":"Einrichten einer Benutzeranmeldung Während der Installation können Sie festlegen, ob MVE als lokales Systemkonto oder als Domänenbenutzerkonto ausgeführt wird. Die Ausführung von MVE als Domänenbenutzerkonto bietet eine sicherere Installation. Das Domänenbenutzerkonto verfügt über beschränkte Berechtigungen im Vergleich zu einem lokalen Systemkonto. Ausführung als Domänenbenutzerkonto Ausführung im lokalen System Berechtigungen im lokalen System Gesamten Zugriff wie folgt festlegen: $MVE_INSTALL /tomcat/logs $MVE_INSTALL /tomcat/temp $MVE_INSTALL /tomcat/work $MVE_INSTALL /apps/library $MVE_INSTALL /apps/dm-mve/picture $MVE_INSTALL /... /mve_truststore* $MVE_INSTALL /jre/lib/security/cacerts $MVE_INSTALL /apps/dm-mve/WEB-INF/ldap $MVE_INSTALL /apps/dm-mve/download Dabei ist  $MVE_INSTALL  das Installationsverzeichnis. Windows-Berechtigung: LOGON_AS_A_SERVICE Administrator-Berechtigungen Datenbank-Verbindungsauthentifizierung Windows-Authentifizierung mit Microsoft SQL Server SQL-Authentifizierung SQL-Authentifizierung Konfiguration Ein Domänenbenutzer muss vor der Installation konfiguriert werden. Automatische Konfiguration während der Installation Wenn Sie MVE als Domänenbenutzerkonto einrichten, erstellen Sie den Benutzer auf derselben Domäne wie der des MVE-Servers. Benutzeranmeldung einrichten Einrichten von MVE für die Benutzeranmeldung"},{"UUID":"afb39101-87a0-4563-b692-f6ae17221691","title":"Erste Schritte","link":"installing-markvision-topic.html","desc":"Installation von MVE Laden Sie","descFull":"Installation von MVE Laden Sie die ausführbare Datei in einen Pfad herunter, der keine Leerzeichen enthält. Führen Sie die Datei als Administrator aus und folgen Sie den Anweisungen auf dem Computerbildschirm. Passwörter werden gehasht und sicher gespeichert. Stellen Sie sicher, dass Sie Ihre Kennwörter nicht vergessen, oder speichern Sie sie an einem sicheren Ort, da gespeicherte Passwörter nicht entschlüsselt werden können. Wenn Sie sich über die Windows-Authentifizierung mit dem Microsoft SQL Server verbinden, wird keine Verifizierung während der Installation versucht. Stellen Sie sicher, dass der vorgesehene Benutzer des MVE Windows-Dienstes, ein entsprechendes Konto in der Microsoft SQL Server-Instanz besitzt. Der angegebene Benutzer muss db-Owner-Rechte für die Datenbanken FRAMEWORK, MONITOR, und QUARTZ besitzen. MVE installieren Installation von MVE"},{"UUID":"245d6a5b-de21-4569-8017-25a18fd5c30e","title":"Erste Schritte","link":"installing-mve-silently-topic.html","desc":"Installieren von MVE im Hintergrund","descFull":"Installieren von MVE im Hintergrund Datenbankeinstellungen für die Installation im Hintergrund Einstellung Beschreibung Wert --help Zeigt die Liste der gültigen Optionen an. --version Zeigt die Produktinformationen an. --unattendedmodeui <unattendedmodeui> Die Benutzeroberfläche für den unbeaufsichtigten Modus. Standard:  keine Zugelassen: keine minimal minimalWithDialogs --optionfile <optionfile> Die Datei mit den Installationsoptionen. Standard: --debuglevel <debuglevel> Die Debuginformationsebene der Verbosität. Standard:  2 Zugelassen: 0 1 2 3 4 --mode <mode> Der Installationsmodus. Standard:  win32 Zugelassen: win32 unbeaufsichtigt --debugtrace <debugtrace> Der Name der Debugdatei. Standard: --installer-language <installer-language> Die Sprachauswahl. Standard:  de Zugelassen: de es de fr it pt_BR zh_CN --encryptionKey <encryptionKey> Der Kodierungsschlüssel. Kodierungsschlüssel: Standard: --prefix <prefix> Das Installationsverzeichnis. Standard:  C:\\Programme --mveLexmark_runas <mveLexmark_runas> Die Benutzeroptionen für \"Ausführen als\". Standard:  LOCAL_SYSTEM Zugelassen: LOCAL_SYSTEM SPECIFIC_USER --serviceRunAsUsername <serviceRunAsUsername> Der Benutzername für \"Ausführen als\". Benutzername: Standard: --serviceRunAsPassword <serviceRunAsPassword> Das Benutzerkennwort für \"Ausführen als\". Kennwort: Standard: --mveLexmark_database <mveLexmark_database> Der Datenbanktyp. Standard: Zugelassen: FIREBIRD SQL_SERVER --firebirdUsername <firebirdUsername> Der Benutzername der Firebird-Datenbank. Benutzername: Standard: --firebirdPassword <firebirdPassword> Das Kennwort der Firebird-Datenbank. Kennwort: Standard: --firebirdFWDbName <firebirdFWDbName> Der Name der Firebird-Datenbank für FRAMEWORK. Datenbanknamen: Standard:  FRAMEWORK --firebirdMNDbName <firebirdMNDbName> Der Firebird-Datenbankname für MONITOR. Standard:  MONITOR --firebirdQZDbName <firebirdQZDbName> Der Firebird-Datenbankname für QUARTZ. Standard:  QUARTZ --databaseIPAddress <databaseIPAddress> Die IP-Adresse oder der Hostname der Datenbank. IP-Adresse oder Hostname: Standard: --databasePort <databasePort> Die Anschlussnummer der Datenbank. Anschlussnummer: Standard: --instanceName <instanceName> Der Instanzname. Instanzname: Standard: --instanceIdentifier <instanceIdentifier> Die Instanz. Standard:  databasePort Zugelassen: databasePort instanceName --databaseUsername <databaseUsername> Der Benutzername der Datenbank. Benutzername: Standard: --databasePassword <databasePassword> Das Kennwort der Datenbank. Kennwort: Standard: --sqlServerAuthenticationMethod <sqlServerAuthenticationMethod> Die Authentifizierungsmethode für den Microsoft SQL-Server. Standard:  sqlServerDbAuthentication Zugelassen: sqlServerDbAuthentication sqlServerWindowsAuthentication --fWDbName <fWDbName> Der Datenbankname für FRAMEWORK. Datenbanknamen: Standard:  FRAMEWORK --mNDbName <mNDbName> Der Datenbankname für MONITOR. Standard:  MONITOR --qZDbName <qZDbName> Der Datenbankname für QUARTZ. Standard:  QUARTZ --mveAdminUsername <mveAdminUsername> Der Benutzername des Administrators. Benutzername: Standard:  admin --mveAdminPassword <mveAdminPassword> Das Kennwort des Administrators. Kennwort: Standard: Installation von MVE im Hintergrund MVE-Installation im Hintergrund Installation im Hintergrund MVE"},{"UUID":"829acf9c-c537-4457-8d6e-da02f1737277","title":"Erste Schritte","link":"accessing-mve-topic.html","desc":"Zugreifen auf MVE Verwenden Sie","descFull":"Zugreifen auf MVE Verwenden Sie die Anmeldeinformationen, die Sie bei der Installation erstellt haben, um auf MVE zuzugreifen. Sie können auch andere Anmeldemethoden, z. B. LDAP, Kerberos oder andere lokale Konten, einrichten. Weitere Informationen finden Sie unter  . Öffnen Sie einen Web-Browser, und geben Sie in das Feld \"URL\" Folgendes ein:  https:// MVE_SERVER /mve/ , wobei  MVE_SERVER  der Hostname oder die IP-Adresse der auf dem Server gehosteten MVE-Software ist. Akzeptieren Sie gegebenenfalls den Haftungsausschluss. Geben Sie Ihre Benutzeranmeldeinformationen ein. Klicken Sie auf  Anmelden . Stellen Sie sicher, dass Sie nach der Anmeldung das Standard-Administratorpasswort, das während der Installation verwendet wurde, ändern. Weitere Informationen finden Sie unter  . Der Benutzer wird automatisch abgemeldet, wenn MVE mehr als 30 Minuten nicht verwendet wird. MVE Zugreifen auf Zugreifen auf MVE"},{"UUID":"4d1feb4d-ae88-4823-93c5-71ff23d4cb87","title":"Erste Schritte","link":"changing-language-topic.html","desc":"Ändern der Sprache Öffnen Sie","descFull":"Ändern der Sprache Öffnen Sie einen Web-Browser, und geben Sie in das Feld \"URL\" Folgendes ein:  https:// MVE_SERVER /mve/ , wobei  MVE_SERVER  der Hostname oder die IP-Adresse der auf dem Server gehosteten MVE-Software ist. Akzeptieren Sie gegebenenfalls den Haftungsausschluss. Wählen Sie in der oberen rechten Ecke der Seite eine Sprache aus. Ändern der Sprache Sprache Ändern"},{"UUID":"7d01701f-57be-4131-8ea6-24e7f472da04","title":"Erste Schritte","link":"changing-your-password-topic.html","desc":"Ändern des Passworts Öffnen Sie","descFull":"Ändern des Passworts Öffnen Sie einen Web-Browser, und geben Sie in das Feld \"URL\" Folgendes ein:  https:// MVE_SERVER /mve/ , wobei  MVE_SERVER  der Hostname oder die IP-Adresse der auf dem Server gehosteten MVE-Software ist. Akzeptieren Sie gegebenenfalls den Haftungsausschluss. Geben Sie Ihre Benutzeranmeldeinformationen ein. Klicken Sie auf  Anmelden . Klicken Sie in der oberen rechten Ecke der Seite auf Ihren Benutzernamen, und klicken Sie dann auf  Passwort ändern . Ändern Sie das Passwort. Passwort ändern Ändern des Passworts"},{"UUID":"28db60ae-f4ac-4df5-912d-82de570878f3","title":"Warten der Anwendung","link":"upgrading-to-latest-version-topic.html","desc":"Aktualisieren auf MVE 4.2 Führen Sie","descFull":"Aktualisieren auf MVE 4.2 Führen Sie vor Beginn der Aktualisierung Folgendes aus: Sichern Sie die Datenbank-, Anwendungs- und Eigenschaftsdateien. Weitere Informationen finden Sie unter  . Geben Sie bei Bedarf benutzerdefinierte Datenbanknamen an. Wenn Sie ein Upgrade von Version 1.x durchführen, führen Sie zunächst ein Upgrade auf Version 2.0, dann auf Version 3.3 und dann auf Version 4.0 durch, bevor Sie auf Version 4.2 aktualisieren. Die Richtlinienmigration wird nur bei einem Upgrade auf MVE 2.0 durchgeführt. Beispiel Gültiger Upgradepfad 3.3  auf  4.0  auf  4.2 Ungültiger Upgradepfad 1.6.x  auf  4.2 2.0  auf  4.2 Sichern Sie Ihre Datenbank- und Anwendungsdateien. Bei jeder Aktualisierung oder Deinstallation besteht das Risiko eines nicht zu behebenden Datenverlusts. Sie können die Sicherungsdateien verwenden, um die Anwendung auf ihren vorherigen Status zurückzusetzen, falls das Upgrade fehlschlägt. Beim Aktualisieren von MVE ändert sich die Datenbank. Stellen Sie keine von einer älteren Version erstellte Datenbanksicherung wieder her. Weitere Informationen finden Sie unter  . Laden Sie die ausführbare Datei in ein temporäres Verzeichnis herunter. Führen Sie die Datei als Administrator aus, und folgen Sie den Anweisungen auf dem Computerbildschirm. Beim Upgrade auf MVE 2.0 werden Richtlinien, die Druckern zugewiesen sind, für jedes Druckermodell in eine einzige Konfiguration migriert. Wenn beispielsweise Richtlinien für Faxen, Kopieren, Papier und Drucken einem X792-Drucker zugewiesen sind, werden diese Richtlinien in einer X792-Konfiguration zusammengefasst. Dies gilt nicht für Richtlinien, die keinem Drucker zugewiesen sind. MVE erstellt eine Protokolldatei, in der die erfolgreiche Migration der Richtlinien in eine Konfiguration bestätigt wird. Weitere Informationen finden Sie unter  . Stellen Sie nach der Aktualisierung sicher, dass Sie den Browsercache leeren, bevor Sie erneut auf die Anwendung zugreifen. Wenn Sie MVE auf Version 3.5 oder höher aktualisieren, werden die erweiterten Sicherheitskomponenten aus den Konfigurationen ausgeklammert, in denen sie sich befinden. Wenn mindestens eine erweiterte Sicherheitskomponente identisch ist, werden die Komponenten zu einer Komponente zusammengefasst. Die erstellte erweiterte Sicherheitskomponente wird automatisch zur Bibliothek der erweiterten Sicherheitskomponenten hinzugefügt. Aktualisieren auf die neueste Version von MVE MVE Aktualisieren"},{"UUID":"1aa06e4e-78e8-4f7d-a5a3-705f1d49e395","title":"Warten der Anwendung","link":"backing-up-and-restoring-database-topic.html","desc":"Sichern und Wiederherstellen der Datenbank","descFull":"Sichern und Wiederherstellen der Datenbank Bei der Durchführung von Sicherungs- und Wiederherstellungsvorgängen kann es zu Datenverlust kommen. Stellen Sie sicher, dass die Schritte ordnungsgemäß ausgeführt werden. Sichern der Datenbank- und Anwendungsdateien Wir empfehlen Ihnen, Ihre Datenbank regelmäßig zu sichern. Stoppen Sie den Firebird- und den Markvision Enterprise-Dienst. Öffnen Sie das Dialogfeld  Ausführen , und geben Sie anschließend  services.msc  ein. Klicken Sie mit der rechten Maustaste auf  Firebird Guardian - DefaultInstance , und klicken Sie anschließend auf  Stopp . Klicken Sie mit der rechten Maustaste auf  Markvision Enterprise , und klicken Sie anschließend auf  Stopp . Navigieren Sie zu dem Ordner, in dem Markvision Enterprise installiert ist. Beispiel:  C:\\Programme\\ Sichern Sie die Anwendungs- und Datenbankdateien. Sichern der Anwendungsdateien Kopieren Sie folgende Dateien in ein sicheres Repository: Lexmark\\mve_encryption.jceks Lexmark\\mve_truststore.p12 Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\platform.properties Lexmark\\Markvision Enterprise\\apps\\library Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml Stellen Sie sicher, dass diese Dateien ordnungsgemäß gespeichert sind. Ohne die Verschlüsselungsschlüssel in der Datei mve_Encryption.jceks können Daten, die in einem verschlüsselten Format in der Datenbank und im Dateisystem gespeichert sind, nicht wiederhergestellt werden. Sichern der Datenbank-Dateien Führen Sie einen der folgenden Schritte aus: Die folgenden Dateien verwenden die standardmäßigen Datenbanknamen. Diese Anweisungen gelten auch für benutzerdefinierte Datenbanknamen. Wenn Sie eine Firebird-Datenbank verwenden, kopieren Sie die folgenden Dateien in ein sicheres Repository. Diese Dateien müssen regelmäßig gesichert werden, um Datenverlust vorzubeugen. Lexmark\\Markvision Enterprise\\firebird\\security2.fdb Wenn Sie benutzerdefinierte Datenbanknamen verwenden, aktualisieren Sie Folgendes: Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service/WEB-INF\\classes\\application.yml Lexmark\\Markvision Enterprise\\firebird\\aliases.conf Lexmark\\Markvision Enterprise\\firebird\\Data\\QUARTZ.FDB Lexmark\\Markvision Enterprise\\firebird\\Data\\MONITOR.FDB Lexmark\\Markvision Enterprise\\firebird\\Data\\FRAMEWORK.FDB Wenn Sie Microsoft SQL Server verwenden, erstellen Sie eine Sicherung für FRAMEWORK, MONITOR und QUARTZ. Weitere Informationen erhalten Sie bei Ihrem SQL-Server-Administrator. Starten Sie den Firebird-Dienst und den Markvision Enterprise-Dienst erneut. Öffnen Sie das Dialogfeld  Ausführen , und geben Sie anschließend  services.msc  ein. Klicken Sie mit der rechten Maustaste auf  Firebird Guardian – DefaultInstance , und klicken Sie anschließend auf  Neu starten . Klicken Sie mit der rechten Maustaste auf  Markvision Enterprise , und klicken Sie anschließend auf  Neu starten . Wiederherstellen von Datenbank- und Anwendungsdateien Beim Aktualisieren von MVE kann sich die Datenbank ändern. Stellen Sie keine Datenbanksicherung wieder her, die von einer älteren Version erstellt wurde. Beenden Sie den Markvision Enterprise-Dienst. Weitere Informationen finden Sie in   unter  . Navigieren Sie zu dem Ordner, in dem Markvision Enterprise installiert ist. Beispiel:  C:\\Programme\\ Stellen Sie die Anwendungsdateien wieder her. Ersetzen Sie die folgenden Dateien durch die während des Sicherungsprozesses gespeicherten Dateien: Lexmark\\mve_encryption.jceks Lexmark\\mve_truststore.p12 Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\platform.properties Lexmark\\Markvision Enterprise\\apps\\library Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml Sie können eine Datenbanksicherung in einer neuen MVE-Installation nur wiederherstellen, wenn es sich bei der neuen MVE-Installation um die gleiche Version handelt. Stellen Sie die Datenbankdateien wieder her. Führen Sie einen der folgenden Schritte aus: Wenn Sie eine Firebird-Datenbank verwenden, ersetzen Sie die folgenden Dateien, die Sie während des Sicherungsvorgangs gespeichert haben: Die folgenden Dateien verwenden die standardmäßigen Datenbanknamen. Diese Anweisung gilt auch für benutzerdefinierte Datenbanknamen. Lexmark\\Markvision Enterprise\\firebird\\security2.fdb Wenn Sie benutzerdefinierte Datenbanknamen verwenden, werden auch die folgenden Dateien wiederhergestellt: Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service/WEB-INF\\classes\\application.yml Lexmark\\Markvision Enterprise\\firebird\\aliases.conf Lexmark\\Markvision Enterprise\\firebird\\Data\\QUARTZ.FDB Lexmark\\Markvision Enterprise\\firebird\\Data\\MONITOR.FDB Lexmark\\Markvision Enterprise\\firebird\\Data\\FRAMEWORK.FDB Bei Verwendung von Microsoft SQL Server wenden Sie sich an Ihren Microsoft SQL Server-Administrator. Starten Sie den Markvision Enterprise-Dienst erneut. Weitere Informationen finden Sie in   unter  . Datenbank Sichern Datenbank Wiederherstellen Sichern und Wiederherstellen der Datenbank"},{"UUID":"fba4261c-fc66-49dd-ab35-806bf472c9ed","title":"Warten der Anwendung","link":"changing-installer-settings-topic.html","desc":"Aktualisieren der Installationsprogramm-Einstellungen nach der","descFull":"Aktualisieren der Installationsprogramm-Einstellungen nach der Installation Mit dem Markvision Enterprise-Kennwortdienstprogramm können Sie, ohne Neuinstallation von MVE, die Microsoft SQL Server-Einstellungen aktualisieren, die während der Installation konfiguriert wurden. Mit diesem Dienstprogramm können Sie auch Benutzeranmeldeinformationen des Domänenkontos aktualisieren, wie etwa Benutzernamen und Kennwort. Sie können das Dienstprogramm auch verwenden, um ein weiteres Administratorkonto zu erstellen, wenn Sie Ihre vorherigen Administrator-Anmeldeinformationen vergessen haben. Navigieren Sie zu dem Ordner, in dem Markvision Enterprise installiert ist. Beispiel:  C:\\Program Files\\ Starten Sie die Datei  mvepwdutility-windows.exe  im Verzeichnis Lexmark\\Markvision Enterprise\\. Wählen Sie eine Sprache aus und klicken Sie dann auf  OK Weiter . Befolgen Sie dann die Anweisungen auf dem Bildschirm. Ändern der Installationsprogramm-Einstellungen nach der Installation Installationsprogramm-Einstellungen Ändern"},{"UUID":"c9daa132-4f20-40f6-be27-80254f8580f4","title":"Einrichten des Benutzerzugriffs","link":"setting-up-user-access-overview-topic.html","desc":"Übersicht Mit MVE können Sie","descFull":"Übersicht Mit MVE können Sie interne Benutzer direkt dem MVE-Server hinzufügen oder die bei einem LDAP-Server registrierten Benutzerkonten verwenden. Weitere Informationen über das Hinzufügen von internen Benutzern finden Sie unter  . Weitere Informationen zum Verwenden von LDAP-Benutzerkonten finden Sie unter  . Beim Hinzufügen von Benutzern müssen Rollen zugewiesen werden. Weitere Informationen finden Sie unter  . Während der Authentifizierung überprüft das System die Benutzeranmeldeinformationen der internen Benutzer auf dem MVE-Server. Wenn MVE den Benutzer nicht authentifizieren kann, wird ein neuer Versuch anhand der im LDAP-Server registrierten Benutzer durchgeführt. Wenn der Benutzername sowohl im MVE- als auch im LDAP-Server vorhanden ist, wird das MVE-Passwort verwendet. Übersicht über das Einrichten des Benutzerzugriffs Übersicht Einrichten des Benutzerzugriffs"},{"UUID":"4cb93ceb-1b1d-4c9f-a060-b48aa9c3ac30","title":"Einrichten des Benutzerzugriffs","link":"understanding-user-roles-topic.html","desc":"Informationen zu Benutzerrollen MVE-Benutzern können","descFull":"Informationen zu Benutzerrollen MVE-Benutzern können eine oder mehrere Rollen zugewiesen werden. Abhängig von der Rolle können Benutzer folgende Aufgaben ausführen: Admin : Zugreifen auf und Durchführen von Aufgaben in allen Menüs. Verfügt außerdem über Administratorrechte, zum Beispiel das Hinzufügen von Benutzern zum System oder das Konfigurieren von Systemeinstellungen. Nur Benutzer mit einer Admin-Rolle können laufende Aufgaben anhalten, unabhängig davon, welcher Benutzertyp die Aufgaben gestartet hat. Drucker Suchprofile verwalten. Den Druckerstatus einstellen. Eine Prüfung durchführen. Kategorien und Stichwörter verwalten. Eine Prüfung, einen Datenexport und eine Druckersuche planen. Konfigurationen Konfigurationen verwalten, einschließlich Importieren und Exportieren von Konfigurationsdateien. Dateien in die Ressourcenbibliothek hochladen. Druckern Konfigurationen zuweisen und durchsetzen. Übereinstimmungsprüfung und Konfigurationsdurchsetzung planen. Stellen Sie Dateien für Drucker bereit. Aktualisieren der Drucker-Firmware Erzeugen Sie Signieraufforderungen für Druckerzertifikate. Laden Sie Signieraufforderungen für Druckerzertifikate herunter. Event Manager Aktionen und Ereignissen verwalten. Geräten Ereignisse zuweisen. Testaktionen. Service Desk Druckerstatus aktualisieren. Drucker neu starten. Übereinstimmungsprüfung ausführen. Konfigurationen auf Drucker durchsetzen. Alle Benutzer können in MVE die Druckerinformationsseite anzeigen und gespeicherte Suchvorgänge und Ansichten verwalten. Weitere Informationen über das Zuweisen von Benutzerrollen finden Sie unter  . Benutzerrollen Erläuterungen Informationen zu Benutzerrollen"},{"UUID":"ef86dd48-37ab-46b7-83f7-52499bbe99c9","title":"Einrichten des Benutzerzugriffs","link":"managing-users-topic.html","desc":"Verwalten von Benutzern Klicken Sie","descFull":"Verwalten von Benutzern Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  Benutzer , und wählen Sie dann eine der folgenden Möglichkeiten aus: Benutzer hinzufügen Klicken Sie auf  Erstellen . Geben Sie Benutzernamen, Benutzer-ID und Passwort ein. Wählen Sie die Rollen aus. Weitere Informationen finden Sie unter  . Klicken Sie auf  Benutzer erstellen . Benutzer bearbeiten Wählen Sie eine Benutzer-ID aus. Konfigurieren Sie die Einstellungen. Klicken Sie auf  Änderungen speichern . Benutzer löschen Wählen Sie einen oder mehrere Benutzer aus. Klicken Sie auf  Löschen , und bestätigen Sie dann das Löschen. Ein Benutzerkonto wird nach drei hintereinander fehlgeschlagenen Anmeldeversuchen gesperrt. Nur ein Administrator kann das Benutzerkonto reaktivieren. Wenn der Administrator gesperrt wird, wird er vom System automatisch nach fünf Minuten reaktiviert. Verwalten von Benutzern Benutzer Verwalten Benutzer Hinzufügen Benutzer Bearbeiten Benutzer Löschen"},{"UUID":"c20e33e6-e6ae-441f-9429-577d9d2c505a","title":"Einrichten des Benutzerzugriffs","link":"enabling-ldap-server-authentication-topic.html","desc":"Aktivieren der LDAP-Server-Authentifizierung LDAP ist","descFull":"Aktivieren der LDAP-Server-Authentifizierung LDAP ist ein standardbasiertes, plattformübergreifendes und erweiterbares Protokoll, das direkt über TCP/IP ausgeführt wird. Es wird für den Zugriff auf spezielle Datenbanken (Verzeichnisse) verwendet. Um zu vermeiden, dass mehrere Anmeldeinformationen verwaltet werden müssen, können Benutzer-IDs und Kennwörter mithilfe des firmeneigenen LDAP-Servers authentifiziert werden. Voraussetzung dafür ist, dass der LDAP-Server Benutzergruppen enthält, die den erforderlichen Benutzerrollen entsprechen. Weitere Informationen finden Sie unter  . Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  LDAP , und wählen Sie anschließend  LDAP für Authentifizierung aktivieren  aus. In dem Feld  Hostname des LDAP-Servers  wird die IP-Adresse oder der Hostname des LDAP-Servers angezeigt, auf dem die Authentifizierung stattfindet. Wenn die Kommunikation zwischen MVE- und LDAP-Server verschlüsselt werden soll, verwenden Sie den vollqualifizierten Domänennamen (FQDN). Geben Sie die Server-Anschlussnummer entsprechend dem ausgewählten Verschlüsselungsprotokoll an. Wählen Sie das Verschlüsselungsprotokoll aus. Keine TLS : ein Sicherheitsprotokoll, das die Kommunikation zwischen einem Server und einem Client mittels Datenverschlüsselung und Zertifikatauthentifizierung schützt. Wenn diese Option ausgewählt ist, wird ein START_TLS-Befehl an den LDAP-Server gesendet, nachdem die Verbindung hergestellt worden ist. Verwenden Sie diese Einstellung, wenn Sie eine sichere Kommunikation über Port 389 wünschen. SSL/TLS : Ein Sicherheitsprotokoll, das die Kommunikation zwischen einem Server und einem Client mithilfe von Kryptografie mit öffentlichem Schlüssel authentifiziert. Verwenden Sie diese Option, wenn Sie eine gesicherte Kommunikation ab dem Beginn der LDAP-Bindung wünschen. Diese Option wird in der Regel für Port 636 oder andere gesicherte LDAP-Anschlüsse verwendet. Wählen Sie den Bindungstyp aus. Einfach : Der MVE-Server legt die angegebenen Anmeldeinformationen gegenüber dem LDAP-Server offen, um dessen Suchfunktion zu verwenden. Geben Sie den Verbindungsbenutzernamen ein. Geben Sie das Verbindungskennwort ein, und bestätigen Sie anschließend das Kennwort. Kerberos : Zur Konfiguration der Einstellungen gehen Sie folgendermaßen vor: Geben Sie den Verbindungsbenutzernamen ein. Geben Sie das Verbindungskennwort ein, und bestätigen Sie anschließend das Kennwort. Klicken Sie auf  Datei auswählen , und navigieren Sie zur Datei \"krb5.conf\". SPNEGO : Zur Konfiguration der Einstellungen gehen Sie folgendermaßen vor: Geben Sie den Dienstprinzipalnamen ein. Klicken Sie auf  Datei auswählen , und navigieren Sie zur Datei \"krb5.conf\". Klicken Sie auf  Datei auswählen , und navigieren Sie zur Kerberos-Schlüsseltabellendatei. Diese Option wird nur für die Konfiguration des Simple and Protected GSSAPI Negotiation Mechanism (SPNEGO) zur Unterstützung der Single-Sign-On-Funktionalität verwendet. Konfigurieren Sie im Abschnitt  Erweiterte Optionen  Folgendes: Suchbasis : der definierte Name (DN) des Root-Knotens. In der Hierarchie des LDAP-Community-Servers muss dieser Knoten der Vorgänger des Benutzer- und Gruppenknotens sein. Beispiel:  dc=mvetest,dc=com . Wenn Sie einen Root-DN angeben, stellen Sie sicher, dass der Ausdruck nur  dc  und  o  enthält. Wenn  ou  oder  cn  für den Vorgänger der Benutzer- oder Gruppenknoten angegeben ist, verwenden Sie  ou  oder  cn  in den Ausdrücken \"Benutzersuchbasis\" und \"Gruppensuchbasis\". Benutzersuchbasis : der Knoten im LDAP-Community-Server, in dem das Benutzerobjekt enthalten ist. Dieser Knoten befindet sich unterhalb des Root-DNs, in dem alle Benutzerknoten aufgeführt sind. Beispiel:  ou=people . Filter für Benutzersuche : der Parameter zur Suche nach einem Benutzerobjekt im LDAP-Community-Server. Beispiel:  (uid={0}) . Beispiele für zulässige mehrere Bedingungen und komplexe Ausdrücke Anmelden mit Geben Sie im Feld  Filter für Benutzersuche  Folgendes ein: Gemeinsamer Name (CN={0}) Anmeldename (sAMAccountName={0}) Benutzerprinzipalname (userPrincipalName={0}) Telefonnummer (telephoneNumber={0}) Anmeldename oder gemeinsamer Name (|(sAMAccountName={0})(CN={0})) Das einzig gültige Muster lautet  {0} . Das bedeutet, dass MVE nach dem Anmeldenamen des MVE-Benutzers sucht. Benutzerbasisobjekt und gesamten SubTree durchsuchen : Das System durchsucht alle Knoten unter der Benutzersuchbasis. Gruppensuchbasis : Der Knoten im LDAP-Community-Server, der die den MVE-Rollen entsprechenden Benutzergruppen enthält. Dieser Knoten befindet sich unterhalb des Root-DNs, in dem alle Gruppenknoten aufgeführt sind. Beispiel:  ou=group . Gruppensuchfilter : Der Parameter für die Suche nach einem Benutzer innerhalb einer Gruppe, die einer Rolle in MVE entspricht. Nur die Muster  {0}  und  {1}  können verwendet werden. Bei Verwendung von  {0}  sucht MVE nach dem DN des LDAP-Benutzers. Bei Verwendung von  {1}  sucht MVE nach dem Anmeldenamen des MVE-Benutzers. Gruppenrollenattribut : Geben Sie das LDAP-Attribut für den vollständigen Namen der Gruppe ein. Ein LDAP-Attribut hat eine bestimmte Bedeutung und definiert eine Zuordnung zwischen dem Attribut und einem Feldnamen. Das LDAP-Attribut  cn  ist beispielsweise dem Feld  Vollständiger Name  zugeordnet. Das LDAP-Attribut  commonname  ist auch dem Feld  Vollständiger Name  zugeordnet. Im Allgemeinen sollte dieses Attribut auf dem Standardwert  cn  belassen werden. Benutzerbasisobjekt und gesamten SubTree durchsuchen : Das System durchsucht alle Knoten unter der Gruppensuchbasis. Geben Sie im Abschnitt  Zuordnung von LDAP-Gruppen und MVE-Rollen  die Namen der LDAP-Gruppen ein, die den MVE-Rollen entsprechen. Weitere Informationen finden Sie unter  . Sie können eine LDAP-Gruppe mehreren MVE-Rollen zuweisen. Sie können auch mehr als eine LDAP-Gruppe in ein Rollenfeld eingeben, indem Sie das Senkrechtstrich-Zeichen ( | ) verwenden, um mehrere Gruppen voneinander zu trennen. Um beispielsweise die Gruppen  admin  und  assets  in die  Admin -Rolle einzuschließen, geben Sie  admin|assets  in das Rollenfeld  LDAP-Gruppen für Admin  ein. Wenn Sie nur eine  Admin -Rolle und keine anderen MVE-Rollen verwenden möchten, lassen Sie die Felder leer. Klicken Sie auf  Änderungen speichern . LDAP-Server Authentifizierung aktivieren Aktivieren der LDAP-Serverauthentifizierung"},{"UUID":"813b68e6-be5a-4286-bed1-69795b98e4cf","title":"Einrichten des Benutzerzugriffs","link":"installing-ldap-server-certificates-topic.html","desc":"Installieren von LDAP-Serverzertifikaten Um eine","descFull":"Installieren von LDAP-Serverzertifikaten Um eine verschlüsselte Kommunikation zwischen dem MVE-Server und dem LDAP-Server einzurichten, muss MVE dem LDAP-Serverzertifikat vertrauen. Wenn MVE in der MVE-Architektur eine Authentifizierung mit einem LDAP-Server durchführt, ist MVE der Client und der LDAP-Server ist der Peer. Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  LDAP , und konfigurieren Sie dann die LDAP-Einstellungen. Weitere Informationen finden Sie unter  . Klicken Sie auf  LDAP testen . Geben Sie einen gültigen LDAP-Benutzernamen mit Passwort ein, und klicken Sie dann auf  Test starten . Überprüfen Sie das Zertifikat auf seine Gültigkeit, und akzeptieren Sie es dann. Installieren von LDAP-Serverzertifikaten LDAP-Serverzertifikate Einsetzen des"},{"UUID":"8438cc99-857c-4d5e-aabb-82d3329cb2b1","title":"Erkennen von Druckern","link":"creating-discovery-profile-topic.html","desc":"Erstellen eines Suchprofils Verwenden Sie","descFull":"Erstellen eines Suchprofils Verwenden Sie ein Suchprofil zum Suchen nach Druckern in Ihrem Netzwerk, und fügen Sie diese zum System hinzu. Führen Sie in einem Suchprofil einen der folgenden Schritte aus, um eine Liste von IP-Adressen oder Hostnamen ein- oder auszuschließen: Einträge einzeln hinzufügen Importieren von Einträgen mithilfe einer TXT- oder CSV-Datei Sie können einem kompatiblen Druckermodell auch automatisch eine Konfiguration zuweisen und diese durchsetzen. Eine Konfiguration muss Printer Settings, Anwendungen, Lizenzen, Firmware und CA-Zertifikate enthalten, die den Druckern bereitgestellt werden können. Klicken Sie im Menü  Drucker  auf  Suchprofile Erstellen . Geben Sie im Abschnitt  Allgemein  einen eindeutigen Namen für das Suchprofil und seine Beschreibung ein, und konfigurieren Sie anschließend Folgendes: Zeitsperre : So lange wartet das System auf eine Druckerantwort. Erneute Versuche : So oft soll das System versuchen, mit einem Drucker zu kommunizieren. Gefundene Drucker automatisch verwalten : Neu gefundene Drucker werden automatisch auf den Staus \"Verwaltet\" gesetzt, und der Status \"Neu\" wird während der Suche übersprungen. Führen Sie im Abschnitt  Adressen  eine der folgenden Aktionen durch: Adressen hinzufügen Wählen Sie  Einschließen  oder  Ausschließen  aus. Geben Sie die IP-Adresse, den Hostnamen, das Subnetz oder den IP-Adressbereich ein. Fügen Sie nur jeweils einen Eintrag hinzu. Geben Sie die Adressen mithilfe der folgenden Formate ein: 10.195.10.1  (einzelne IPv4-Adresse) meindrucker.beispiel.com  (einzelner Hostname) 10.195.10.3–10.195.10.255  (IPv4-Adressbereich) 10.195.*.*  (Platzhalter) 10.195.10.1/22  (IPv4-Classless-Inter‑Domain-Routing- oder CIDR-Schreibweise) 2001:db8:0:0:0:0:2:1  (vollständige IPv6-Adresse) 2001:db8::2:1  (gekürzte IPv6-Adresse) Wenn separate Suchprofile für die IPv6- und die IPv4-Adresse für den gleichen Drucker erstellt werden, wird die zuletzt gefundene Adresse angezeigt. Wird beispielsweise für einen Drucker erst eine IPv6-Adresse und anschließend noch eine IPv4-Adresse gefunden, wird nur die IPv4-Adresse in der Druckerliste angezeigt. Klicken Sie auf  Hinzufügen . Importieren der Adressen Klicken Sie auf  Importieren . Wählen Sie aus, ob IP-Adressen während der Suche ein- oder ausgeschlossen werden sollen. Navigieren Sie zu der Textdatei, die eine Liste der Adressen enthält. Jede Adresse muss in einer separaten Zeile eingetragen werden. Beispiel-Textdatei 10.195.10.1\nmyprinter.example.com\n10.195.10.3-10.195.10.255\n10.195.*.*\n10.195.10.1/22\n2001:db8:0:0:0:0:2:1\n2001:db8::2:1 Klicken Sie auf  Importieren . Wählen Sie im Abschnitt  SNMP  die Option  Version 1 ,  Version 2c  oder  Version 3  aus, und stellen Sie anschließend die Zugriffsberechtigungen ein. Um Drucker zu identifizieren, die SNMP-Version 3 verwenden, erstellen Sie einen Benutzernamen und ein Benutzerkennwort im Embedded Web Server des Druckers, und starten Sie anschließend den Drucker neu. Wenn keine Verbindung hergestellt werden kann, suchen Sie erneut nach den Druckern. Weitere Informationen finden Sie im  Embedded Web Server Administratorhandbuch . Falls erforderlich, wählen Sie im Abschnitt  Anmeldeinformationen eingeben  die von den Druckern verwendete Authentifizierungsmethode aus, und geben Sie anschließend die Anmeldeinformationen ein. Mit dieser Funktion können Sie während der Suche die Kommunikation mit gesicherten Druckern herstellen. Die korrekten Anmeldeinformationen müssen angegeben werden, um Aufgaben auf den gesicherten Druckern auszuführen, zum Beispiel Prüfung, Statusaktualisierung und Firmware-Aktualisierung. Bei Bedarf können Sie einem Druckermodell über den Abschnitt  Konfigurationen zuweisen  eine Konfiguration zuweisen. Informationen zum Erstellen einer Konfiguration finden Sie unter  . Bei Bedarf können Sie einem Druckermodell über den Abschnitt  Schlüsselwörter zuweisen  ein Schlüsselwort zuweisen. Informationen zum Zuweisen von Schlüsselwörtern zu Druckern finden Sie unter  . Alle Drucker, die über dieses Profil erkannt werden, werden mit den neuen Schlüsselwörtern zugewiesen. Die neuen Schlüsselwörter werden der bestehenden Liste von Stichwörtern hinzugefügt, die bereits einem Drucker zugewiesen sind. Klicken Sie auf  Profil speichern  oder auf  Profil speichern und ausführen . Eine Suche kann so geplant werden, dass sie in regelmäßigen Abständen stattfindet. Weitere Informationen finden Sie unter  . Erstellen eines Suchprofils Suchprofil Erstellen"},{"UUID":"2b1b57a1-5c23-44cd-b93d-5591485e3709","title":"Erkennen von Druckern","link":"managing-discovery-profiles-topic.html","desc":"Verwalten von Suchprofilen Klicken Sie","descFull":"Verwalten von Suchprofilen Klicken Sie im Menü \"Drucker\" auf  Suchprofile . Gehen Sie wie folgt vor: Bearbeiten eines Profils Wählen Sie ein Profil aus, und klicken Sie dann auf  Bearbeiten . Konfigurieren Sie die Einstellungen. Klicken Sie auf  Profil speichern  oder  Profil speichern und ausführen . Profil kopieren Wählen Sie ein Profil aus, und klicken Sie dann auf  Kopieren . Konfigurieren Sie die Einstellungen. Fügen Sie die IP-Adressen hinzu. Weitere Informationen finden Sie unter  . Klicken Sie auf  Profil speichern  oder  Profil speichern und ausführen . Löschen eines Profils Wählen Sie ein oder mehrere Profile aus. Klicken Sie auf  Löschen , und bestätigen Sie dann das Löschen. Profil ausführen Wählen Sie ein oder mehrere Profile aus. Klicken Sie auf  Ausführen . Überprüfen Sie den Suchstatus über das Menü \"Aufgaben\". Verwalten von Suchprofilen Suchprofile Verwalten Bearbeiten von Suchprofilen Löschen von Suchprofilen Kopieren von Suchprofil Ausführen von Suchprofilen Suchprofile Bearbeiten Suchprofile Löschen Suchprofile Kopieren Suchprofile ausführen"},{"UUID":"b7057102-0f56-4da1-87bd-e869db8992e7","title":"Erkennen von Druckern","link":"sample-scenario-discovering-printers-topic.html","desc":"Beispielszenario: Erkennen von Druckern Firma","descFull":"Beispielszenario: Erkennen von Druckern Firma ABC ist ein großes Fertigungsunternehmen, das in einem neunstöckigen Gebäude residiert. Das Unternehmen hat gerade 30 neue Lexmark Drucker gekauft, die auf die neun Stockwerke verteilt sind. Als IT-Mitarbeiter müssen Sie diese neuen Drucker zu MVE hinzufügen. Die Drucker sind bereits mit dem Netzwerk verbunden, aber Sie kennen nicht alle IP-Adressen. Sie möchten die folgenden neuen Drucker in der Buchhaltung sichern. 10.194.55.60 10.194.56.77 10.194.55.71 10.194.63.27 10.194.63.10 Beispielimplementierung Erstellen Sie ein Suchprofil für die Drucker in der Buchhaltung. Fügen Sie die fünf IP-Adressen hinzu. Erstellen Sie eine Konfiguration, die die angegebenen Drucker sichert. Nehmen Sie die Konfigurationen in das Suchprofil auf. Speichern Sie das Profil, und führen Sie es aus. Erstellen Sie ein weiteres Suchprofil für die übrigen Drucker. Fügen Sie die IP-Adressen mit einem Platzhalter ein. Verwenden Sie Folgendes:  10.194.*.* Schließen Sie die fünf Drucker-IP-Adressen in der Buchhaltung aus. Speichern Sie, und führen Sie dann das Profil aus. Nach Druckern suchen Drucker suchen"},{"UUID":"d8c4abcd-67a1-488c-ad60-7cdd4827ee79","title":"Verwalten des Sicherheits-Dashboards","link":"overview-security-dashboard-topic.html","desc":"Übersicht Im Sicherheits-Dashboard können Sie","descFull":"Übersicht Im Sicherheits-Dashboard können Sie den Zustand der Sicherheitseinstellungen des Geräts anzeigen. Es ist eine visuelle Darstellung verschiedener Sicherheitseinstellungen, wie Ports, Protokolle, Festplattenverschlüsselungsstatus, Geräteadministratorkonten und Standardzertifikatstatus. Es bietet einen Überblick über die Sicherheitslage Ihrer Flotte, sodass Administratoren die Einstellungen identifizieren und korrigieren können, die nicht den Vorgaben entsprechen. Überblick Sicherheits-Dashboard"},{"UUID":"df5c5fc3-0897-4f8b-9092-19dbbcac1575","title":"Verwalten des Sicherheits-Dashboards","link":"accessing-dashboard-topic.html","desc":"Zugriff auf das Sicherheits-Dashboard Klicken","descFull":"Zugriff auf das Sicherheits-Dashboard Klicken Sie im MVE-Webportal auf  Dashboard . Das Sicherheits-Dashboard ist die Standard-Landing Page für Admin-Benutzer. Klicken Sie auf eine der folgenden Optionen: Geräte-Sicherheitsinformationen Gerätekonformitätsprüfung Dashboard Zugreifen"},{"UUID":"048fccd8-75be-4ae2-a9e1-bc7bd1824438","title":"Verwalten des Sicherheits-Dashboards","link":"managing-device-security-information-topic.html","desc":"Verwalten der  Geräte-Sicherheitsinformationen Dieses","descFull":"Verwalten der  Geräte-Sicherheitsinformationen Dieses Widget fasst die Sicherheitsansicht der Flotte zusammen. Klicken Sie auf einen beliebigen Balken des Diagramms, um das Fenster  Geräte-Sicherheitsinformationen  zu öffnen. Bewegen Sie den Mauszeiger über die Balken, um die folgenden Details anzuzeigen: Anschlussnummer Anzahl der zugeordneten Drucker Gibt an, ob die Druckereinstellungen geöffnet/aktiviert sind Klicken Sie auf  Drucken , um ein druckbares Format der Detailansicht anzuzeigen. Das Fenster „Geräte-Sicherheitsinformationen“ bietet dem Benutzer eine Funktion zur genauen Suche an. Durch Klicken auf ein beliebiges Balkenelement im Diagramm kann der Benutzer zu einer gefilterten Ansicht der Druckerlistenseite navigieren. Weitere Informationen finden Sie unter  . Geräte-Sicherheitsinformationen Verwalten"},{"UUID":"d8d437e6-9626-4589-b44f-7cdd6d94030d","title":"Verwalten des Sicherheits-Dashboards","link":"managing-device-conformance-check-topic.html","desc":"Verwalten der  Gerätekonformitätsprüfung Dieses","descFull":"Verwalten der  Gerätekonformitätsprüfung Dieses Widget fasst die detaillierte Ansicht der Übereinstimmungsprüfung der Flotte zusammen. Klicken Sie auf einen beliebigen Abschnitt des Kreisdiagramms, um das Fenster  Gerätekonformitätsprüfung  aufzurufen. Wenden Sie im linken Fensterbereich den Filter  Zeitraum  an. Der Standardbereich beträgt 7 Tage. Klicken Sie auf  Drucken , um ein druckbares Format der Detailansicht anzuzeigen. Das Fenster Gerätekonformitätsprüfung bietet dem Benutzer eine Funktion zur genauen Suche. Durch Klicken auf einen beliebigen Abschnitt des Kreisdiagramms kann der Benutzer zu einer gefilterten Ansicht der Druckerlistenseite navigieren. Weitere Informationen finden Sie unter  . Gerätekonformitätsprüfung Verwalten"},{"UUID":"2d5c7d5b-9778-4988-b173-8f6df967351c","title":"Anzeigen von Druckern","link":"viewing-printer-list-topic.html","desc":"Anzeigen der Druckerliste Die Druckerlistenseite","descFull":"Anzeigen der Druckerliste Die Druckerlistenseite ist die standardmäßige Startseite beim Zugriff auf MVE. Die Tabelle zeigt die Liste der Drucker, die in MVE hinzugefügt werden. Klicken Sie im Menü  Drucker  auf  Druckerliste . Gehen Sie auf der Seite  Druckerliste  wie folgt vor: Um nach bestimmten Druckern zu suchen, führen Sie einen der folgenden Schritte aus: Suchen Sie mithilfe des Suchfeldes nach einer IP-Adresse, einem Hostnamen, einem Systemnamen, oder einer Seriennummer. Ändern Sie die Druckerlistenansicht. Weitere Informationen finden Sie unter  . Bei Verwendung des Suchfeldes sucht die Anwendung nach allen Druckern im System. Die ausgewählten Filter und gespeicherten Suchvorgänge werden ignoriert. Bei der Ausführung eines gespeicherten Suchvorgangs werden die darin angegebenen Kriterien verwendet. Die ausgewählten Filter und die im Suchfeld eingegebene IP-Adresse bzw. der Host-Name werden ignoriert. Anhand der Filter können die aktuellen Suchergebnisse eingegrenzt werden. Verwenden Sie die Filter. Führen Sie einen gespeicherten Suchvorgang aus. Weitere Informationen finden Sie unter  . Klicken Sie zum Sortieren der Drucker in der Druckerlistentabelle auf eine beliebige Spaltenüberschrift. Die Drucker werden gemäß der ausgewählten Spaltenüberschrift sortiert. Um sich weitere Informationen zu den Druckern anzeigen zu lassen, ändern Sie die Größe der Spalten. Platzieren Sie den Cursor auf den vertikalen Rand der Spaltenüberschrift, und ziehen Sie den Rand nach links oder rechts. Anzeigen der Druckerliste Druckerliste Anzeigen"},{"UUID":"0a8f463b-8d59-4c79-9340-f8642bcd7cb8","title":"Anzeigen von Druckern","link":"viewing-device-information-topic.html","desc":"Anzeigen der Druckerinformationen Um eine","descFull":"Anzeigen der Druckerinformationen Um eine vollständige Liste mit Informationen anzuzeigen, stellen Sie sicher, dass am Drucker eine Geräteprüfung durchgeführt wurde. Weitere Informationen finden Sie unter  . Klicken Sie im Menü  Drucker  auf  Druckerliste . Klicken Sie auf die IP-Adresse des Druckers. Beachten Sie folgende Informationen: Status : Der Druckerstatus. Verbrauchsmaterialien : Die Einzelheiten des Verbrauchsmaterials und der verbleibende Vorrat in Prozent. Identifikation : Die Informationen zur Druckernetzwerk-Identifikation. Die Zeitzoneninformation ist nur auf bestimmten Druckermodellen verfügbar. Datumsangaben : Das Datum, an dem der Drucker zum System hinzugefügt wurde, das Suchdatum und das letzte Prüfdatum. Firmware : Die Eigenschaften und Code-Version der Drucker-Firmware. Funktionen : Die Druckerfunktionen. Speicheroptionen : Die Festplattengröße und freier Speicherplatz im Benutzer-Flash. Einzugsoptionen : Die Einstellungen für die verfügbaren Fächer. Ausgabeoptionen : Die Einstellungen für die verfügbaren Ablagen. eSF-Anwendungen : Angaben über die auf dem Drucker installierten eSF-Anwendungen (Embedded Solutions Framework). Druckerstatistiken : Die spezifischen Werte für die einzelnen Druckereigenschaften. Details ändern : Die Informationen über Änderungen am Drucker. Diese Informationen sind nur für Drucker verfügbar, für die der Zustand \"Verwaltet (geändert)\" festgelegt wurde. Weitere Informationen finden Sie unter  . Druckeranmeldeinformationen : Die Anmeldeinformationen, die in der dem Drucker zugewiesenen Konfiguration verwendet wurden. Druckerzertifikat : Die Eigenschaften der folgenden Druckerzertifikate. Standard HTTPS 802.1x IPSec Diese Informationen sind nur bei manchen Druckermodellen verfügbar. Der Gültigkeitsstatus  Läuft bald ab  gibt das Ablaufdatum an, das im Abschnitt  Zertifizierungsstelle  unter  Systemkonfiguration  festgelegt wurde. Konfigurationseigenschaften : Die Eigenschaften der Konfiguration, die dem Drucker zugewiesen wurde. Aktive Warnungen : Die Druckerwarnungen, die zu löschen sind. Zugewiesene Ereignisse : Die dem Drucker zugewiesenen Ereignisse. Anzeigen der Druckerinformationen Druckerinformationen Anzeigen"},{"UUID":"c4b13fd8-1538-4a3f-bef0-9b2185aecd4b","title":"Anzeigen von Druckern","link":"exporting-data-topic.html","desc":"Exportieren von Druckerdaten MVE ermöglicht","descFull":"Exportieren von Druckerdaten MVE ermöglicht Ihnen das Exportieren der Druckerinformationen, die in Ihrer aktuellen Ansicht verfügbar sind. Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Drucker Daten exportieren . Die exportierten Daten werden in einer CSV-Datei gespeichert. Das Exportieren von Daten kann so geplant werden, dass es in regelmäßigen Abständen stattfindet. Weitere Informationen finden Sie unter  . Exportieren von Druckerdaten Druckerdaten Exportieren"},{"UUID":"cf840e8d-b544-4b50-b796-3743bbdaa20a","title":"Anzeigen von Druckern","link":"managing-views-topic.html","desc":"Verwalten von Ansichten Die Funktion","descFull":"Verwalten von Ansichten Die Funktion  Ansichten  ermöglicht das Anpassen der Informationen, die auf der Seite \"Druckerliste\" angezeigt wird. Klicken Sie im Menü  Drucker  auf  Ansichten . Wählen Sie eine der folgenden Möglichkeiten: Erstellen einer Ansicht Klicken Sie auf  Erstellen . Geben Sie einen eindeutigen Namen für die Ansicht und ihre Beschreibung ein. Wählen Sie im Menü  Spalte 1  im Abschnitt  Spalten anzeigen  die Bezeichner-Spalte aus. Wählen Sie im Abschnitt  Mögliche Spalten  die Informationen aus, die Sie als Spalte anzeigen möchten, und klicken Sie dann auf  > . Funktionen : Zeigt an, ob die ausgewählten Funktionen auf dem Drucker unterstützt werden. Zertifikat : Zeigt das Erstellungsdatum des Druckerzertifikats, den Anmeldestatus, das Ablaufdatum, das Verlängerungsdatum, die Überarbeitungsnummer, das Zertifikatsthema, die Gültigkeit und den Signaturstatus an. Konfigurationsinformationen : Zeigt konfigurationsrelevante Druckerinformationen wie Übereinstimmung, Konfigurationsname und Status an. Datumsangaben : Zeigt die letzte Prüfung, die letzte Übereinstimmungsprüfung, die letzte Suche und das Datum an, an dem der Drucker dem System hinzugefügt wurde. Ereignisse : Zeigt ereignisrelevante Druckerinformationen an. Firmware : Zeigt Firmware-relevante Informationen wie die Firmware-Version an. Identifikation : Zeigt Informationen über den Drucker wie IP-Adresse, Hostname und Seriennummer an. Einzugsoptionen : Zeigt Informationen zu den Zuführungsoptionen wie Fachgröße und Medienart an. Optionen : Zeigt Informationen über die Druckeroptionen wie Festplatte und Flash-Laufwerk an. Druckerstatistik : Zeigt Informationen über die Druckerverwendung an, beispielsweise die Anzahl der gedruckten oder gescannten Seiten und die Gesamtanzahl der gefaxten Aufträge. Lösungen : Zeigt die auf dem Drucker installierten eSF-Anwendungen und deren Versionsnummern an. Status : Zeigt den Status von Drucker und Verbrauchsmaterialien an. Verbrauchsmaterialien : Zeigt Informationen zu Verbrauchsmaterialien an. Druckeranschlüsse : Zeigt Informationen zu Anschlüssen an. Die Option  Unbekannt  im Anschlusswert bedeutet, dass entweder der Anschluss nicht auf dem Drucker vorhanden ist oder MVE den Anschluss nicht abrufen kann. Druckersicherheitsoptionen : Zeigt TLS- und Cipher-Informationen an. Klicken Sie auf  Ansicht erstellen . Bearbeiten einer Ansicht Wählen Sie eine Ansicht aus. Klicken Sie auf  Bearbeiten , und bearbeiten Sie dann die Einstellungen. Klicken Sie auf  Änderungen speichern . Kopieren einer Ansicht Wählen Sie eine Ansicht aus. Klicken Sie auf  Kopieren , und konfigurieren Sie dann die Einstellungen. Klicken Sie auf  Ansicht erstellen . Löschen von Ansichten Wählen Sie eine oder mehrere Ansichten aus. Klicken Sie auf  Löschen , und bestätigen Sie dann das Löschen. Festlegen einer Standardansicht Wählen Sie eine Ansicht aus. Klicken Sie auf  Als Standard festlegen . Die folgenden Ansichten wurden vom System erzeugt und können weder bearbeitet noch gelöscht werden: Konfiguration Druckerliste Ereignis Sicherheit Service Desk Standard Verwalten von Ansichten Bearbeiten von Ansichten Kopieren von Ansichten Löschen von Ansichten Einrichten einer Standardansicht Ansichten Verwalten Ansichten Bearbeiten Ansichten Kopieren Ansichten löschen"},{"UUID":"2af9d824-693d-4677-b499-c9300fdc1e33","title":"Anzeigen von Druckern","link":"changing-printer-listing-view-topic.html","desc":"Druckerlistenansicht ändern Weitere Informationen finden","descFull":"Druckerlistenansicht ändern Weitere Informationen finden Sie unter  . Klicken Sie im Menü \"Drucker\" auf  Druckerliste . Klicken Sie auf  Ansichten , und wählen Sie anschließend einen Typ aus. Ändern der Anzeige \"Druckerliste\" Druckerlistenansicht Ändern"},{"UUID":"50ce79b4-31bc-476d-856a-40756758ae55","title":"Anzeigen von Druckern","link":"filtering-printers-using-search-bar-topic.html","desc":"Filtern von Druckern über die","descFull":"Filtern von Druckern über die Suchleiste Beachten Sie folgende Hinweise, wenn Sie über die Suchleiste nach Druckern suchen. Für die Suche nach einer IP-Adresse, bitte die komplette IP-Adresse oder den IP-Adressbereich angeben. Beispiel: 10.195.10.1 10.195.10.3-10.195.10.255 10.195.*.* 2001:db8:0:0:0:0:2:1 Wenn der Suchstring keine volle IP-Adresse ist, werden die Drucker entsprechend ihrer Hostnamen, Systemnamen, oder Seriennummer gesucht. Der Unterstrich (  _  ) kann als Platzhalterzeichen verwendet werden. Filtern von Druckern über die Suchleiste Suchleiste Filtern von Druckern Drucker Filtern"},{"UUID":"42880440-da4f-4683-a013-120d82ea6345","title":"Anzeigen von Druckern","link":"managing-keywords-topic.html","desc":"Verwalten von Schlüsselwörtern Mit Schlüsselwörtern","descFull":"Verwalten von Schlüsselwörtern Mit Schlüsselwörtern können Sie benutzerdefinierte Tags erstellen und sie Druckern zuweisen. Klicken Sie im Menü  Drucker  auf  Schlüsselwörter . Führen Sie einen der folgenden Schritte aus: Hinzufügen, Bearbeiten oder Löschen einer Kategorie. In Kategorien werden Schlüsselwörter zu Gruppen zusammengefasst. Hinzufügen, Bearbeiten oder Löschen eines Schlüsselworts. Informationen zum Zuweisen von Schlüsselwörtern zu Druckern finden Sie unter  . Verwalten von Schlüsselwörtern Schlüsselwörter Verwalten Erstellen von Schlüsselwörtern Bearbeiten von Schlüsselwörtern Löschen von Schlüsselwörtern Schlüsselwörter Erstellen Schlüsselwörter Bearbeiten Schlüsselwörter Löschen"},{"UUID":"50794e13-9448-4b59-b8f9-978097328a2d","title":"Verwenden gespeicherter Suchvorgänge","link":"understanding-device-life-cycle-states-topic.html","desc":"Informationen zu Lebenszyklus-Statusarten von Druckern","descFull":"Informationen zu Lebenszyklus-Statusarten von Druckern Vom System erzeugte gespeicherte Suchvorgänge zeigen die Drucker in folgenden Lebenszyklus-Statusarten: Alle Drucker : Alle Drucker im System Verwaltete Drucker : Angezeigte Drucker können eine der folgenden Statusarten aufweisen: Verwaltet (normal) Verwaltet (geändert) Verwaltet (fehlt) Verwaltet (gefunden) Verwaltete (geänderte) Drucker : Drucker im System, deren Eigenschaften seit der letzten Überprüfung geändert wurden. Kennzeichnung Hostname Kontaktname Kontaktstandort Speichergröße Beidseitig Verbrauchsmaterial (ohne Ebenen) Einzugsoptionen Ausgabeoptionen eSF-Anwendungen Standardruckerzertifikat Verwaltete (gefundene) Drucker : Drucker, die als fehlend gemeldet wurden, jetzt aber gefunden wurden. Verwaltete (fehlende) Drucker : Drucker, mit denen das System nicht kommunizieren konnte. Verwaltete (normale) Drucker : Drucker im System, deren Eigenschaften seit der letzten Überprüfung unverändert sind. Neue Drucker : Geräte, die neu gefunden wurden und nicht automatisch auf den Staus \"Verwaltet\" gesetzt wurden. Stillgelegte Drucker : Drucker, die nicht mehr im System aktiv sind. Nicht verwaltete Drucker : Drucker, die für im System ausgeführte Aktivitäten als ausgeschlossen gekennzeichnet wurden. Anfangsstatus Endstatus Übergang 1  Die Einstellung \" Gefundene Drucker automatisch verwalten \" ist im Suchprofil aktiviert. 2  Die Einstellung \" Gefundene Drucker automatisch verwalten \" ist im Suchprofil deaktiviert. Starten Normal Gefunden. 1 Starten Neu Gefunden. 2 Beliebig Normal, Nicht verwaltet oder Stillgelegt Manuell (\"Fehlt\" ändert sich nicht in \"Normal\"). Stillgelegt Normal Gefunden. 1 Stillgelegt Neu Gefunden. 2 Normal, Fehlend oder Gefunden Geändert Neue Adresse, wenn gefunden. Normal Geändert Überprüfungseigenschaften stimmen nicht mit Datenbankeigenschaften überein. Normal, Geändert oder Gefunden Fehlt Nicht gefunden bei Prüfung oder Aktualisierungsstatus. Geändert Normal Überprüfungseigenschaften stimmen mit Datenbankeigenschaften überein. Fehlt Gefunden Gefunden, Prüfung oder Aktualisierungsstatus. Gefunden Normal Gefunden, Prüfung oder Aktualisierungsstatus. Lebenszyklus-Statusarten von Druckern Bedeutung Informationen zu Lebenszyklus-Statusarten von Druckern"},{"UUID":"77c169f1-c551-457d-84b1-40c886062f12","title":"Verwenden gespeicherter Suchvorgänge","link":"understanding-device-life-cycle-states-topic.html","desc":"Ausführen eines gespeicherten Suchvorgangs Eine","descFull":"Ausführen eines gespeicherten Suchvorgangs Eine gespeicherte Suche ist ein gespeicherter Parametersatz, der die neuesten Druckerinformationen zurückgibt, die den Parametern entsprechen. Sie können eine benutzerdefinierte gespeicherte Suche erstellen und ausführen oder die vom System erzeugten und gespeicherten Standardsuchvorgänge ausführen. Vom System erzeugte gespeicherte Suchvorgänge zeigen die Drucker in folgenden Lebenszyklus-Statusarten: Weitere Informationen finden Sie unter  . Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie im Drop-down-Menü einen gespeicherten Suchvorgang aus. Ausführen eines gespeicherten Suchvorgangs Gespeicherte Suchvorgänge Ausführen"},{"UUID":"b5c356da-f48d-477b-b0cb-175ebe9b933b","title":"Verwenden gespeicherter Suchvorgänge","link":"understanding-device-life-cycle-states-topic.html","desc":"Erstellen eines gespeicherten Suchvorgangs Verwenden","descFull":"Erstellen eines gespeicherten Suchvorgangs Verwenden von Filtern Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie im linken Bereich der Seite die Filter aus. Die ausgewählten Filter werden oberhalb der Suchergebnis-Kopfzeile aufgeführt. Klicken Sie auf  Speichern , und geben Sie dann einen eindeutigen Namen für den gespeicherten Suchvorgang und seine Beschreibung ein. Klicken Sie auf  Gespeicherten Suchvorgang erstellen . Verwenden der Seite \"Gespeicherter Suchvorgang\" Klicken Sie im Menü  Drucker  auf  Gespeicherte Suchvorgänge Erstellen . Geben Sie im Abschnitt  Allgemein  einen eindeutigen Namen für den gespeicherten Suchvorgang und seine Beschreibung ein. Geben Sie im Abschnitt  Regeln und Regelgruppen  im Menü  Übereinstimmung  an, ob die Suchergebnisse allen oder beliebigen Regeln entsprechen müssen. Führen Sie einen der folgenden Schritte aus: Regel hinzufügen Klicken Sie auf  Regel hinzufügen . Legen Sie den Parameter, Vorgang und Wert für Ihre Suchregel fest. Weitere Informationen finden Sie unter  . Regelgruppe hinzufügen Eine Regelgruppe kann eine Kombination von Regeln enthalten. Wenn das Menü  Übereinstimmung  auf  BELIEBIGE Regeln und Regelgruppen  eingestellt ist, sucht das System nach Druckern, die beliebigen Regeln in der Regelgruppe entsprechen. Wenn das Menü  Übereinstimmung  auf  ALLE Regeln und Regelgruppen  eingestellt ist, sucht das System nach Druckern, die allen Regeln in der Regelgruppe entsprechen. Klicken Sie auf  Regelgruppe hinzufügen . Legen Sie den Parameter, Vorgang und Wert für Ihre Suchregel fest. Weitere Informationen finden Sie unter  . Klicken Sie auf  Regel hinzufügen , um eine weitere Regel hinzuzufügen. Klicken Sie auf  Gespeicherten Suchvorgang erstellen  oder  Gespeicherten Suchvorgang erstellen und ausführen . Erstellen eines benutzerdefinierten gespeicherten Suchvorgangs Benutzerdefinierter gespeicherter Suchvorgang Erstellen"},{"UUID":"02144ebc-31ed-4525-abed-fa47a03fde54","title":"Verwenden gespeicherter Suchvorgänge","link":"understanding-device-life-cycle-states-topic.html","desc":"Informationen zu Einstellungen für Suchkriterien","descFull":"Informationen zu Einstellungen für Suchkriterien Suchen Sie nach Druckern mittels einem oder mehreren der folgenden Parameter: Parameter Beschreibung Gerätenummer Der Wert der Einstellung \"Asset-Tag\" auf dem Drucker. Zertifikatserstellungsdatum 1 Ruft das Datum ab, an dem das Zertifikat erstellt wurde. Zertifikatsanmeldestatus 1 Der Anmeldestatus des Zertifikats. Ablaufdatum des Zertifikats 1 Das Datum, an dem das Zertifikat abläuft. Verlängerungsdatum des Zertifikats 1 Das Datum, an dem das Zertifikat erneuert wird. Zertifikatsprüfnummer 1 Die Prüfnummer des Zertifikats. Zertifikatssignaturstatus 1 Der Status des Zertifikats. Zertifikatsgültigkeitsstatus 1 Die Gültigkeit des Zertifikats. Der Status  Läuft bald ab  zeigt an, dass das Zertifikat innerhalb von 30 Tagen abläuft. Unterstützung des Farbdrucks Der Drucker druckt in Farbe oder Schwarzweiß. Konfiguration Der dem Drucker zugewiesene Konfigurationsname. Konfigurationskonformität Der Konformitätsstatus des Druckers in Hinblick auf die zugewiesene Konfiguration. Kontaktstandort Der Wert der Einstellung \"Kontaktstandort\" auf dem Drucker. Kontaktname Der Wert der Einstellung \"Kontaktname\" auf dem Drucker. Kopieren Der Drucker unterstützt die Kopierfunktion. Datum: Zu System hinzugefügt Das Datum, an dem der Drucker zum System hinzugefügt wurde. Datum: Zuletzt überprüft Das Datum, an dem der Drucker zuletzt überprüft wurde. Datum: Letzte Konformitätsprüfung Das Datum, an dem die Konformität der Druckerkonfiguration zuletzt überprüft wurde. Datum: Zuletzt gesucht Das Datum, an dem der Drucker zuletzt erkannt wurde. Festplattenverschlüsselung Der Drucker ist für Festplattenverschlüsselung konfiguriert. Löschen der Festplatte Der Drucker ist für das Löschen der Festplatte konfiguriert. Duplexmodus Der Drucker unterstützt zweiseitigen Druck. eSF-Funktion Der Drucker unterstützt das Verwalten von eSF-Anwendungen. eSF-Informationen Die auf dem Drucker installierten Informationen über die eSF-Anwendung, wie beispielsweise Name, Status und Version. Ereignisname Der Name der zugewiesenen Ereignisse. Faxname Der Wert der Einstellung \"Faxname\" auf dem Drucker. Faxnummer Der Wert der Einstellung \"Faxnummer\" auf dem Drucker. Fax-Empfang Der Drucker unterstützt den Fax-Empfang. Firmware-informationen Informationen zu der auf dem Drucker installierten Firmware. Name : Der Name der Firmware. Beispiel:  Base  oder  Kernel . Version : Die Version der Drucker-Firmware. Hostname Der Hostname des Druckers. IP-Adresse Die IP-Adresse des Druckers. Sie können in den letzten drei Oktetten ein Sternchen eingeben, um nach mehreren Einträgen zu suchen. Beispielsweise  123.123.123.* ,  123.123.*.* ,  123.*.*.* ,  2001:db8::2:1  und  2001:db8:0:0:0:0:2:1 . Schlüsselwort Die zugewiesenen Schlüsselwörter. Insgesamt gedruckte Seiten Der Wert der insgesamt gedruckten Seiten des Druckers. MAC-Adresse Die MAC-Adresse des Druckers. Wartungszähler Der Wert des Druckerwartungszählers. Hersteller Der Name des Druckerherstellers. Kennzeichnungstechnologie Die vom Drucker unterstützte Kennzeichnungstechnologie. Unterstützung der MFP-Funktion Beim Drucker handelt es sich um ein Multifunktionsgerät (MFP). Modell Der Name des Druckermodells. Modulare Seriennummer Die modulare Seriennummer. Druckerstatus Der Druckerstatus. Beispielsweise  Bereit ,  Papierstau ,  Fach 1 fehlt . Schweregrad Druckerstatus Der Wert des Druckerstatus mit dem höchsten Schweregrad. Beispielsweise  Unbekannt ,  Bereit ,  Warnung  oder  Fehler . Profil Der Drucker unterstützt Profile. Scan to E-mail Der Drucker unterstützt Scan to E-mail. Scan to Fax Der Drucker unterstützt Scan to Fax Scan to Fax Der Drucker unterstützt Scan to Fax Sicherer Kommunikationsstatus Der Gerätesicherheits- bzw. Authentifizierungsstatus. Seriennummer Die Seriennummer des Druckers. Zustand Der aktuelle Druckerstatus in der Datenbank. Verbrauchsmaterialstatus Der Verbrauchsmaterialstatus des Druckers. Schweregrad Verbrauchsmaterialstatus Der Wert des Druckerstatus mit dem höchsten Schweregrad für Verbrauchsmaterialien. Beispielsweise  Unbekannt ,  OK ,  Warnung  oder  Fehler . Systemname Der Systemname des Druckers. Zeitzone Die Zeitzone der Region, in der sich der Drucker befindet. TLI Der Wert der Einstellung \"TLI\" auf dem Drucker. 1 Zertifikatsparameter gelten für die folgenden Gerätezertifikate: Standard HTTPS 802.1x IPSec Verwenden Sie bei der Suche nach Druckern die folgenden Operatoren: Entspricht genau : Ein Parameter entspricht einem festgelegten Wert. Entspricht nicht : Ein Parameter entspricht nicht einem festgelegten Wert. Enthält : Ein Parameter enthält einen festgelegten Wert. Enthält nicht : Ein Parameter enthält einen festgelegten Wert nicht. Beginnt mit : Ein Parameter beginnt mit einem festgelegten Wert. Endet mit : Ein Parameter endet mit einem festgelegten Wert. Datum Älter als : Ein Parameter für die Suche nach Tagen vor den angegebenen Tagen. Innerhalb der letzten : Ein Parameter für die Suche innerhalb der vor dem heutigen Tag angegebenen Tage. Innerhalb der nächsten : Ein Parameter für die Suche innerhalb der nach dem heutigen Tag angegebenen Tage. Für die Suche nach Druckern, die Parameter mit leeren Werten haben, verwenden Sie  _EMPTY_OR_NULL_ . Wenn Sie beispielsweise nach Druckern suchen, bei denen  Faxname  leer ist, geben Sie im Feld  Wert  den Wert  _EMPTY_OR_NULL_  ein. Einstellungen für Suchkriterien Grundlagen Suchkriterien Parameter Suchkriterien Operatoren"},{"UUID":"6ed909cd-953f-4423-bf48-f8834946717a","title":"Verwenden gespeicherter Suchvorgänge","link":"understanding-device-life-cycle-states-topic.html","desc":"Verwalten von gespeicherten Suchvorgängen Klicken","descFull":"Verwalten von gespeicherten Suchvorgängen Klicken Sie im Menü \"Drucker\" auf  Gespeicherte Suchvorgänge . Gehen Sie wie folgt vor: Gespeicherte Suchvorgänge bearbeiten Wählen Sie einen gespeicherten Suchvorgang aus, und klicken Sie dann auf  Bearbeiten . Vom System generierte, gespeicherte Suchvorgänge können nicht bearbeitet werden. Weitere Informationen finden Sie unter  . Konfigurieren Sie die Einstellungen. Klicken Sie auf  Änderungen speichern  oder  Speichern und Ausführen . Gespeicherte Suchvorgänge kopieren Wählen Sie einen gespeicherten Suchvorgang aus, und klicken Sie dann auf  Kopieren . Konfigurieren Sie die Einstellungen. Klicken Sie auf  Gespeicherten Suchvorgang erstellen  oder  Gespeicherten Suchvorgang erstellen und ausführen . Gespeicherte Suchvorgänge löschen Wählen Sie mindestens einen gespeicherten Suchvorgang aus. Vom System generierte, gespeicherte Suchvorgänge können nicht gelöscht werden. Weitere Informationen finden Sie unter  . Klicken Sie auf  Löschen , und bestätigen Sie dann das Löschen. Verwalten von gespeicherten Suchvorgängen Gespeicherte Suchvorgänge Verwalten Bearbeiten von gespeicherten Suchvorgängen Kopieren von gespeicherten Suchvorgängen Löschen von gespeicherten Suchvorgängen Gespeicherte Suchvorgänge Bearbeiten Gespeicherte Suchvorgänge Kopieren Gespeicherte Suchvorgänge Löschen"},{"UUID":"e4495867-dedc-44e9-b8f3-f9d9cb5163ae","title":"Anzeigen von Druckern","link":"sample-scenario-monitor-fleet-topic.html","desc":"Beispielszenario: Überwachung der Tonerstände Ihrer","descFull":"Beispielszenario: Überwachung der Tonerstände Ihrer Flotte Als IT-Mitarbeiter von Unternehmen ABC müssen Sie die Druckerflotte organisieren, um sie einfach zu überwachen. Sie möchten den Tonerverbrauch der Drucker überwachen, um festzustellen, ob das Verbrauchsmaterial ausgetauscht werden muss. Beispielimplementierung Erstellen Sie einen gespeicherten Suchvorgang, der die Drucker abruft, für deren Verbrauchsmaterialien es Fehler oder Warnungen gibt. Beispielregel für Ihre gespeicherte Suche Parameter:  Schweregrad Verbrauchsmaterialstatus Vorgang:  Ist nicht Wert:  Verbrauchsmaterial OK Erstellen Sie eine Ansicht, die den Verbrauchsmaterialstatus, die Kapazität und den Verbrauchsstand für jeden Drucker anzeigt. Beispielspalten, die in der Verbrauchsmaterialansicht angezeigt werden Verbrauchsmaterialstatus Tonerkassette Schwarz, Kapazität Tonerkassette Schwarz, Verbrauchsstand Tonerkassette Cyan, Kapazität Tonerkassette Cyan, Verbrauchsstand Tonerkassette Magenta, Kapazität Tonerkassette Magenta, Verbrauchsstand Tonerkassette Gelb, Kapazität Tonerkassette Gelb, Verbrauchsstand Führen Sie die gespeicherte Suche unter Verwendung der Ansicht aus. Die in der Druckerlistenansicht angezeigten Informationen basieren auf der letzten Prüfung. Führen Sie eine Prüfung und eine Statusaktualisierung durch, um den aktuellen Druckerstatus abzurufen. Überwachen von Druckern"},{"UUID":"adb6df95-3689-4e34-950a-4000fc9aa9ad","title":"Sichern der Druckerkommunikation","link":"understanding-security-status-topic.html","desc":"Bedeutung des Druckersicherheitsstatus Während der","descFull":"Bedeutung des Druckersicherheitsstatus Während der Suche kann sich der Drucker in einem der folgenden Sicherheitsstatus befinden: Ungesichert : MVE benötigt keine Anmeldeinformationen, um mit dem Gerät zu kommunizieren. Gesichert : MVE benötigt Anmeldeinformationen, und diese wurden angegeben. Fehlende Anmeldeinformationen : MVE benötigt Anmeldeinformationen, diese wurden aber nicht angegeben. Ungültige Anmeldeinformationen : MVE benötigt Anmeldeinformationen, jedoch wurden falsche Anmeldeinformationen angegeben. Ein Drucker befindet sich im Status  Ungültige Anmeldeinformationen , wenn die Anmeldeinformationen während der Suche, Prüfung, Statusaktualisierung, Konformitätsprüfung oder Konfigurationsdurchsetzung ungültig sind. Der Drucker befindet sich nur dann im Status  Ungesichert , wenn während der Suche keine Anmeldeinformationen erforderlich sind. Erzwingen Sie zum Ändern des Status von  Ungesichert  in  Gesichert  eine gesicherte Konfiguration. Um einen Drucker aus dem Status  Fehlende Anmeldeinformationen  oder  Ungültige Anmeldeinformationen  zu verschieben, geben Sie die Anmeldeinformationen manuell in MVE ein, oder erstellen Sie eine Konfiguration vom Drucker. Druckersicherheitsstatus Bedeutung"},{"UUID":"d01ede44-6b5c-4355-9605-d26b55ad56dd","title":"Sichern der Druckerkommunikation","link":"securing-printers-using-default-config-topic.html","desc":"Sichern von Druckern unter Verwendung","descFull":"Sichern von Druckern unter Verwendung der Standardkonfigurationen Bei einigen Druckermodellen gibt es keinen Standardadministrator-Benutzer. Gastbenutzer haben offenen Zugriff und sind nicht angemeldet. Diese Einrichtung gewährt Benutzern Zugriff auf alle Druckerberechtigungen und Zugriffssteuerungen. MVE behandelt dieses Risiko durch Standardkonfigurationen. Nach einer Neuinstallation werden automatisch zwei erweiterte Sicherheitskomponenten erstellt. Jede Komponente enthält die Standardsicherheitseinstellungen und das vorkonfigurierte lokale Administratorkonto. Sie können diese Sicherheitskomponenten beim Erstellen einer Konfiguration verwenden und anschließend die Konfiguration auf den neuen Druckern bereitstellen und durchsetzen. Klicken Sie im Menü  Konfigurationen  auf  Alle erweiterten Sicherheitskomponenten . Einfache kontobasierte Authentifizierung Diese Sicherheitskomponente enthält ein  lokales Konto (Benutzername/Passwort)  mit dem Namen  admin . Das  Administratorkonto  ist ein Mitglied der Admin-Gruppe, zu deren Berechtigungen Funktionszugriffssteuerungen und Berechtigungen gehören, um den Drucker zu sichern und den öffentlichen Zugriff einzuschränken. Weitere Informationen finden Sie unter  . Stellen Sie vor dem Hinzufügen dieser Komponente zu einer Konfiguration sicher, dass Sie das  Administratorkennwort  und die Anmeldeinformationen des Druckers festgelegt haben. Einfache vorlagenbasierte Authentifizierung Diese Sicherheitskomponente enthält eine Sicherheitsvorlage namens  Admin kennwortgesichert , die mit einem  lokalen Kennwortkonto  konfiguriert ist. Diese Sicherheitsvorlage wird auf die folgenden Zugriffssteuerungen angewendet: Firmware-Aktualisierungen Remote-Verwaltung Sicherheitsmenü , standortfern Die übrigen Zugriffssteuerungen sind auf  Keine Sicherheit  eingestellt. Sie können jedoch immer die anderen Druckerverwaltungsmenüs so einstellen, dass die Sicherheitsvorlage für mehr Schutz verwendet wird. Weitere Informationen zu den Zugriffssteuerungen finden Sie unter  . Achten Sie darauf, vor dem Hinzufügen dieser Komponente zu einer Konfiguration das Kennwort und die Anmeldeinformationen des Druckers festzulegen. Sichern von Druckern unter Verwendung der Standardkonfigurationen Drucker Sichern Standardkonfigurationen"},{"UUID":"a8f9dbe9-cf16-4bba-94dd-9f174927ae98","title":"Sichern der Druckerkommunikation","link":"understanding-fac-permissions-topic.html","desc":"Bedeutung von Berechtigungen und Funktionszugriffssteuerungen","descFull":"Bedeutung von Berechtigungen und Funktionszugriffssteuerungen Drucker können so konfiguriert werden, dass der öffentliche Zugriff auf Verwaltungsmenüs und Geräteverwaltungsfunktionen eingeschränkt wird. Bei neueren Druckermodellen können Berechtigungen für den Zugriff auf Druckerfunktionen über verschiedene Authentifizierungsmethoden gesichert werden. Bei älteren Druckermodellen kann eine Sicherheitsvorlage auf eine Funktionszugriffssteuerung (Function Access Control, FAC) angewendet werden. Um mit diesen gesicherten Druckern zu kommunizieren und diese zu verwalten, benötigt MVE je nach Druckermodell bestimmte Berechtigungen oder FACs. In der folgenden Tabelle wird erläutert, welche Druckerverwaltungsfunktionen in MVE verwaltet werden können und welche Berechtigungen oder FACs erforderlich sind. Beachten Sie, dass MVE die Authentifizierungsinformationen benötigt, wenn die  Remote-Verwaltung  gesichert ist. Wenn andere Verwaltungsmenüs und Geräteverwaltungsberechtigungen oder FACs gesichert sind, muss die  Remote-Verwaltung  ebenfalls gesichert sein. Andernfalls kann MVE die Funktionen nicht ausführen. Diese Berechtigungen und Funktionszugriffssteuerungen sind in MVE als standardmäßige erweiterte Sicherheitskomponenten vordefiniert und können problemlos in einer Konfiguration verwendet werden. Weitere Informationen finden Sie unter  . Wenn Sie die erweiterten Standardsicherheitskomponenten nicht verwenden, stellen Sie sicher, dass diese Berechtigungen und Funktionszugriffssteuerungen im Drucker manuell konfiguriert sind. Weitere Informationen finden Sie unter  . Berechtigungen oder FACs Beschreibung Remote-Verwaltung Die Möglichkeit, Einstellungen per Fernzugriff zu lesen und zu schreiben. Wenn andere in dieser Tabelle aufgeführte Berechtigungen oder FACs gesichert sind, muss die  Remote-Verwaltung  ebenfalls gesichert sein. Firmware-Aktualisierungen Die Möglichkeit, Firmware über jede beliebige Methode zu aktualisieren. Konfiguration der Anwendungen Die Möglichkeit, Anwendungen auf dem Drucker zu installieren oder zu entfernen und Dateien mit Anwendungseinstellungen an den Drucker zu senden. Alle Einstellungen importieren/exportieren oder Konfigurationsdatei importieren/exportieren Die Möglichkeit, Konfigurationsdateien an den Drucker zu senden. Menü \"Sicherheit\" oder Remote-Sicherheitsmenü Die Möglichkeit, Anmeldemethoden zu verwalten und Druckersicherheitsoptionen zu konfigurieren. Um neuere Druckermodelle in MVE zu sichern, deaktivieren Sie den öffentlichen Zugriff auf die Berechtigungen für die  Remote-Verwaltung  und das  Menü \"Sicherheit\" . Wenden Sie bei älteren Druckermodellen eine Sicherheitsvorlage auf die FAC  Remote-Verwaltung  an. Funktionszugriffs-Steuerelemente Bedeutung Berechtigungen Bedeutung"},{"UUID":"d0e29522-0f94-4168-82d5-ca73b19a05ee","title":"Sichern der Druckerkommunikation","link":"configuring-device-security-topic.html","desc":"Konfigurieren der Druckersicherheit Klicken Sie","descFull":"Konfigurieren der Druckersicherheit Klicken Sie im Menü  Drucker  auf  Druckerliste . Klicken Sie auf die IP-Adresse des Druckers, und klicken Sie anschließend auf  Embedded Web Server öffnen . Klicken Sie auf  Einstellungen  oder  Konfiguration . Führen Sie je nach Druckermodell einen der folgenden Schritte aus: Klicken Sie auf  Sicherheit Anmeldemethoden , und gehen Sie wie folgt vor: Für neuere Druckermodelle Erstellen Sie im Abschnitt  Sicherheit  eine Anmeldemethode. Klicken Sie neben der Anmeldemethode auf  Gruppen/Berechtigungen verw.  oder  Berechtigungen verw. Erweitern Sie die  Verwaltungsmenüs , und wählen Sie anschließend das Menü  Sicherheit  aus. Erweitern Sie die  Geräteverwaltung , und wählen Sie die folgenden Berechtigungen aus: Remote-Verwaltung Firmware-Aktualisierungen Konfiguration der Anwendungen Alle Einstellungen importieren/exportieren Klicken Sie auf  Speichern . Klicken Sie im Abschnitt  Öffentlich  auf  Berechtigungen verwalten . Erweitern Sie die  Verwaltungsmenüs , und löschen dann die Auswahl des Menüs  Sicherheit . Erweitern Sie  Geräteverwaltung , und löschen Sie dann die Auswahl für  Remote-Verwaltung . Klicken Sie auf  Speichern . Klicken Sie auf  Sicherheit Sicherheitseinstellung  oder  Sicherheitseinstellung bearbeiten , und gehen Sie dann wie folgt vor: Für ältere Druckermodelle Erstellen Sie im Abschnitt  Erweiterte Sicherheitseinrichtung  einen Baustein und eine Sicherheitsvorlage. Klicken Sie auf  Zugriffssteuerungen , und erweitern Sie die  Verwaltungsmenüs . Wählen Sie im  Remote-Sicherheitsmenü  die Sicherheitsvorlage aus. Erweitern Sie  Verwaltung , und wählen Sie dann die Sicherheitsvorlage für die folgenden Funktionszugriffssteuerungen aus: Konfiguration der Anwendungen Remote-Verwaltung Firmware-Aktualisierungen Konfigurationsdatei importieren/exportieren Klicken Sie auf  Übernehmen . Konfigurieren der Druckersicherheit Druckersicherheit Konfigurieren"},{"UUID":"e0018df2-3d08-461d-9d38-cfde77c550b0","title":"Sichern der Druckerkommunikation","link":"securing-printer-communications-on-your-fleet-topic.html","desc":"Sichern der Kommunikation in der","descFull":"Sichern der Kommunikation in der Druckerflotte Suchen Sie einen gesicherten Drucker. Weitere Informationen finden Sie unter  . Ein Drucker ist gesichert, wenn   daneben angezeigt wird. Weitere Informationen zum Sichern eines Druckers finden Sie im  Hilfedokument . Weitere Informationen zum Druckersicherheitsstatus finden Sie unter  . Erstellen Sie eine Konfiguration über einen Drucker. Weitere Informationen finden Sie unter  . Weisen Sie die Konfiguration der Druckerflotte zu. Weitere Informationen finden Sie unter  . Setzen Sie die Konfiguration durch. Weitere Informationen finden Sie unter  . Neben dem gesicherten Drucker wird ein Vorhängeschloss-Symbol angezeigt. Sichern der Kommunikation auf der Druckerflotte Druckerkommunikation Sichern"},{"UUID":"1c0f3edd-d8ab-4856-af51-37b5b2768091","title":"Sichern der Druckerkommunikation","link":"securing-printers-topic.html","desc":"Andere Möglichkeiten, Ihre Drucker zu","descFull":"Andere Möglichkeiten, Ihre Drucker zu schützen Weitere Informationen zur Konfiguration für Sicherheitseinstellungen von Druckern finden Sie im  Administratorhandbuch zu Embedded Web Server  für Ihren Drucker. Überprüfen Sie Ihre Drucker auf die folgenden Einstellungen: Festplattenverschlüsselung ist aktiviert. Folgende Anschlüsse sind eingeschränkt: TCP 79 (Finger) TCP 21 (FTP) UDP 69 (TFTP) TCP 5001 (IPDS) TCP 9600 (IPDS) TCP 10000 (Telnet) Die Standard-Ziffernliste ist die OWASP-Ziffernzeichenfolge \"B.\". Sichern von Druckern Drucker Sichern"},{"UUID":"b02b4a8b-916a-451a-b1ae-7c172f53d3e6","title":"Verwalten von Druckern","link":"restarting-printer-topic.html","desc":"Neustarten des Druckers Klicken Sie","descFull":"Neustarten des Druckers Klicken Sie im Menü  Drucker  auf  Druckerliste . Klicken Sie auf die IP-Adresse des Druckers. Klicken Sie auf  Drucker neu starten . Ausführen des Drucker-Neustarts Drucker Neu starten"},{"UUID":"6060ff55-9857-4962-bbee-b92d937478ca","title":"Verwalten von Druckern","link":"viewing-ews-topic.html","desc":"Anzeigen des Embedded Web Servers","descFull":"Anzeigen des Embedded Web Servers des Druckers Der Embedded Web Server ist eine im Drucker integrierte Software, mit der eine Bedienkonsole bereitgestellt wird, über die das Konfigurieren des Druckers von jedem Webbrowser aus möglich ist. Klicken Sie im Menü  Drucker  auf  Druckerliste . Klicken Sie auf die IP-Adresse des Druckers. Klicken Sie auf  Embedded Web Server öffnen . Anzeigen des Embedded Web Servers des Druckers Embedded Web Server anzeigen"},{"UUID":"47e1b7e9-722e-4d46-8410-56764caaf4f3","title":"Verwalten von Druckern","link":"auditing-devices-topic.html","desc":"Überprüfen von Druckern Bei einer","descFull":"Überprüfen von Druckern Bei einer Prüfung werden Informationen der Drucker im Status \"Verwaltet\" erfasst und dann im System gespeichert. Führen Sie regelmäßige Prüfungen durch, um sicherzustellen, dass die Informationen im System aktuell sind. Klicken Sie im Menü \"Drucker\" auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Drucker Überwachung . Die Durchführung einer Prüfung kann in regelmäßigen Abständen geplant werden. Weitere Informationen finden Sie unter  . Überprüfen von Druckern Drucker Prüfen"},{"UUID":"c58e6b76-1fdf-4ed8-bb94-c3483c927878","title":"Verwalten von Druckern","link":"updating-printer-status-topic.html","desc":"Aktualisieren des Druckerstatus Mit der","descFull":"Aktualisieren des Druckerstatus Mit der Funktion \"Status aktualisieren\" können Sie den Druckerstatus aktualisieren, während sie gleichzeitig Informationen bereitstellt. Um sicherzustellen, dass der Druckerstatus und die Verbrauchsmaterialinformationen aktuell sind, aktualisieren Sie den Status regelmäßig. Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Drucker Status aktualisieren . Eine Status-Aktualisierung kann so geplant werden, dass sie in regelmäßigen Abständen stattfindet. Weitere Informationen finden Sie unter  . Aktualisieren des Druckerstatus Druckerstatus Aktualisieren"},{"UUID":"1aeb4d41-36bb-4de2-b150-297d1c8a8b8a","title":"Verwalten von Druckern","link":"setting-device-state-topic.html","desc":"Einstellen des Druckerstatus Weitere Informationen","descFull":"Einstellen des Druckerstatus Weitere Informationen zu Druckerstatus finden Sie unter  . Klicken Sie im Menü \"Drucker\" auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Drucker , und wählen Sie dann eine der folgenden Optionen aus: Status auf \"Verwaltet\" setzen — Der Drucker wird in sämtliche Aktivitäten, die im System ausgeführt werden können, einbezogen. Status auf \"Nicht Verwaltet\" setzen — Der Drucker wird von sämtlichen Aktivitäten, die im System ausgeführt werden können, ausgeschlossen. Status auf \"Nicht verwendet\" setzen — Der Drucker wird aus dem Netzwerk entfernt. Das System behält die Druckerinformationen, geht aber nicht davon aus, das Gerät wieder im Netzwerk zu entdecken. Druckerstatus Einstellung Einstellen des Druckerstatus"},{"UUID":"23568d00-c2f0-45be-83ee-23b3264ea470","title":"Verwalten von Druckern","link":"assigning-configurations-to-devices-topic.html","desc":"Zuweisen von Konfigurationen zu Druckern","descFull":"Zuweisen von Konfigurationen zu Druckern Stellen Sie zunächst sicher, dass eine Konfiguration für den Drucker erstellt wurde. Durch das Zuweisen einer Konfiguration zu einem Drucker kann das System Übereinstimmungsprüfung und Durchsetzung ausführen. Weitere Informationen finden Sie unter  . Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Konfigurieren Konfigurationen zuweisen . Wählen Sie im Abschnitt  Konfiguration  eine Konfiguration aus. Wenn das System auf  Markvision verwenden, um Gerätezertifikate zu verwalten  eingestellt ist, wählen Sie die Option  Ausgewählten Geräten vertrauen  aus. Mit dieser Bestätigung können Benutzer überprüfen, ob es sich bei den Druckern um echte Geräte und nicht um vorgetäuschte Geräte handelt. Klicken Sie auf  Konfigurationen zuweisen . Zuweisen von Konfigurationen zu Druckern Konfigurationen zuweisen"},{"UUID":"60d9e343-3118-4f80-80d1-865f6c6f41a3","title":"Verwalten von Druckern","link":"unassigning-configurations-topic.html","desc":"Aufheben der Zuweisung von Konfigurationen","descFull":"Aufheben der Zuweisung von Konfigurationen Klicken Sie im Menü \"Drucker\" auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Konfigurieren Zuweisen der Konfigurationen aufheben . Klicken Sie auf  Zuweisen der Konfigurationen aufheben . Aufheben der Zuweisung von Konfigurationen Konfigurationen Aufheben der Zuweisung"},{"UUID":"b94001a8-d74d-40d1-a24e-5c62073a578a","title":"Verwalten von Druckern","link":"enforcing-configurations-topic.html","desc":"Durchsetzen von Konfigurationen MVE führt","descFull":"Durchsetzen von Konfigurationen MVE führt eine Übereinstimmungsprüfung am Drucker durch. Wenn einige Einstellungen nicht übereinstimmen, ändert MVE diese Einstellungen des Druckers. Im Anschluss an die Einstellungsänderungen führt MVE eine abschließende Übereinstimmungsprüfung durch. Zum Abschluss von Updates, die einen Neustart des Druckers erfordern, beispielsweise Firmware-Aktualisierungen, ist möglicherweise eine zweite Durchsetzung nötig. Stellen Sie zunächst sicher, dass dem Drucker eine Konfiguration zugewiesen ist. Weitere Informationen finden Sie unter  . Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Konfigurieren Konfigurationen durchsetzen . Wenn sich der Drucker in einem Fehlerstatus befindet, werden einige Einstellungen möglicherweise nicht aktualisiert. Damit MVE Firmware- und Lösungsdateien für einen Drucker bereitstellen kann, muss die Funktionszugriffssteuerung für Firmware-Aktualisierungen auf  Keine Sicherheit  eingestellt werden. Wenn Sicherheit angewandt wird, muss die Funktionszugriffssteuerung für Firmware-Aktualisierungen die gleiche Sicherheitsvorlage verwenden wie die Funktionszugriffssteuerung für die Remote-Verwaltung. Weitere Informationen finden Sie unter  . Eine Durchsetzung kann so geplant werden, dass sie in regelmäßigen Abständen stattfindet. Weitere Informationen finden Sie unter  . Durchsetzen von Konfigurationen Konfigurationen Durchsetzen"},{"UUID":"22345dd9-db33-44b1-952d-83a1a2bfac92","title":"Verwalten von Druckern","link":"checking-device-conformance-topic.html","desc":"Prüfen der Druckerübereinstimmung mit einer","descFull":"Prüfen der Druckerübereinstimmung mit einer Konfiguration Während einer Übereinstimmungsprüfung prüft MVE die Druckereinstellungen und überprüft, ob sie der zugewiesenen Konfiguration entsprechen. Während dieses Vorgangs nimmt MVE keine Änderungen am Drucker vor. Stellen Sie zunächst sicher, dass dem Drucker eine Konfiguration zugewiesen ist. Weitere Informationen finden Sie unter  . Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Konfigurieren Übereinstimmung prüfen . Sie können die Ergebnisse auf der Statusseite der Aufgabe anzeigen. Eine Übereinstimmungsprüfung kann so geplant werden, dass sie in regelmäßigen Abständen stattfindet. Weitere Informationen finden Sie unter  . Prüfen der Druckerübereinstimmung mit einer Konfiguration Übereinstimmung Prüfen Drucker Übereinstimmung Konfiguration Übereinstimmung"},{"UUID":"539e4fe8-d9df-496b-b16c-62da1ba713b1","title":"Verwalten von Druckern","link":"deploying-files-to-printers-topic.html","desc":"Bereitstellen von Dateien für Drucker","descFull":"Bereitstellen von Dateien für Drucker Sie können folgende Dateien für den Drucker bereitstellen: CA-Zertifikate — .cer  - oder  .pem  -Dateien, die zum vertrauenswürdigen Druckerspeicher hinzugefügt werden. Konfigurationpaket — .zip  -Dateien, die über einen unterstützten Drucker exportiert oder direkt von Lexmark erhalten werden. Firmware-Aktualisierung —Eine  .fls  -Datei, die an den Drucker geflasht wird. Generische Datei —Beliebige Datei, die Sie an den Drucker senden möchten. Raw Socket —Über Port 9100 gesendet. Der Drucker behandelt dies wie alle anderen Druckdaten. FTP —Datei über FTP senden. Diese Bereitstellungsmethode wird bei gesicherten Druckern nicht unterstützt. Drucker-Zertifikat —Ein signiertes Zertifikat, das als Standard-Zertifikat auf dem Drucker installiert ist. Universelle Konfigurationsdatei (UCF) —Eine Konfigurationsdatei, die von einem Drucker exportiert wurde. Webdienst —Der HTTPS-Webdienst wird verwendet, wenn das Druckermodell diesen unterstützt. Andernfalls verwendet der Drucker den HTTP-Webdienst. FTP —Datei über FTP senden. Diese Bereitstellungsmethode wird bei gesicherten Druckern nicht unterstützt. Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Konfigurieren Datei für Drucker bereitstellen . Klicken Sie auf  Datei auswählen , und navigieren Sie dann zur Datei. Wählen Sie einen Dateityp aus, und wählen Sie dann eine Bereitstellungsmethode aus. Klicken Sie auf  Datei bereitstellen . Damit MVE Firmware- und Lösungsdateien für einen Drucker bereitstellen kann, muss die Funktionszugriffssteuerung für Firmware-Aktualisierungen auf  Keine Sicherheit  eingestellt werden. Wenn Sicherheit angewandt wird, muss die Funktionszugriffssteuerung für Firmware-Aktualisierungen die gleiche Sicherheitsvorlage verwenden wie die Funktionszugriffssteuerung für die Remote-Verwaltung. Eine Datei-Bereitstellung kann so geplant werden, dass sie in regelmäßigen Abständen stattfindet. Weitere Informationen finden Sie unter  . Bereitstellen von Dateien für Drucker Dateien bereitstellen Drucker Bereitstellen von Dateien"},{"UUID":"f5a26efe-6b32-4d99-a046-fe22b41ff411","title":"Verwalten von Druckern","link":"updating-printer-firmware-topic.html","desc":"Aktualisieren der Drucker-Firmware Klicken Sie","descFull":"Aktualisieren der Drucker-Firmware Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Konfigurieren Firmwareaktualisierung zu Druckern . Wählen Sie eine Firmware-Datei aus der Ressourcenbibliothek aus, oder klicken Sie auf  Datei auswählen , und navigieren Sie dann zur Firmware-Datei. Weitere Informationen zum Hinzufügen von Firmware-Dateien zur Bibliothek finden Sie unter  . Falls erforderlich, können Sie eine Zeit für die Aktualisierung wählen, indem Sie  Aktualisierungsfenster festlegen  auswählen und dann die Start- und Unterbrechungszeit und die Wochentage festlegen. Die Firmware wird innerhalb der angegebenen Start- und Unterbrechungszeit an die Drucker gesendet. Die Aufgabe wird nach der Unterbrechungszeit angehalten, und zur nächsten Startzeit bis zum Abschluss weitergeführt. Klicken Sie auf  Firmware aktualisieren . Damit MVE die Drucker-Firmware aktualisieren kann, muss die Funktionszugriffssteuerung für Firmware-Aktualisierungen auf  Keine Sicherheit  eingestellt sein. Wenn Sicherheit angewandt wird, muss die Funktionszugriffssteuerung für  Firmware-Aktualisierungen  die gleiche Sicherheitsvorlage verwenden wie die Funktionszugriffssteuerung für die  Remote-Verwaltung . In diesem Fall muss MVE den Drucker sicher verwalten. Weitere Informationen finden Sie unter  . Aktualisieren der Drucker-Firmware Drucker-Firmware Aktualisieren"},{"UUID":"7090c157-c0c2-4238-b59d-7ebe8f4457eb","title":"Verwalten von Druckern","link":"uninstalling-applications-from-devices-topic.html","desc":"Deinstallieren von Anwendungen auf Druckern","descFull":"Deinstallieren von Anwendungen auf Druckern MVE kann nur Anwendungen deinstallieren, die dem System im Package Builder-Format hinzugefügt wurden. Weitere Informationen zum Hochladen von Anwendungen zum System finden Sie unter  . Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Konfigurieren Apps auf Druckern deinstallieren . Wählen Sie die Anwendungen aus. Klicken Sie auf  Apps deinstallieren . Deinstallieren von Anwendungen auf Druckern Anwendungen Deinstallieren"},{"UUID":"6c5367eb-5331-42a2-b115-343507182fb4","title":"Verwalten von Druckern","link":"assigning-events-to-device-topic.html","desc":"Zuweisen von Ereignissen zu Druckern","descFull":"Zuweisen von Ereignissen zu Druckern Durch das Zuweisen von Ereignissen zu Druckern kann MVE die zugehörige Aktion ausführen, sobald eine der zugehörigen Warnungen auf dem zugewiesenen Drucker auftritt. Weitere Informationen zum Erstellen von Ereignissen finden Sie unter  . Ereignisse können nur ungesicherten Druckern zugewiesen werden. Klicken Sie im Menü \"Drucker\" auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Zuweisen Ereignisse . Wählen Sie ein oder mehrere Ereignisse aus. Wenn einigen der ausgewählten Drucker bereits das Ereignis zugewiesen wurde, wird ein Bindestrich im Kontrollkästchen angezeigt. Wenn Sie den Bindestrich dort stehen lassen, wird das Ereignis nicht verändert. Wenn Sie dieses Kontrollkästchen aktivieren, wird das Ereignis allen ausgewählten Druckern zugewiesen. Wenn Sie das Kontrollkästchen deaktivieren, wird die Zuordnung des Ereignisses zu den Druckern, denen es zuvor zugewiesen war, aufgehoben. Klicken Sie auf  Ereignisse zuweisen . Zuweisen von Ereignissen zu Druckern Ereignisse zuweisen Drucker Ereignisse"},{"UUID":"92846459-96f2-4bc3-8e29-7f7304928469","title":"Verwalten von Druckern","link":"assigning-keyword-topic.html","desc":"Zuweisen von Stichwörtern zu Druckern","descFull":"Zuweisen von Stichwörtern zu Druckern Durch das Zuweisen von Stichwörtern zu Druckern können Sie Ihre Drucker organisieren. Weitere Informationen zum Erstellen von Stichwörtern finden Sie unter  . Klicken Sie im Menü \"Drucker\" auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Zuweisen Stichwörter . Wählen Sie ggf. im Menü \"Anzeigen\" eine Kategorie aus. Wählen Sie ein oder mehrere Stichwörter aus. Stichwörter werden nach Kategorien aufgeführt. Wenn einigen der ausgewählten Drucker bereits ein Schlüsselwort zugewiesen wurde, wird ein Bindestrich im Kontrollkästchen angezeigt. Wenn Sie den Bindestrich stehen lassen, wird das Schlüsselwort den ausgewählten Druckern nicht zugeordnet oder die Zuordnung wird aufgehoben. Wenn Sie dieses Kontrollkästchen aktivieren, wird das Schlüsselwort allen ausgewählten Druckern zugewiesen. Wenn Sie das Kontrollkästchen deaktivieren, wird die Zuordnung des Schlüsselworts zu den Druckern, denen es zuvor zugewiesen war, aufgehoben. Klicken Sie auf  Stichwörter zuweisen . Zuweisen von Stichwörtern Schlüsselwort zuweisen"},{"UUID":"f32134a5-8d73-4b52-89c5-95538d81d4c4","title":"Verwalten von Druckern","link":"entering-credentials-secured-printers-topic.html","desc":"Eingeben von Anmeldeinformationen für gesicherte","descFull":"Eingeben von Anmeldeinformationen für gesicherte Drucker Gesicherte Drucker können erkannt und integriert werden. Um mit diesen Druckern zu kommunizieren, können Sie entweder eine Konfiguration erzwingen oder die Anmeldeinformationen direkt in MVE eingeben. Ein Drucker ist gesichert, wenn   daneben angezeigt wird. Um die Anmeldeinformationen einzugeben, verfahren Sie wie folgt: Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere gesicherte Drucker aus. Klicken Sie auf  Sicherheit Anmeldeinformationen eingeben . Wählen Sie die Authentifizierungsmethode aus, und geben Sie dann die Anmeldeinformationen ein. Klicken Sie auf  Anmeldeinformationen eingeben . Integrierte Drucker, die gesichert sind, für die aber nicht die richtigen Anmeldeinformationen in MVE gespeichert sind, werden unter dem Filter  Kommunikationen  als  Fehlende Anmeldeinformationen  gekennzeichnet. Nach Eingabe der richtigen Anmeldeinformationen werden die Drucker als  Gesichert  gekennzeichnet. Eingeben von Anmeldeinformationen für gesicherte Drucker Anmeldeinformationen Eingeben Gesicherte Drucker Authentifizierung"},{"UUID":"d188c5f7-6256-4e75-a1a0-99ac927b3db0","title":"Verwalten von Druckern","link":"configuring-printer-certificates-manually-topic.html","desc":"Manuelles Konfigurieren von Standarddruckerzertifikaten Wenn","descFull":"Manuelles Konfigurieren von Standarddruckerzertifikaten Wenn MVE nicht die Funktion zur automatischen Zertifikatsverwaltung verwendet, kann es Ihnen helfen, das Standarddruckerzertifikat für eine Druckerflotte zu signieren. MVE sammelt die Anforderungen der Druckerflotte zum Signieren von Zertifikaten und stellt nach dem Signieren die signierten Zertifikate für die richtigen Drucker bereit. Ein Systemadministrator muss Folgendes tun: Erzeugen Sie die Signieranforderungen für Druckerzertifikate. Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Sicherheit Signieranforderungen für Druckerzertifikate erzeugen . Sie können bei der Erzeugung von Zertifikatssignieranforderungen einen oder mehrere Drucker auswählen, aber nur maximal ein Satz Anforderungen kann vorhanden sein. Um vorhandene Zertifikatssignieranforderungen nicht zu überschreiben, müssen Sie die Zertifikatssignieranforderungen herunterladen, bevor Sie einen weiteren Satz erzeugen. Warten Sie, bis die Aufgabe beendet ist, und laden Sie anschließend die Signieranforderungen für Druckerzertifikate herunter. Klicken Sie im Menü  Drucker  auf  Druckerliste . Klicken Sie auf  Sicherheit Herunterladen von Signieranforderungen für Druckerzertifikate . Verwenden Sie eine vertrauenswürdige Zertifizierungsstelle zum Signieren der Zertifikatssignieranforderungen. Speichern Sie die signierten Zertifikate in einer ZIP-Datei. Alle signierten Zertifikate müssen sich im Stammverzeichnis der ZIP-Datei befinden. Andernfalls kann MVE die Datei nicht analysieren. Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Konfigurieren Datei für Drucker bereitstellen . Klicken Sie auf  Datei auswählen , und navigieren Sie anschließend zur ZIP-Datei. Wählen Sie im Menü  Dateityp  die Option  Druckerzertifikate  aus. Klicken Sie auf  Datei bereitstellen . Manuelles Konfigurieren von Druckerzertifikaten Druckerzertifikate Manuell konfigurieren"},{"UUID":"f1aefd8b-5204-4a90-ac09-b012866d04d9","title":"Verwalten von Druckern","link":"removing-printers-topic.html","desc":"Entfernen von Druckern Klicken Sie","descFull":"Entfernen von Druckern Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie einen oder mehrere Drucker aus. Klicken Sie auf  Drucker . Falls es notwendig ist, das Druckerzertifikat zu entfernen, wählen Sie die Option  Zugeordnete(s) Gerätezertifikat(e) löschen  aus. Wenn MVE die Gerätezertifikate verwaltet, wird beim Entfernen des Druckerzertifikats das Standardzertifikat vom Drucker gelöscht. Der Drucker erzeugt daraufhin ein neues signiertes Zertifikat. Führen Sie einen der folgenden Schritte aus: Um die Druckerinformationen beizubehalten, klicken Sie auf  Drucker stilllegen . Um den Drucker aus Ihrem System zu entfernen, klicken Sie auf  Drucker löschen . Entfernen von Druckern Drucker Entfernen"},{"UUID":"63840923-98ec-48f6-a4e7-630f6f900794","title":"Verwalten von Konfigurationen","link":"managing-configurations-overview-topic.html","desc":"Übersicht MVE verwendet Konfigurationen zur","descFull":"Übersicht MVE verwendet Konfigurationen zur Verwaltung der Drucker in Ihrer Druckerflotte. Eine Konfiguration ist eine Zusammenfassung von Einstellungen, die einem Drucker oder einer Gruppe von Druckermodellen zugewiesen und durchgesetzt werden können. Innerhalb einer Konfiguration können Sie Druckereinstellungen ändern und Anwendungen, Lizenzen, Firmware und CA-Zertifikate für die Drucker bereitstellen. Sie können eine Konfiguration erstellen, die aus Folgendem besteht: Grundlegende Druckereinstellungen Erweiterte Sicherheitseinstellungen Farbdruckberechtigungen Diese Einstellung ist nur in Konfigurationen für unterstützte Farbdrucker verfügbar. Drucker-Firmware Anwendungen CA-Zertifikate Ressourcendateien Durch die Verwendung von Konfigurationen haben Sie folgende Möglichkeiten zur Verwaltung der Drucker: Weisen Sie den Druckern Konfigurationen zu. Durchsetzung von Konfiguration an den Druckern. Die in der Konfiguration angegebenen Einstellungen werden auf die Drucker angewendet. Firmware, Anwendungen, Druckerzertifikat, Anwendungsdateien (.fls) und CA-Zertifikate sind installiert. Prüfen Sie, ob die Drucker mit einer Konfiguration übereinstimmen. Wenn keine Übereinstimmung vorhanden ist, kann die Konfiguration am Drucker durchgesetzt werden. Die Durchsetzung der Konfiguration und die Übereinstimmungsprüfung können so geplant werden, dass sie in regelmäßigen Abständen stattfinden. Wenn der Drucker die Konfigurationseinstellungen unterstützt, die Werte jedoch nicht zutreffen, wird der Drucker als nicht konform angezeigt. Verwalten von Konfigurationen Übersicht Verwalten von Konfigurationen Konfigurationen Verwalten"},{"UUID":"2a38edac-24ee-4020-a624-cfeaccd65101","title":"Verwalten von Konfigurationen","link":"creating-configuration-topic.html","desc":"Erstellen einer Konfiguration Eine Konfiguration","descFull":"Erstellen einer Konfiguration Eine Konfiguration ist eine Zusammenfassung von Einstellungen, die einem Drucker oder einer Gruppe von Druckern zugewiesen und durchgesetzt werden können. Innerhalb einer Konfiguration können Sie Printer Settings ändern und Anwendungen, Lizenzen, Firmware und CA-Zertifikate für Drucker bereitstellen. Klicken Sie im Menü  Konfigurationen  auf  Alle Konfigurationen Erstellen . Geben Sie einen eindeutigen Namen für die Konfiguration und ihre Beschreibung ein. Führen Sie in der  Einstellungsliste  einen oder mehrere der folgenden Schritte aus: Wählen Sie über die Registerkarte  Grundeinstellungen  eine oder mehrere Einstellungen aus und geben Sie anschließend die Werte an. Handelt es sich bei dem Wert um eine Variableneinstellung, müssen Sie die Kopfzeile mit  ${}  einschließen. Beispiel:  ${Contact_Name} . Um eine Datei mit Variableneinstellungen zu verwenden, wählen Sie die Datei im Menü  Variableneinstellungsdatei verwenden  aus, oder importieren Sie die Datei. Weitere Informationen finden Sie unter  . Wählen Sie eine oder mehrere Einstellungen aus und legen Sie dann die Werte fest. Handelt es sich bei dem Wert um eine Variableneinstellung, müssen Sie die Kopfzeile mit  ${}  einschließen. Beispiel:  ${Contact_Name} . Um eine Datei mit Variableneinstellungen zu verwenden, wählen Sie die Datei im Menü  Variableneinstellungsdatei verwenden  aus, oder importieren Sie die Datei. Weitere Informationen finden Sie unter  . Wenn ein oder mehrere Zertifikate zu dieser Konfiguration hinzugefügt werden, können Sie eines der Zertifikate aus dem Dropdown Wert  auswählen. Wählen Sie über die Registerkarte  Erweiterte Sicherheit  eine erweiterte Sicherheitskomponente aus. Informationen zum Erstellen einer erweiterten Sicherheitskomponente finden Sie unter  . Sie können die erweiterten Sicherheitseinstellungen nur verwalten, wenn Sie eine Konfiguration über einen ausgewählten Drucker erstellen. Weitere Informationen finden Sie unter  . Konfigurieren Sie die Einstellungen über die Registerkarte  Farbdruckberechtigungen . Weitere Informationen finden Sie unter  . Diese Einstellung ist nur in Konfigurationen für unterstützte Farbdrucker verfügbar. Wählen Sie auf der Registerkarte  Firmware  eine Firmware-Datei aus. Wenn mehrere Versionen derselben Firmware in einer Konfiguration vorhanden sind, wird bei der Konformitätsprüfung und Durchsetzung nur die höhere Firmware-Version berücksichtigt. Informationen zum Importieren einer Firmware-Datei finden Sie unter  . Wählen Sie auf der Registerkarte  Apps  mindestens eine bereitzustellende Anwendung aus. Weitere Informationen finden Sie unter  . MVE unterstützt keine Bereitstellungsanwendungen mit Probe-Lizenzen. Sie können nur freie Anwendungen oder Anwendungen mit Produktionslizenzen bereitstellen. Wählen Sie auf der Registerkarte  Zertifikate  mindestens ein Zertifikat für die Bereitstellung aus. Informationen zum Importieren einer Zertifikatsdatei finden Sie unter  . Wählen Sie die Option  Markvision zur Verwaltung von Gerätezertifikaten verwenden  (für MVE) aus, um fehlende, ungültige, widerrufene und abgelaufene Zertifikate zu bewerten. Lassen Sie sie anschließend automatisch ersetzen. Wählen Sie eine der folgenden Optionen aus: Standardgerätezertifikat Benanntes Gerätezertifikat Standardmäßig kann ein Benutzer 10 benannte Zertifikate pro MVE-Installation und 5 benannte Zertifikate pro MVE-Konfiguration hinzufügen. Weitere Informationen finden Sie unter  . Wählen Sie auf der Registerkarte  Ressourcendateien  einen der folgenden Dateitypen für die Bereitstellung aus: Anwendungsdatei (.fls) Konfigurationspaket (.zip) Universelle Konfigurationsdatei (.ucf) Jede Option auf der Registerkarte \"Ressource\" ist nicht auf Konformität geprüft. Es ist nicht ratsam, mehrere UCF- und Konfigurationspakete in einer einzigen Konfiguration zu verwenden. Diese Methode ist nicht auf UCF-Dateien anwendbar, wenn \"Scannen im Netzwerk\" auf älteren Druckermodellen konfiguriert wird. UCF-Dateien müssen mit der Aktion  Datei für Drucker bereitstellen  bereitgestellt werden. Klicken Sie auf  Konfiguration erstellen . Die folgende Liste zeigt die Deploymentsequenz in einer Konfiguration: CA-Zertifikate Anwendungsdateien Lösungspaket Erweiterte Sicherheit Gerätezertifikate Grundlegende Einstellungen UCF- und Konfigurationspaket Firmware Erstellen einer Konfiguration Konfiguration Erstellen"},{"UUID":"4b367e95-7c91-4ddd-8cb5-6acd955e4f08","title":"Verwalten von Konfigurationen","link":"creating-configuration-from-printer-topic.html","desc":"Erstellen einer Konfiguration über einen","descFull":"Erstellen einer Konfiguration über einen Drucker Folgende Komponenten sind nicht enthalten: Drucker-Firmware Anwendungen Zertifikate Zum Hinzufügen von Firmware, Anwendungen und Zertifikaten bearbeiten Sie die Konfiguration in MVE. Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie den Drucker aus, und klicken Sie dann auf  Konfigurieren Konfiguration über Drucker erstellen . Wählen Sie gegebenenfalls  Erweiterte Sicherheitseinstellungen inkludieren  aus, um eine erweiterte Sicherheitskomponente von dem ausgewählten Drucker zu erstellen. Wenn der Drucker gesichert ist, wählen Sie die Authentifizierungsmethode aus, und geben Sie die Anmeldeinformationen ein. Geben Sie einen eindeutigen Namen für die Konfiguration und ihre Beschreibung ein, und klicken Sie auf  Konfiguration erstellen . Klicken Sie im Menü  Konfigurationen  auf  Alle Konfigurationen . Wählen Sie die Konfiguration aus, und klicken Sie dann auf  Bearbeiten . Passen Sie gegebenenfalls die Einstellungen an. Klicken Sie auf  Änderungen speichern . Erstellen einer Konfiguration über einen Drucker Konfiguration Erstellen"},{"UUID":"a0b947b9-eff9-4e14-ab98-e52bff238aff","title":"Verwalten von Konfigurationen","link":"sample-scenario-cloning-configurations-topic.html","desc":"Beispielszenario: Duplizieren einer Konfiguration Fünfzehn","descFull":"Beispielszenario: Duplizieren einer Konfiguration Fünfzehn Lexmark MX812-Drucker wurden nach der Erkennung zum System hinzugefügt. Als IT-Mitarbeiter müssen Sie die Einstellungen der vorhandenen Drucker für die neu erkannten Drucker übernehmen. Sie können auch eine Konfiguration von einem Drucker duplizieren und anschließend die Konfiguration auf einer Gruppe von Druckermodellen erzwingen. Beispielimplementierung Wählen Sie in der Liste der vorhandenen Drucker einen Lexmark Drucker MX812 aus. Erstellen Sie eine Konfiguration über den Drucker. Um die Drucker zu sichern, fügen Sie die erweiterten Sicherheitseinstellungen ein. Weisen Sie den neu ermittelten Druckern die Konfiguration zu, und setzen Sie sie durch. Duplizieren einer Konfiguration Beispielszenario Beispielszenario für das Duplizieren einer Konfiguration"},{"UUID":"579031bc-1294-42ae-bdee-970cf18a1be5","title":"Verwalten von Konfigurationen","link":"creating-advanced-security-component-topic.html","desc":"Erstellen einer erweiterten Sicherheitskomponente von","descFull":"Erstellen einer erweiterten Sicherheitskomponente von einem Drucker Erstellen Sie zur Verwaltung der erweiterten Sicherheitseinstellungen eine erweiterte Sicherheitskomponente von einem Drucker. MVE liest alle Einstellungen dieses Druckers und erstellt dann eine Komponente, die die Einstellungen enthält. Die Komponente kann mehreren Konfigurationen für Druckermodelle zugeordnet werden, die über dasselbe Sicherheitssystem verfügen. Klicken Sie im Menü  Drucker  auf  Druckerliste . Wählen Sie den Drucker aus, und klicken Sie dann auf  Konfigurieren Erweiterte Sicherheitskomponente von Drucker erstellen . Geben Sie einen eindeutigen Namen für die Komponente und ihre Beschreibung ein. Wenn der Drucker gesichert ist, wählen Sie die Authentifizierungsmethode aus, und geben Sie die Anmeldeinformationen ein. Klicken Sie auf  Komponente erstellen . Wenn Sie eine Konfiguration mit einer erweiterten Sicherheitskomponente erstellen und durchsetzen, die lokale Konten umfasst, werden die lokalen Konten den Druckern hinzugefügt. Alle vorhandenen lokalen Konten, die im Drucker vorkonfiguriert sind, werden beibehalten. Erstellen einer erweiterten Sicherheitskomponente von einem Drucker Erweiterte Sicherheitskomponente Erstellen"},{"UUID":"139be0d5-992f-44cc-98c8-0bda50e79165","title":"Verwalten von Konfigurationen","link":"generating-printable-version-topic.html","desc":"Erstellen einer druckbaren Version der","descFull":"Erstellen einer druckbaren Version der Konfigurationseinstellungen Bearbeiten Sie eine Konfiguration oder eine erweiterte Sicherheitskomponente. Klicken Sie auf  Druckerfreundliche Version . Konfigurationseinstellungen Druckversion"},{"UUID":"2b8b9622-c798-4802-88a1-ee769c4f15a4","title":"Verwalten von Konfigurationen","link":"understanding-dynamic-settings-topic.html","desc":"Grundlagen zu dynamischen Einstellungen Zu","descFull":"Grundlagen zu dynamischen Einstellungen Zu diesen Einstellungen gehören das 802,1x-Gerätezertifikat, das HTTPS-Gerätezertifikat und das IPSec-Gerätezertifikat, die auf der Registerkarte  Grundeinstellung  einer Konfiguration aufgeführt sind. Die Optionen für jede dieser Einstellungen werden mit den Zertifikaten ausgefüllt, die auf der Registerkarte  Zertifikat  ausgewählt wurden. Wenn Sie eine Konfiguration klonen, exportieren oder importieren, werden die vorausgewählten Werte dieser Einstellungen gelöscht. Sie müssen die Werte manuell auswählen. Dynamische Einstellungen Erläuterungen"},{"UUID":"1a735a2a-413b-48b2-837f-fe5164cf1c2c","title":"Verwalten von Konfigurationen","link":"understanding-variable-settings-topic.html","desc":"Grundlagen zu Variableneinstellungen Variableneinstellungen ermöglichen","descFull":"Grundlagen zu Variableneinstellungen Variableneinstellungen ermöglichen Ihnen das flottenübergreifende Verwalten von Einstellungen, die für jeden Drucker eindeutig sind, beispielsweise Hostname oder Bestandsetikett. Beim Erstellen oder Bearbeiten einer Konfiguration können Sie eine CSV-Datei auswählen, die mit der Konfiguration verknüpft werden soll. CSV-Beispielformat: \nIP_ADDRESS,Contact_Name,Address,Disp_Info\n1.2.3.4,John Doe,1600 Penn. Ave., Blue\n4.3.2.1,Jane Doe,1601 Penn. Ave., Red\n2.3.6.5,\"Joe, Jane and Douglas\",1601 Penn. Ave.,Yellow\n2.3.6.7,\"Joe, Jane and Douglas\",1600 Penn. Ave.,He is 6’7” tall Die erste Spalte in der Kopfzeile der Variablen-Datei ist ein eindeutiges Drucker-Identifizierungstoken. Bei dem Token muss es sich um eines der Folgenden handeln: HOSTNAME IP_ADDRESS SYSTEM_NAME SERIAL_NUMBER Jede nachfolgende Spalte in der Kopfzeile der Variablen-Datei ist ein benutzerdefiniertes \"Ersatz\"-Token. Auf dieses Token muss innerhalb der Konfiguration mithilfe des ${Header}-Formats verwiesen werden. Es wird beim Durchsetzen der Konfiguration durch die Werte in den nachfolgenden Zeilen ersetzt. Stellen Sie sicher, dass die Token keine Leerzeichen enthalten. Sie können die CSV-Datei, in der die Variableneinstellungen enthalten sind, beim Erstellen oder Bearbeiten einer Konfiguration importieren. Weitere Informationen finden Sie unter  . Variableneinstellungen Erläuterungen Importieren von CSV-Dateien Variableneinstellungen Exportieren von CSV-Dateien Variableneinstellungen CSV Variableneinstellungen"},{"UUID":"a2060abe-b8f3-4648-bf3f-8b5ecf3e2bf5","title":"Verwalten von Konfigurationen","link":"configuring-color-permissions-topic.html","desc":"Farbdruckberechtigungen konfigurieren Mit MVE können","descFull":"Farbdruckberechtigungen konfigurieren Mit MVE können Sie den Farbdruck für Host-Computer und bestimmte Benutzer einschränken. Diese Einstellung ist nur in Konfigurationen für unterstützte Farbdrucker verfügbar. Klicken Sie im Menü \"Konfigurationen\" auf  Alle Konfigurationen . Erstellen oder bearbeiten Sie eine Konfiguration. Führen Sie in der Registerkarte \"Farbdruckberechtigungen\" einen der folgenden Schritte aus: Farbdruckberechtigungen für Host-Computer konfigurieren Wählen Sie im Menü \"Anzeigen\" zunächst die Option  Host-Computer  und dann  Farbdruckberechtigungen für Host-Computer einschließen  aus. Klicken Sie auf  Hinzufügen , und geben Sie dann den Namen des Host-Computers ein. Damit der Host-Computer in Farbe druckt, wählen Sie die Option  Farbdruck zulassen . Um Benutzern, die sich am Host-Computer anmelden, den Farbdruck zu erlauben, wählen Sie die Option  Benutzerberechtigung überschreiben . Klicken Sie auf  Speichern und Hinzufügen  oder auf  Speichern . Farbdruckberechtigungen für Benutzer konfigurieren Wählen Sie im Menü \"Anzeigen\" zunächst die Option  Benutzer  und dann  Farbdruckberechtigungen für Benutzer einschließen  aus. Klicken Sie auf  Hinzufügen , und geben Sie dann den Benutzernamen ein. Wählen Sie  Farbdruck zulassen . Klicken Sie auf  Speichern und Hinzufügen  oder auf  Speichern . Konfigurieren der Farbdruckberechtigungen Farbdruckberechtigungen Konfigurieren"},{"UUID":"87ad615b-b1e8-406c-a2de-a56556999ad6","title":"Verwalten von Konfigurationen","link":"creating-applications-package-topic.html","desc":"Erstellen eines Anwendungspakets Exportieren Sie","descFull":"Erstellen eines Anwendungspakets Exportieren Sie die Ansicht der Druckerliste über MVE mithilfe der Funktion \"Daten exportieren\". Klicken Sie im Menü  Drucker  auf  Ansichten . Wählen Sie  Druckerliste , und klicken Sie dann auf  Daten exportieren . Wählen Sie einen gespeicherten Suchvorgang aus. Wählen Sie im Menü \" Dateityp für Datenexport auswählen \" die Option  CSV . Klicken Sie auf  Daten exportieren . Öffnen Sie den Paket-Builder. Wenn Sie noch keinen Zugriff auf den Paket-Builder haben, wenden Sie sich an einen Vertriebsmitarbeiter von Lexmark. Melden Sie sich an bei Paket-Builder unter  cdp.lexmark.com/package-builder . Importieren Sie die Druckerliste, und klicken Sie dann auf  Weiter . Geben Sie die Paketbeschreibung und dann Ihre E-Mail-Adresse. Wählen Sie im Menü  Produkt  eine Anwendung aus, und fügen Sie ggf. Lizenzen hinzu. Klicken Sie auf  Weiter Fertig stellen . Der Link zum Herunterladen des Pakets wird an Ihre E-Mail-Adresse gesendet. Laden Sie das Paket herunter. MVE unterstützt keine Bereitstellungsanwendungen mit Probe-Lizenzen. Sie können nur freie Anwendungen oder Anwendungen mit Produktionslizenzen bereitstellen. Wenden Sie sich an einen Vertriebsmitarbeiter von Lexmark, wenn Sie Anwendungscodes benötigen. Importieren Sie das Anwendungspaket in die Ressourcenbibliothek, um die Anwendungen zu einer Konfiguration hinzuzufügen. Weitere Informationen finden Sie unter  . Erstellen eines Anwendungspakets Anwendungspaket erstellen"},{"UUID":"d0a49bd0-9d26-4317-98a5-285815562420","title":"Verwalten von Konfigurationen","link":"importing-exporting-configuration-file-topic.html","desc":"Importieren oder Exportieren einer Konfiguration","descFull":"Importieren oder Exportieren einer Konfiguration Stellen Sie zunächst beim Importieren einer Konfigurationsdatei sicher, dass sie aus einem MVE der gleichen Version exportiert wurde. Klicken Sie im Menü  Konfigurationen  auf  Alle Konfigurationen . Führen Sie einen der folgenden Schritte aus: Um eine Konfigurationsdatei zu importieren, klicken Sie auf  Importieren , suchen Sie nach der Konfigurationsdatei, und klicken Sie dann auf  Importieren . Um eine Konfigurationsdatei zu exportieren, wählen Sie eine Konfiguration aus, und klicken Sie dann auf  Exportieren . Beim Exportieren einer Konfiguration sind die Kennwörter ausgeschlossen. Nach dem Importieren müssen die Kennwörter manuell hinzugefügt werden. UCF, Konfigurationspakete und Anwendungsdateien sind nicht Teil einer exportierten Konfiguration. Importieren oder Exportieren einer Konfiguration Konfiguration Importieren Konfiguration Exportieren"},{"UUID":"79925b86-26d2-4036-a6d4-c4e31e4182b3","title":"Verwalten von Konfigurationen","link":"importing-files-to-resource-library-topic.html","desc":"Importieren von Dateien in die","descFull":"Importieren von Dateien in die Ressourcenbibliothek Die Ressourcenbibliothek ist eine Zusammenstellung von Firmware-Dateien, CA-Zertifikaten und Anwendungspaketen, die in MVE importiert werden. Diese Dateien können einer oder mehreren Konfiguration(en) zugeordnet werden. Klicken Sie im Menü  Konfigurationen  auf  Ressourcenbibliothek . Klicken Sie auf  Importieren  Datei auswählen , und navigieren Sie anschließend zur Datei. Nur Firmware-/Anwendungsdateien (.fls), Anwendungs- oder Konfigurationspakete (.zip), CA-Zertifikate (.pem) und universelle Konfigurationsdateien (.ucf) können importiert werden. Klicken Sie auf  Ressource importieren . Importieren von Dateien in die Ressourcenbibliothek Ressourcenbibliothek Importieren von Dateien Importieren von Dateien in die Ressourcenbibliothek"},{"UUID":"12f452e5-1282-46f9-aed3-05b88eb95c58","title":"Einrichten von MVE zur automatischen Verwaltung von Zertifikaten","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Bedeutung der Funktion zur automatisierten","descFull":"Bedeutung der Funktion zur automatisierten Zertifikatsverwaltung Sie können MVE so konfigurieren, dass Druckerzertifikate automatisch verwaltet werden, und Sie können diese anschließend über die Konfigurationsdurchsetzung auf den Druckern installieren. Das folgende Diagramm beschreibt den End-to-End-Prozess der automatischen Zertifikatsverwaltung. Die Endpunkte der Zertifizierungsstelle, zum Beispiel der CA-Server und die Serveradresse, müssen in MVE definiert werden. Die folgenden CA-Server werden unterstützt: OpenXPKI CA : Benutzer können eines der folgenden Protokolle verwenden: Sicheres Zertifikatverschlüsselungsprotokoll (Secure Certificate Encryption Protocol, SCEP) EST-Anschluss EST ist die empfohlene Methode, um eine Verbindung zum OpenXPKI-Server herzustellen. Weitere Informationen zum Konfigurieren von OpenXPKI CA mit dem EST-Protokoll finden Sie unter  . Weitere Informationen zum Konfigurieren von OpenXPKI CA mit dem SCEP-Protokoll finden Sie unter  . Microsoft CA Enterprise : Benutzer können eines der folgenden Protokolle verwenden Sicheres Zertifikatverschlüsselungsprotokoll (Secure Certificate Encryption Protocol, SCEP) Microsoft Certificate Enrollment Web Services (MSCEWS) MSCEWS ist die empfohlene Methode, um eine Verbindung zum Microsoft CA Enterprise-Server herzustellen. Weitere Informationen zum Konfigurieren von Microsoft CA mit dem MSCEWS-Protokoll finden Sie unter  . Weitere Informationen zum Konfigurieren von Microsoft CA mit dem SCEP-Protokoll finden Sie unter  . Die Verbindung zwischen MVE und den CA-Servern muss validiert werden. Während der Validierung kommuniziert MVE mit dem CA-Server, um die Zertifikatskette und die Zertifikatsperrliste (Certificate Revocation List, CRL) herunterzuladen. Das Zertifikat des Anmeldeagenten oder Testzertifikat wird ebenfalls generiert. Mit diesem Zertifikat kann der CA-Server MVE vertrauen. Weitere Informationen zur Definition der Endpunkte und zur Validierung finden Sie unter  . Eine Konfiguration, die für die  Verwendung von Markvision zur Verwaltung von Gerätezertifikaten  eingerichtet ist, muss dem Drucker zugewiesen und durchgesetzt werden. Weitere Informationen finden Sie in den folgenden Themenabschnitten: Während der Durchsetzung überprüft MVE den Drucker auf Konformität. Für  Standardgerätezertifikat Das Zertifikat wird anhand der Zertifikatskette validiert, die vom CA-Server heruntergeladen wurde. Wenn der Drucker nicht konform ist, wird eine Zertifikatssignierungsanforderung (CSR) für den Drucker angefordert. Für  Benanntes Gerätezertifikat Das Zertifikat wird anhand der Zertifikatskette validiert, die vom CA-Server heruntergeladen wurde. MVE erstellt ein selbstsigniertes, benanntes Gerätezertifikat auf dem Gerät. Wenn der Drucker nicht konform ist, wird eine CSR für den Drucker angefordert. MVE kommuniziert mit dem CA-Server unter Verwendung eines konfigurierten Protokolls. Der CA-Server generiert das neue Zertifikat und sendet das Zertifikat anschließend an den Drucker. Wenn ein benanntes Zertifikat im Drucker vorhanden ist, wird kein neues benanntes Zertifikat erstellt, aber für den Drucker wird eine CSR erstellt. Automatisierte Zertifikatsverwaltungsfunktion Zertifikatsverwaltung"},{"UUID":"f0511b45-bec9-46f5-bbe9-a2645b0bfd70","title":"Einrichten von MVE zur automatischen Verwaltung von Zertifikaten","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Konfigurieren von MVE für die","descFull":"Konfigurieren von MVE für die automatische Zertifikatsverwaltung Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  Zertifizierungsstelle Zertifizierungsstellen-Server verwenden . Die Schaltfläche  Zertifizierungsstellen-Server verwenden  wird nur angezeigt, wenn die Zertifizierungsstelle zum ersten Mal konfiguriert oder wenn das Zertifikat gelöscht wird. Konfigurieren Sie die Serverendpunkte. CA-Server : Der CA-Server (Certificate Authority), der die Druckerzertifikate generiert. Sie können eine der folgenden Optionen auswählen: OpenXPKI CA Microsoft CA- Enterprise Der Benutzer kann auch einen CA-Server konfigurieren, der das  Enrollment over Secure Transport (EST) -Protokoll unterstützt. Der CA-Server muss das in RFC 7030 definierte EST-Protokoll implementieren. Jede Abweichung von der Spezifikation kann zu einer ungültigen Installation führen. EST ist das empfohlene Protokoll für die Verbindung mit dem OpenXPKI CA-Server. Der Microsoft CA Enterprise-Server unterstützt das EST-Protokoll nicht. CA-Serveradresse : Geben Sie die IP-Adresse oder den Hostnamen Ihres CA-Servers ein. Dieses Feld gilt nur für SCEP- und EST-Protokolle. Geben Sie eine der folgenden Optionen ein: Für MSCA-Server (mit SCEP): <Server-IP-Adresse oder Hostname>/certsrv/mscep/mscep.dll Für OpenXPKI-Server (mit SCEP): <Server-IP-Adresse oder Hostname>/scep/scep Geben Sie für EST eine der folgenden Optionen ein: https://172.87.95.240 https://estserver.com estserver.com CA-Server-Kennzeichnung (Optional)  – Wenn der Benutzer einen neuen Bereich erstellt, muss derselbe Bereichsname in dieses Feld eingefügt werden. CEP-Serveradresse  – Dieses Feld gilt nur für das MSCEWS-Protokoll. Geben Sie eine der folgenden Optionen ein: Für die Authentifizierung mit Benutzername und Kennwort: https://democep.com/ADPolicyProvider_CEP_UsernamePassword/service.svc/CEP Für die integrierte Windows-Authentifizierung: https://democep.com/ADPolicyProvider_CEP_Kerberos/service.svc/CEP Für die Clientzertifikat-Authentifizierung: https://democep.com/ADPolicyProvider_CEP_Certificate/service.svc/CEP CA-Server-Hostname  – Geben Sie die IP-Adresse oder den Hostnamen Ihres CA-Servers ein. Für das MSCEWS-Protokoll kann der Benutzer beispielsweise  democa.lexmark.com  auswählen. CES-Server-Hostname  – Geben Sie die IP-Adresse oder den Hostnamen Ihres CES-Servers ein. Für das MSCEWS-Protokoll kann der Benutzer beispielsweise  democes.lexmark.com  auswählen. Abfrage-Kennwort : Das Abfrage-Kennwort, das erforderlich ist, um die Identität von MVE beim CA-Server zu bestätigen. Dieses Kennwort ist nur für OpenXPKI CA erforderlich. Es wird in Microsoft CA Enterprise nicht unterstützt. Je nach CA-Server müssen Sie den Authentifizierungsmodus des Servers konfigurieren. Führen Sie einen der folgenden Schritte aus: Wenn Sie das  EST -Protokoll auswählen, wählen Sie im Menü  Authentifizierungsmodus des CA-Servers  eine der folgenden Optionen aus: Authentifizierung mit Benutzername und Kennwort Clientzertifikat-Authentifizierung Wenn Sie das  MSCEWS -Protokoll auswählen, wählen Sie im Menü  Authentifizierungsmodus des CA-Servers  eine der folgenden Optionen aus: Authentifizierung mit Benutzername und Kennwort Clientzertifikat-Authentifizierung Integrierte Windows-Authentifizierung Das SCEP -Protokoll unterstützt nur den Authentifizierungsmodus  Kennwortabfrage . Je nach CA-Server finden Sie in den folgenden Abschnitten weitere Informationen: Klicken Sie auf  Änderungen speichern und validieren OK . Die Option  Änderungen verwerfen  funktioniert nur, wenn die Änderungen noch nicht gespeichert oder gespeichert und validiert wurden. Der Benutzer kann Daten nicht aus einer ungültigen Konfiguration heraus wiederherstellen, da MVE den letzten gültigen Status von Konfigurationen nicht speichert. MVE speichert jeweils nur eine einzelne Zertifikatskonfiguration, die gültig sein kann oder nicht. Die Verbindung zwischen MVE und den CA-Servern muss validiert werden. Während der Validierung kommuniziert MVE mit dem CA-Server, um die Zertifikatskette und die Zertifikatsperrliste (Certificate Revocation List, CRL) herunterzuladen. Das Zertifikat des Anmeldeagenten oder Testzertifikat wird ebenfalls generiert. Mit diesem Zertifikat kann der CA-Server MVE vertrauen. Sie können eine oder mehrere CEP-Vorlagen auswählen, wenn Sie das MSCEWS-Protokoll verwenden. Gehen Sie folgendermaßen vor: Nachdem Sie auf  Änderungen speichern und validieren  geklickt haben, wird das Fenster zur CEP-Vorlagenauswahl angezeigt. Wählen Sie eine oder mehrere Vorlagen aus den verfügbaren Vorlagen aus. Das Dialogfeld „Zertifizierungsstellen-Server verwenden“ ruft die Zertifikatsrückrufliste ab. Ein Dialogfeld bestätigt, dass die Zertifikatsüberprüfung erfolgreich war. Sie können die ausgewählten CEP-Vorlagen auf der Konfigurationsseite des CA-Servers anzeigen. Wenn Sie diese Konfiguration für ein beliebiges Gerät erzwingen, wird ein Zertifikat entsprechend der ausgewählten Vorlage erstellt. Navigieren Sie zurück zur Seite  Systemkonfiguration , und überprüfen Sie anschließend das CA-Zertifikat. Sie können ein CA-Zertifikat auch herunterladen oder löschen. Konfigurieren von MVE für die automatische Zertifikatsverwaltung Automatisierte Zertifikatsverwaltung Konfigurieren"},{"UUID":"cb79ed12-0287-4fb3-b5e7-9d1f859cc9dc","title":"Konfigurieren von Microsoft Enterprise CA mit NDES","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Übersicht Im folgenden Bereitstellungsszenario basieren","descFull":"Übersicht Im folgenden Bereitstellungsszenario basieren alle Berechtigungen auf Berechtigungen, die auf Zertifikatsvorlagen festgelegt sind, die im Domänen-Controller veröffentlicht werden. Die an die Zertifizierungsstelle gesendeten Zertifikatsanforderungen basieren auf Zertifikatsvorlagen. Stellen Sie bei dieser Einrichtung sicher, dass Sie über Folgendes verfügen: Gerät, das die untergeordnete CA hostet Gerät, auf dem der NDES-Service gehostet wird Domänen-Controller Erforderliche Benutzer Erstellen Sie die folgenden Benutzer im Domänen-Controller: Service-Administrator Benannt als  SCEPAdmin Muss Mitglied der Gruppen  lokaler Admin  - und  Enterprise-Admin  sein Muss lokal protokolliert werden, wenn die Installation der NDES-Rolle ausgelöst wird Verfügt über  Registrierungsberechtigung  für die Zertifikatvorlagen Verfügt über  Berechtigung zum Hinzufügen von Vorlagen  für CA Dienstkonto Benannt als  SCEPSvc Muss Mitglied der lokalen Gruppe  IIS_IUSRS  sein Muss ein Domänenbenutzer sein und über  Lese-  und  Registrierungsberechtigungen  für die konfigurierten Vorlagen verfügen Verfügt über  Anforderungsberechtigung  für CA CA-Administrator des Unternehmens Benannt als  CAAdmin Mitglied der  Admin -Gruppe des Unternehmens Muss Teil der  lokalen Admin -Gruppe sein Konfigurieren von Microsoft Enterprise CA mit NDES Übersicht Microsoft Enterprise CA mit NDES Konfigurieren"},{"UUID":"d03721a2-c5b0-4fcb-a98e-6677fba3e10a","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Übersicht Der Root-CA-Server ist der","descFull":"Übersicht Der Root-CA-Server ist der Haupt-CA-Server in einer Organisation und die Spitze der PKI-Infrastruktur. Die Root-CA authentifiziert den untergeordneten CA-Server. Dieser Server wird im Allgemeinen im Offlinemodus gehalten, um ein Eindringen zu verhindern und den privaten Schlüssel zu sichern. Zur Konfiguration des CA-Servers gehen Sie folgendermaßen vor: Stellen Sie sicher, dass der CA-Server installiert ist. Weitere Informationen finden Sie unter  . Konfigurieren Sie die Einstellungen für den Zertifizierungsverteilungspunkt und den Zugriff auf die Zertifizierungsstelleninformationen. Weitere Informationen finden Sie unter  . Konfigurieren Sie die CRL-Zugänglichkeit. Weitere Informationen finden Sie unter  . Übersicht Konfigurieren des Root-CA-Servers Übersicht über das Konfigurieren des Root-CA-Servers"},{"UUID":"e906323a-9f21-4d39-a6d3-818a9bd994ab","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Installieren des Root-CA-Servers Klicken Sie","descFull":"Installieren des Root-CA-Servers Klicken Sie im Server-Manager auf  Verwalten  Rollen und Funktion hinzufügen . Klicken Sie auf  Server-Rollen , wählen Sie  Active Directory-Zertifikatdienste  und alle Funktionen aus, und klicken Sie anschließend auf  Weiter . Wählen Sie im Abschnitt  AD CS-Rollendienste  die Option  Zertifizierungsstelle  aus, und klicken Sie anschließend auf  Weiter  Installieren . Klicken Sie nach der Installation auf  Active Directory-Zertifikatdienste auf dem Zielserver konfigurieren . Wählen Sie im Abschnitt  Rollendienste  die Option  Zertifizierungsstelle  Weiter  aus. Wählen Sie im Abschnitt  Einrichtungstyp  die Option  Eigenständige Zertifizierungsstelle  aus, und klicken Sie anschließend auf  Weiter . Wählen Sie im Abschnitt  CA-Typ  die Option  Root-CA  aus, und klicken Sie anschließend auf  Weiter . Wählen Sie  Neuen privaten Schlüssel erstellen  aus, und klicken Sie anschließend auf  Weiter . Wählen Sie im Menü  Kryptografieanbieter auswählen  die Option  RSA#Microsoft Software Key Storage Provider  aus. Wählen Sie im Menü  Schlüssellänge  die Option  4096  aus. Wählen Sie aus der Liste mit den Hash-Algorithmen  SHA512  aus, und klicken Sie anschließend auf  Weiter . Geben Sie in das Feld  Gemeinsamer Name für diese CA  den Namen des Hosting-Servers ein. Geben Sie in das Feld  Suffix des definierten Namens  die Domänenkomponente ein. Beispiel für Konfiguration des CA-Namens Vollqualifizierter Domänenname (FQDN) des Geräts:  test.dev.lexmark.com Gemeinsamer Name (CN):  TEST Suffix des DN (Distinguished Name):  DC=DEV,DC=LEXMARK,DC=COM Klicken Sie auf  Weiter . Geben Sie den Gültigkeitszeitraum an, und klicken Sie anschließend auf  Weiter . Im Allgemeinen beträgt der Gültigkeitszeitraum 10 Jahre. Ändern Sie nichts im Fenster \"Datenbankspeicherorte\". Schließen Sie die Installation ab. Installieren von Root-CA-Servern Root-CA-Server Installieren"},{"UUID":"da90d5d3-e08c-444b-8341-eae3b6c84ca7","title":"Konfigurieren von Microsoft Enterprise CA mit NDES","link":"managing-certificates-using-SCEP-group.html","desc":"Übersicht Im folgenden Bereitstellungsszenario basieren","descFull":"Übersicht Im folgenden Bereitstellungsszenario basieren alle Berechtigungen auf Berechtigungen, die auf Zertifikatsvorlagen festgelegt sind, die im Domänen-Controller veröffentlicht werden. Die an die Zertifizierungsstelle gesendeten Zertifikatsanforderungen basieren auf Zertifikatsvorlagen. Stellen Sie bei dieser Einrichtung sicher, dass Sie über Folgendes verfügen: Gerät, das die untergeordnete CA hostet Gerät, auf dem der NDES-Service gehostet wird Domänen-Controller Erforderliche Benutzer Erstellen Sie die folgenden Benutzer im Domänen-Controller: Service-Administrator Benannt als  SCEPAdmin Muss Mitglied der Gruppen  lokaler Admin  - und  Enterprise-Admin  sein Muss lokal protokolliert werden, wenn die Installation der NDES-Rolle ausgelöst wird Verfügt über  Registrierungsberechtigung  für die Zertifikatvorlagen Verfügt über  Berechtigung zum Hinzufügen von Vorlagen  für CA Dienstkonto Benannt als  SCEPSvc Muss Mitglied der lokalen Gruppe  IIS_IUSRS  sein Muss ein Domänenbenutzer sein und über  Lese-  und  Registrierungsberechtigungen  für die konfigurierten Vorlagen verfügen Verfügt über  Anforderungsberechtigung  für CA Konfigurieren von Microsoft Enterprise CA mit NDES Übersicht Microsoft Enterprise CA mit NDES Konfigurieren"},{"UUID":"64b06193-95a9-42ef-bc00-15d6cd36ff24","title":"Konfigurieren eines untergeordneten CA-Servers","link":"managing-certificates-using-SCEP-group.html","desc":"Übersicht Der untergeordnete CA-Server ist","descFull":"Übersicht Der untergeordnete CA-Server ist der Zwischen-CA-Server und immer online. In der Regel führt er die Verwaltung von Zertifikaten durch. Zur Konfiguration des untergeordneten CA-Servers gehen Sie folgendermaßen vor: Stellen Sie sicher, dass der untergeordnete CA-Server installiert ist. Weitere Informationen finden Sie unter  . Konfigurieren Sie die Einstellungen für den Zertifizierungsverteilungspunkt und den Zugriff auf die Zertifizierungsstelleninformationen. Weitere Informationen finden Sie unter  . Konfigurieren Sie die CRL-Zugänglichkeit. Weitere Informationen finden Sie unter  . Übersicht Konfigurieren eines untergeordneten CA-Servers Übersicht über das Konfigurieren eines untergeordneten CA-Servers"},{"UUID":"c3a8bf95-6b80-47e5-b8c5-c4c9aec7dd87","title":"Konfigurieren eines untergeordneten CA-Servers","link":"managing-certificates-using-SCEP-group.html","desc":"Installieren des untergeordneten CA-Servers Melden","descFull":"Installieren des untergeordneten CA-Servers Melden Sie sich auf dem Server als Domänenbenutzer  CAAdmin  an. Klicken Sie im Server-Manager auf  Verwalten  Rollen und Funktion hinzufügen . Klicken Sie auf  Server-Rollen , wählen Sie  Active Directory-Zertifikatdienste  und alle Funktionen aus, und klicken Sie anschließend auf  Weiter . Wählen Sie im Abschnitt  AD CS-Rollendienste  die Optionen  Zertifizierungsstelle  und  Webregistrierung der Zertifizierungsstelle  aus, und klicken Sie anschließend auf  Weiter . Stellen Sie sicher, dass alle Funktionen der  Webregistrierung der Zertifizierungsstelle  hinzugefügt werden. Behalten Sie im Abschnitt  Web-Server-Rolle (ISS) Rollendienste  die Standardeinstellungen bei. Klicken Sie nach der Installation auf  Active Directory-Zertifikatdienste auf dem Zielserver konfigurieren . Wählen Sie im Abschnitt  Rollendienste  die Optionen  Zertifizierungsstelle  und  Webregistrierung der Zertifizierungsstelle  aus, und klicken Sie anschließend auf  Weiter . Wählen Sie im Abschnitt  Einrichtungstyp  die Option  Unternehmens-CA  aus, und klicken Sie anschließend auf  Weiter . Wählen Sie im Abschnitt  CA-Typ  die Option  Untergeordnete CA  aus, und klicken Sie anschließend auf  Weiter . Wählen Sie  Neuen privaten Schlüssel erstellen  aus, und klicken Sie anschließend auf  Weiter . Wählen Sie im Menü  Kryptografieanbieter auswählen  die Option  RSA#Microsoft Software Key Storage Provider  aus. Wählen Sie im Menü  Schlüssellänge  die Option  4096  aus. Wählen Sie aus der Liste mit den Hash-Algorithmen  SHA512  aus, und klicken Sie anschließend auf  Weiter . Geben Sie in das Feld  Gemeinsamer Name für diese CA  den Namen des Hosting-Servers ein. Geben Sie in das Feld  Suffix des definierten Namens  die Domänenkomponente ein. Beispiel für Konfiguration des CA-Namens Vollqualifizierter Domänenname (FQDN) des Geräts:  test.dev.lexmark.com Gemeinsamer Name (CN):  TEST Suffix des DN (Distinguished Name):  DC=DEV,DC=LEXMARK,DC=COM Speichern Sie die Anforderungsdatei im Dialogfeld  Zertifikatsanforderung , und klicken Sie anschließend auf  Weiter . Ändern Sie nichts im Fenster \"Datenbankspeicherorte\". Schließen Sie die Installation ab. Signieren Sie die CA-Anforderung der Root-CA, und exportieren Sie das signierte Zertifikat anschließend im PKCS7-Format. Öffnen Sie die  Zertifizierungsstelle  über die untergeordnete CA. Klicken Sie im linken Bereich mit der rechten Maustaste auf die Zertifizierungsstelle, und klicken Sie anschließend auf  Alle Aufgaben  CA-Zertifikat installieren . Wählen Sie das signierte Zertifikat aus, und starten Sie anschließend den CA-Dienst. Installieren von untergeordneten CA-Servern Untergeordnete CA-Server installieren"},{"UUID":"49fe3c46-3675-4d9b-bf75-9d580483075e","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Konfigurieren der Einstellungen für den","descFull":"Konfigurieren der Einstellungen für den Zertifizierungsverteilungspunkt und den Zugriff auf die Zertifizierungsstelleninformationen Konfigurieren Sie die Zugriffseinstellungen für den Zertifizierungsverteilungspunkt (CDP) und den Zugriff auf die Zertifizierungsstelleninformationen (AIA) für die Zertifikatsrückrufliste (CRL). Klicken Sie im Server-Manager auf  Extras  Zertifizierungsstelle . Klicken Sie im linken Bereich mit der rechten Maustaste auf die Zertifizierungsstelle, und klicken Sie anschließend auf  Eigenschaften  Erweiterungen . Wählen Sie im Menü  Erweiterung auswählen  die Option  CRL Distribution Point (CDP)  aus. Wählen Sie in der Zertifikatsrückrufliste den Eintrag  C:\\Windows\\system32\\  aus, und gehen Sie anschließend wie folgt vor: Aktivieren Sie  CRLs an diesem Speicherort veröffentlichen . Deaktivieren Sie  Delta-CRLs an diesem Speicherort veröffentlichen . Löschen Sie alle anderen Einträge außer  C:\\Windows\\system32\\ . Klicken Sie auf  Hinzufügen . Fügen Sie im Feld  Speicherort  die Option  http:// serverIP /CertEnroll/<CAName><CRLNameSuffix><DeltaCRLAllowed>.crl  hinzu, wobei  serverIP  die IP-Adresse des Servers ist. Wenn Ihr Server unter Verwendung des FQDN erreichbar ist, verwenden Sie den  <ServerDNSName>  anstelle seiner IP-Adresse. Klicken Sie auf  OK . Wählen Sie  In die CDP-Erweiterung der ausgegebenen Zertifikate aufnehmen  für den erstellten Eintrag. Wählen Sie im Menü  Erweiterung auswählen  die Option  Zugriff auf Zertifizierungsstelleninformationen (AIA)  aus. Löschen Sie alle anderen Einträge außer  C:\\Windows\\system32\\ . Klicken Sie auf  Hinzufügen . Fügen Sie im Feld  Speicherort  die Option  http:// serverIP /CertEnroll/<ServerDNSName>_<CAName><CertificateName>.crt , wobei  serverIP  die IP-Adresse des Servers ist. Wenn Ihr Server unter Verwendung des FQDN erreichbar ist, verwenden Sie den  <ServerDNSName>  anstelle seiner IP-Adresse. Klicken Sie auf  OK . Wählen Sie  In die AIA-Erweiterung der ausgegebenen Zertifikate aufnehmen  für den erstellten Eintrag. Klicken Sie auf  Anwenden OK . Starten Sie den Zertifizierungsdienst ggf. neu. Erweitern Sie im linken Bereich die Zertifizierungsstelle, klicken Sie mit der rechten Maustaste auf  Widerrufene Zertifikate , und klicken Sie anschließend auf  Eigenschaften . Geben Sie den Wert für  CRL-Veröffentlichungsintervall  und für  Veröffentlichungsintervall für Delta CRLs  an, und klicken Sie anschließend auf  Anwenden  OK . Klicken Sie im linken Bereich mit der rechten Maustaste auf  Widerrufene Zertifikate , klicken Sie auf  Alle Aufgaben , und veröffentlichen Sie anschließend die CRL, die  Neu  ist. Konfigurieren der Einstellungen für den Zertifizierungsverteilungspunkt Konfigurieren der Einstellungen für den Zugriff auf Informationen der Zertifizierungsstelle Zertifizierungsverteilungspunkt Konfigurieren Zugriff auf Informationen der Zertifizierungsstelle Konfigurieren CDP Konfigurieren AIA Konfigurieren"},{"UUID":"78204849-1ad2-4115-83af-60c58205f1ca","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Konfigurieren der CRL-Zugänglichkeit Stellen Sie","descFull":"Konfigurieren der CRL-Zugänglichkeit Stellen Sie zu Beginn sicher, dass der Internet Information Services (IIS) Manager installiert ist. Erweitern Sie im IIS-Manager die Zertifizierungsstelle, und erweitern Sie anschließend  Websites . Klicken Sie mit der rechten Maustaste auf  Standard-Website , und klicken Sie anschließend auf  Virtuelles Verzeichnis hinzufügen . Geben Sie im Feld  Alias CertEnroll  ein. Geben Sie im Feld  Physischer Pfad C:\\Windows\\System32\\CertSrv\\CertEnroll  ein. Klicken Sie auf  OK . Klicken Sie mit der rechten Maustaste auf  CertEnroll , und klicken Sie anschließend auf  Berechtigungen bearbeiten . Entfernen Sie auf der Registerkarte  Sicherheit  alle Schreibzugriffe außer für das System. Klicken Sie auf  OK . Konfigurieren  der CRL-Zugänglichkeit CRL-Zugänglichkeit Konfigurieren"},{"UUID":"c91dc937-48af-4730-9531-22ef02caa10b","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Konfigurieren des NDES-Servers Melden Sie","descFull":"Konfigurieren des NDES-Servers Melden Sie sich auf dem Server als Domänen-Benutzer  SCEPAdmin  an. Klicken Sie im Server-Manager auf  Verwalten  Rollen und Funktion hinzufügen . Klicken Sie auf  Server-Rollen , wählen Sie  Active Directory-Zertifikatdienste  und alle Funktionen aus, und klicken Sie anschließend auf  Weiter . Deaktivieren Sie im Bereich  AD CS-Rollendienst  die Option  Zertifizierungsstelle . Wählen Sie  Network Device Enrollment Service  und alle zugehörigen Funktionen aus, und klicken Sie anschließend auf  Weiter . Behalten Sie im Abschnitt  Web-Server-Rolle (ISS) Rollendienste  die Standardeinstellungen bei. Klicken Sie nach der Installation auf  Active Directory-Zertifikatdienste auf dem Zielserver konfigurieren . Wählen Sie im Abschnitt  Rollendienste  die Option  Network Device Enrollment Service  aus, und klicken Sie anschließend auf  Weiter . Wählen Sie das Dienstkonto  SCEPSvc  aus. Wählen Sie im Abschnitt  CA für NDES  entweder  CA-Name  oder  Computername  aus, und klicken Sie anschließend auf  Weiter . Geben Sie im Abschnitt  RA-Informationen  die Informationen an, und klicken Sie anschließend auf  Weiter . Gehen Sie im Abschnitt  Kryptografie für NDES  folgendermaßen vor: Wählen Sie die entsprechenden Signatur- und Kodierungsschlüsselanbieter aus. Wählen Sie im Menü  Schlüssellänge  dieselbe Schlüssellänge wie die des CA-Servers aus. Klicken Sie auf  Weiter . Schließen Sie die Installation ab. Sie können jetzt als SCEPSvc-Benutzer über einen Webbrowser auf den NDES-Server zugreifen. Auf dem NDES-Server können Sie den Fingerabdruck des CA-Zertifikats, das Abfrage-Kennwort der Registrierung und den Gültigkeitszeitraum des Abfrage-Kennworts anzeigen lassen. Zugreifen auf den NDES-Server Öffnen Sie einen Web-Browser, und geben Sie in das Feld \"URL\" Folgendes ein:  http:// NDESserverIP /certsrv/mscep_admin , wobei  NDESserverIP  die IP-Adresse des NDES-Servers ist. Konfigurieren von NDES-Servern NDES-Server Konfigurieren Konfigurieren der Network Device Enrollment Service-Server Network Device Enrollment Service-Server Konfigurieren"},{"UUID":"e962bbd5-74d9-4c71-ab6f-8f1adfcda9bd","title":"Konfigurieren von NDES für MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Erstellen einer Zertifikatvorlage Öffnen Sie","descFull":"Erstellen einer Zertifikatvorlage Öffnen Sie über die untergeordnete CA (certserv) die  Zertifizierungsstelle . Erweitern Sie die Zertifizierungsstelle im linken Bereich, klicken Sie mit der rechten Maustaste auf  Zertifikatvorlagen , und klicken Sie anschließend auf  Verwalten . Erstellen Sie in der  Zertifikatvorlagen-Konsole  eine Kopie des  Web-Servers . Geben Sie auf der Registerkarte  Allgemein MVEWebServer  als Vorlagennamen ein. Geben Sie auf der Registerkarte  Sicherheit  den Benutzern  SCEPAdmin  und  SCEPSvc  die entsprechenden Berechtigungen. Weitere Informationen finden Sie unter  . Wählen Sie auf der Registerkarte  Betreff-Name  die Option  In der Anfrage angeben  aus. Öffnen Sie über die untergeordnete CA (certserv) die  Zertifizierungsstelle . Wählen Sie auf der Registerkarte  Erweiterungen Anwendungsrichtlinien  Bearbeiten  aus. Klicken Sie auf  Hinzufügen  Client-Authentifizierung  OK . Erweitern Sie die Zertifizierungsstelle im linken Bereich, klicken Sie mit der rechten Maustaste auf  Zertifikatvorlagen , und klicken Sie anschließend auf  Neu  Zertifikatvorlage zum Ausstellen . Wählen Sie die neu erstellen Zertifikate aus, und klicken Sie anschließend auf  OK . Sie können jetzt über das CA-Web-Registrierungsportal auf die Vorlagen zugreifen. Zugriff auf die Vorlagen Öffnen Sie einen Web-Browser, und geben Sie in das Feld \"URL\" Folgendes ein:  http:// CAserverIP /certsrv/certrqxt.asp , wobei  CAserverIP  die IP-Adresse des CA-Servers ist. Zeigen Sie die Vorlagen im Menü  Zertifikatvorlagen  an. Erstellen von Zertifikatvorlagen Zertifikatvorlagen Erstellen"},{"UUID":"61c6d4bb-1dd9-41e4-b1ac-39d3e3d3c605","title":"Konfigurieren von NDES für MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Einstellen von Zertifikatvorlagen für NDES","descFull":"Einstellen von Zertifikatvorlagen für NDES Starten Sie auf Ihrem Computer den Registry-Editor. Navigieren Sie zu  HKEY_LOCAL_MACHINE  SOFTWARE  Microsoft   Cryptography  MSCEP . Konfigurieren Sie Folgendes, und legen Sie sie anschließend auf  MVEWebServer  fest: EncryptionTemplate GeneralPurposeTemplate SignatureTemplate Erteilen Sie dem SCEPSvc-Benutzer die volle Berechtigung für MSCEP. Erweitern Sie im IIS-Manager die Zertifizierungsstelle, und klicken Sie anschließend auf  Anwendungspools . Klicken Sie im rechten Bereich auf  Neu starten , um den SCEP-Anwendungspool neu zu starten. Erweitern Sie die Zertifizierungsstelle im IIS-Manager, und erweitern Sie anschließend  Websites  Standard-Website . Klicken Sie im rechten Bereich auf  Neu starten . Einrichten von Zertifikatvorlagen für NDES Zertifikatvorlagen für NDES Einstellen"},{"UUID":"860f2e64-42ce-44bc-9ab8-10dbaf3050e2","title":"Konfigurieren von NDES für MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Deaktivieren von  Kennwort abfragen","descFull":"Deaktivieren von  Kennwort abfragen  im Microsoft CA-Server Starten Sie auf Ihrem Computer den Registry-Editor. Navigieren Sie zu  HKEY_LOCAL_MACHINE   SOFTWARE   Microsoft   Cryptography  MSCEP . Sellten Sie  EnforcePassword  auf  0  ein. Erweitern Sie die Zertifizierungsstelle im IIS-Manager, klicken Sie auf  Anwendungspools , und wählen Sie  SCEP  aus. Klicken Sie im rechten Bereich auf  Erweiterte Einstellungen . Setzen Sie  Benutzerprofil laden  auf  Wahr , und klicken Sie anschließend auf  OK . Klicken Sie im rechten Bereich auf  Neu starten , um den SCEP-Anwendungspool neu zu starten. Erweitern Sie die Zertifizierungsstelle im IIS-Manager, und erweitern Sie anschließend  Websites  Standard-Website . Klicken Sie im rechten Bereich auf  Neu starten . Beim Öffnen der NDES über den Webbrowser können Sie jetzt nur den CA-Fingerabdruck anzeigen lassen. Deaktivieren von  Kennwort abfragen  im Microsoft CA-Server Kennwort abfragen Deaktivieren in Microsoft CA-Server"},{"UUID":"3316a5fa-7d3d-4a8a-b62b-494c031e3fa4","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Systemvoraussetzungen Das Betriebssystem Windows Server","descFull":"Systemvoraussetzungen Das Betriebssystem Windows Server 2012 R2 wird für alle Einstellungen in diesem Abschnitt verwendet. Die folgenden Installationsanforderungen und -funktionen gelten für CEP und CES, sofern nicht anders angegeben. Erstellen Sie die folgenden Kontotypen im Domänen-Controller: Service-Administrator: Benannt als  CEPAdmin  und  CESAdmin Dieser Benutzer muss Teil der  lokalen Admin-Gruppe  auf den entsprechenden CEP- und CES-Servern sein. Dieser Benutzer muss Mitglied der  Unternehmensadmin -Gruppe sein. Dienstkonto: Benannt als  CEPSvc  und  CESSvc Dieser Benutzer muss Teil der  lokalen IIS_IUSRS -Gruppe sein. Erfordert die Berechtigung zum  Anfordern von Zertifikaten  auf der Zertifizierungsstelle für den entsprechenden  CEPSvc  und  CESSvc . Anforderungen System Systemvoraussetzungen"},{"UUID":"75d42a61-1921-4b22-96de-6cd9c874428e","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Anforderungen an die Netzwerkkonnektivität Die","descFull":"Anforderungen an die Netzwerkkonnektivität Die Anforderungen an die Netzwerkkonnektivität sind ein wichtiger Bestandteil des Deployment, insbesondere in Szenarien, in denen CEP und CES in einem Perimeter-Netzwerk gehostet werden. Die gesamte Clientverbindung zu beiden Diensten findet innerhalb einer HTTPS-Sitzung statt, sodass nur HTTPS-Datenverkehr zwischen dem Client und den Webdiensten zulässig ist. CEP kommuniziert mit Active Directory Domain Services (AD DS) über standardmäßige Lightweight Directory Access Protocol (LDAP)- und sichere LDAP (LDAPS)-Ports (TCP 389 bzw. 636). CES kommuniziert mit CA über DCOM (Distributed Component Object Model). Standardmäßig verwendet DCOM willkürliche flüchtige Ports. CA kann so konfiguriert werden, dass ein bestimmter Portbereich reserviert wird, um die Firewall-Konfiguration zu vereinfachen. Anforderungen Netzwerkkonnektivität Anforderungen an die Netzwerkkonnektivität Verbindungsanforderungen"},{"UUID":"9dc14bfc-75fb-4282-a540-804271790446","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Erstellen von SSL-Zertifikaten für CEP-","descFull":"Erstellen von SSL-Zertifikaten für CEP- und CES-Server CES und CEP müssen Secure Sockets Layer (SSL) für die Kommunikation mit Clients verwenden (über HTTPS). Jeder Dienst muss über ein gültiges Zertifikat verfügen, das über eine EKU-Richtlinie (Enhanced Key Usage) zur Serverauthentifizierung im lokalen Computerzertifikatsspeicher verfügt. Installieren Sie den IIS-Dienst auf dem Server. Melden Sie sich beim CEP-Server an, und fügen Sie dann das  Root-CA-Zertifikat  im Speicher der  Trusted-Root-Zertifizierungsstelle  hinzu. Starten Sie die  IIS-Verwaltungskonsole , und wählen Sie dann  Server-Startseite  aus. Öffnen Sie in der Hauptansicht die Datei  Serverzertifikate  aus. Klicken Sie auf  Aktionen Zertifikatsanforderung erstellen . Geben Sie im Fenster  Eigenschaften qualifizierter Verbindungsname  die erforderlichen Informationen ein und klicken Sie dann auf  Weiter . Wählen Sie im Dialogfeld  Eigenschaften Kryptografie-Serviceanbieter  die Bitlänge aus, und klicken Sie dann auf  Weiter . Speichern Sie die Datei. Lassen Sie die Datei von der Zertifizierungsstelle signieren, die Sie für CEP und CES verwenden möchten. Stellen Sie sicher, dass die  EKU der Serverauthentifizierung  im signierten Zertifikat aktiviert ist. Kopieren Sie die signierte Datei zurück auf den CEP-Server. Wählen Sie in der  IIS-Verwaltungskonsole  die Option  Server-Startseite  aus. Öffnen Sie im Abschnitt  Hauptansicht  die Option  Serverzertifikate . Klicken Sie auf  Aktionen Zertifikatsanforderung abschließen . Wählen Sie im Fenster  Antwort der Zertifizierungsstelle angeben  die signierte Datei aus. Geben Sie einen Namen ein, und wählen Sie dann im Menü  Zertifikatsspeicher  die Option  Persönlich aus. Schließen Sie die Zertifikatsinstallation ab. Wählen Sie in der  IIS-Verwaltungskonsole  die Standard-Website aus. Klicken Sie auf  Aktionen Bindungen . Klicken Sie im Dialogfeld  Websitebindungen  auf  Hinzufügen . Stellen Sie im Dialogfeld  Websitebindung hinzufügen  den  Typ  auf  https  ein, und suchen Sie dann im SSL-Zertifikat nach dem neu erstellten Zertifikat. Wählen Sie in der  IIS-Verwaltungskonsole  die Option  Standard-Website  aus, und öffnen Sie dann die SSL-Einstellungen. Aktivieren Sie  SSL erforderlich , und stellen Sie  Clientzertifikate  auf  Ignorieren  ein. Starten Sie IIS neu. Gehen Sie beim CES-Server genauso vor. CEP- und CES-Server Erstellen von SSL-Zertifikaten Erstellen von SSL-Zertifikaten CEP- und CES-Server SSL-Zertifikate Erstellen"},{"UUID":"3d21c386-a115-45b8-97b9-0959e9fee7d1","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority über MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Erstellen von Zertifikatsvorlagen Der Benutzer","descFull":"Erstellen von Zertifikatsvorlagen Der Benutzer muss eine Zertifikatsvorlage für die Zertifikatsregistrierung erstellen. Gehen Sie wie folgt vor, um aus einer vorhandenen Zertifikatsvorlage zu kopieren: Melden Sie sich bei der Enterprise CA mit den Anmeldeinformationen für den CA-Administrator an. Erweitern Sie die Zertifizierungsstelle, klicken Sie mit der rechten Maustaste auf  Zertifikatsvorlagen , und klicken Sie anschließend auf  Verwalten . Klicken Sie in der  Konsole der Zertifikatsvorlage  mit der rechten Maustaste auf  Webserver-Zertifikatsvorlage , und klicken Sie dann auf  Vorlage duplizieren . Geben Sie auf der Registerkarte  Allgemein  der Vorlage den Namen  MVEWebServer . Geben Sie auf der Registerkarte  Sicherheit  dem CA-Administrator  Lese -,  Schreib - und  Registrierungsberechtigungen . Erteilen Sie den authentifizierten Benutzern  Lese - und  Registrierungsberechtigungen . Wählen Sie auf der Registerkarte  Betreff-Name  die Option  In der Anfrage angeben  aus. Legen Sie auf der Registerkarte  Allgemein  den Gültigkeitszeitraum des Zertifikats fest. Wenn Sie diese Zertifikatsvorlage für die Ausgabe eines  802.1X-Zertifikats  für Drucker verwenden möchten, gehen Sie wie folgt vor: Wählen Sie auf der Registerkarte  Erweiterungen  die Option  Anwendungsrichtlinien  aus der Liste der Erweiterungen aus, die in dieser Vorlage enthalten sind. Klicken Sie auf  Bearbeiten Hinzufügen . Wählen Sie im Dialogfeld  Anwendungsrichtlinie hinzufügen  die Option  Clientauthentifizierung  aus. Klicken Sie auf  OK . Klicken Sie im Dialogfeld  Eigenschaften der Zertifikatsvorlage  auf  OK . Klicken Sie im CA-Fenster mit der rechten Maustaste auf  Zertifikatsvorlagen , und klicken Sie dann auf  Neue Zertifikatsvorlage . Wählen Sie  MVEWebServer  aus und klicken Sie auf  OK . Zertifikatsvorlagen Erstellen von Zertifikatsvorlagen"},{"UUID":"302c6e0f-5a1c-4595-9142-d8650f3906b0","title":"Überblick über die Authentifizierungsmethoden","link":"managing-certificates-using-MSCEWS-group.html","desc":"CEP und CES unterstützen die","descFull":"CEP und CES unterstützen die folgenden Authentifizierungsmethoden: Integrierte Windows‑Authentifizierung, auch bekannt als  Kerberos-Authentifizierung Clientzertifikat-Authentifizierung, auch bekannt als  X.509-Zertifikatsauthentifizierung Authentifizierung mit Benutzername und Kennwort Authentifizierungsmethoden"},{"UUID":"82a11954-e068-4349-b23c-783126227628","title":"Überblick über die Authentifizierungsmethoden","link":"managing-certificates-using-MSCEWS-group.html","desc":"Integrierte Windows-Authentifizierung Die integrierte Windows-Authentifizierung","descFull":"Integrierte Windows-Authentifizierung Die integrierte Windows-Authentifizierung verwendet Kerberos, um einen ununterbrochenen Authentifizierungsfluss für Geräte bereitzustellen, die mit dem internen Netzwerk verbunden sind. Diese Methode wird für interne Deployments bevorzugt, da sie die vorhandene Kerberos-Infrastruktur in AD DS verwendet. Außerdem sind minimale Änderungen an den Clientcomputern für Zertifikate erforderlich. Verwenden Sie diese Authentifizierungsmethode, wenn Clients  nur  auf den Webdienst zugreifen müssen, während sie direkt mit Ihrem internen Netzwerk verbunden sind. Integrierte Windows-Authentifizierung Authentifizierung Integrierte Windows-"},{"UUID":"dcf95493-82c5-4d09-ba81-146e1be52f0a","title":"Überblick über die Authentifizierungsmethoden","link":"managing-certificates-using-MSCEWS-group.html","desc":"Clientzertifikat-Authentifizierung Diese Methode wird gegenüber","descFull":"Clientzertifikat-Authentifizierung Diese Methode wird gegenüber der Authentifizierung mit Benutzername und Kennwort bevorzugt, da sie sicherer ist. Es ist keine direkte Verbindung zum Unternehmensnetzwerk erforderlich. Verwenden Sie diese Authentifizierungsmethode, wenn Sie Clients digitale X.509-Zertifikate zur Authentifizierung bereitstellen möchten. Mit dieser Methode werden die im Internet verfügbaren Webdienste aktiviert. Clientzertifikat-Authentifizierung Authentifizierung Clientzertifikat-"},{"UUID":"7100eea7-0684-41a7-ab3e-c7fd1948e1cf","title":"Überblick über die Authentifizierungsmethoden","link":"managing-certificates-using-MSCEWS-group.html","desc":"Authentifizierung mithilfe von Benutzername und","descFull":"Authentifizierung mithilfe von Benutzername und Kennwort Die Methode mit Benutzername und Kennwort ist die einfachste Form der Authentifizierung. Diese Methode wird in der Regel für Clients verwendet, die nicht direkt mit dem internen Netzwerk verbunden sind. Die Authentifizierungsoption ist weniger sicher als die Clientzertifikat-Authentifizierung, erfordert jedoch keine Bereitstellung eines Zertifikats. Verwenden Sie diese Authentifizierungsmethode, wenn Sie über das interne Netzwerk oder über das Internet auf den Webdienst zugreifen können. Authentifizierung mithilfe von Benutzername und Kennwort Authentifizierung mithilfe von Benutzername und Kennwort"},{"UUID":"3ec8da8a-912e-469f-8d39-11de332cc6ec","title":"Delegationsanforderungen","link":"managing-certificates-using-MSCEWS-group.html","desc":"Durch eine Delegation kann ein","descFull":"Durch eine Delegation kann ein Dienst die Identität eines Benutzer- oder Computerkontos für den Zugriff auf Ressourcen im gesamten Netzwerk annehmen. Eine Delegation ist für den CES-Server erforderlich, wenn alle folgenden Szenarien zutreffen: CA und CES befinden sich nicht auf demselben Computer. CES kann anfängliche Anmeldeanforderungen verarbeiten, anstatt nur Verlängerungsanfragen für Zertifikate zu verarbeiten. Der Authentifizierungstyp ist auf  integrierte Windows-Authentifizierung  oder  Clientzertifikat-Authentifizierung eingestellt. In den folgenden Szenarien ist für den CES-Server keine Delegation erforderlich: CA und CES befinden sich auf demselben Computer. Benutzername und Kennwort sind die Authentifizierungsmethode. Microsoft empfiehlt, CEP und CES als Domänenbenutzerkonten auszuführen. Benutzer müssen einen geeigneten Service Principal Name (SPN) erstellen, bevor sie die Delegation auf dem Domainbenutzerkonto konfigurieren. Delegation Anforderungen Delegationsanforderungen"},{"UUID":"f9a0f538-d033-4d85-bcea-0bf9d478587b","title":"Delegationsanforderungen","link":"managing-certificates-using-MSCEWS-group.html","desc":"Ermöglichen der Delegation Um eine","descFull":"Ermöglichen der Delegation Um eine SPN für ein Domänenbenutzerkonto zu erstellen, verwenden Sie den Befehl  setspn  wie folgt: setspn -s http/ces.msca.com msca\\CESSvc Der Kontoname lautet CESSvc. CES wird auf einem Computer mit einem vollqualifizierten Domänennamen (FQDN) von  ces.msca.com  in der Domäne msca.com ausgeführt. Öffnen Sie das CESSvc-Domänen-Benutzerkonto im Domänencontroller. Wählen Sie auf der Registerkarte  Delegation  die Option  Diesem Benutzer nur für die Delegation an bestimmte Dienste vertrauen  aus. Wählen Sie die geeignete Delegation basierend auf der Authentifizierungsmethode aus. Wenn Sie die integrierte Windows-Authentifizierung auswählen, konfigurieren Sie die Delegation so, dass  nur Kerberos  verwendet wird. Wenn der Dienst die Clientzertifikat-Authentifizierung verwendet, konfigurieren Sie die Delegation so, dass ein beliebiges Authentifizierungsprotokoll verwendet wird. Wenn Sie mehrere Authentifizierungsmethoden konfigurieren möchten, konfigurieren Sie die Delegation für die Verwendung eines beliebigen Authentifizierungsprotokolls. Klicken Sie auf  Hinzufügen . Wählen Sie im Dialogfeld  Dienste hinzufügen Benutzer  oder  Computer  aus. Geben Sie den Hostnamen des CA-Servers ein, und klicken Sie dann auf  Namen prüfen . Wählen Sie im Dialogfeld  Dienste hinzufügen  einen der folgenden Dienste aus, die delegiert werden sollen: Hostservice (HOST) für diesen CA-Server Remote Procedure Call System Service (RPCSS) für diesen CA-Server Schließen Sie das Dialogfeld „Domänenbenutzereigenschaften“. Für CEP-Domänenbenutzer, die die Windows-integrierte Authentifizierung verwenden, gehen Sie wie folgt vor: Um eine SPN für ein Domänenbenutzerkonto zu erstellen, verwenden Sie den Befehl  setspn  wie folgt: setspn -s http/cep.msca.com msca\\CEPSvc Der Kontoname lautet CESSvc. Öffnen Sie das CEPSvc-Domänenbenutzerkonto im Domänencontroller. Wählen Sie auf der Registerkarte  Delegation  die Option  Diesem Benutzer für die Delegation nicht vertrauen  aus. Delegation Aktivieren"},{"UUID":"54100ac5-49e2-4b42-abe8-d874c0667689","title":"Konfigurieren der integrierten Windows Authentifizierung","link":"managing-certificates-using-MSCEWS-group.html","desc":"Verwenden Sie Windows PowerShell, um","descFull":"Verwenden Sie Windows PowerShell, um CEP und CES zu installieren. CEP installieren CES installieren"},{"UUID":"80c9f0be-2330-497c-9c64-ef7cae3a6496","title":"Konfigurieren der integrierten Windows Authentifizierung","link":"managing-certificates-using-MSCEWS-group.html","desc":"CEP konfigurieren Das cmdlet ","descFull":"CEP konfigurieren Das cmdlet  Install-AdcsRegistrmentPolicyWebService  konfiguriert den Certificate Enrollment Policy Web Service (CEP). Es wird auch verwendet, um andere Instanzen des Dienstes innerhalb einer vorhandenen Installation zu erstellen. Melden Sie sich mit dem  CEPAdmin -Benutzernamen an, und starten Sie dann PowerShell im Administratormodus. Führen Sie den Befehl  Import-Module ServerManager  aus. Führen Sie den Befehl  Add-WindowsFeature Adcs-Enroll-Web-Pol  aus. Führen Sie den Befehl  Install-AdcsEnrollmentPolicyWebService -AuthenticationType Kerberos -SSLCertThumbprint \"sslCertThumbPrint\"  aus. Ersetzen Sie < sslCertThumbPrint > durch den Thumbprint des für den CEP-Server erstellten SSL-Zertifikats, nachdem Sie die Leerzeichen zwischen den Thumbprint-Werten gelöscht haben. Schließen Sie die Installation ab, indem Sie entweder  Y  oder  A  auswählen. Starten Sie die IIS-Verwaltungskonsole. Erweitern Sie im Bereich  Verbindungen  den Webserver, der CEP hostet. Erweitern Sie  Sites , erweitern Sie  Standard-Website , und klicken Sie dann auf den Namen der entsprechenden virtuellen Installationsanwendung  ADPolicyProvider_CEP_Kerberos . Doppelklicken Sie in der virtuellen Anwendung  Home  auf Anwendungseinstellungen, und doppelklicken Sie dann  auf FriendlyName . Geben Sie unter  Wert  einen Namen ein, und schließen Sie dann das Dialogfeld. Doppelklicken Sie auf  URI , und kopieren Sie dann  Wert . Wenn Sie eine andere Authentifizierungsmethode auf demselben CEP-Server konfigurieren möchten, müssen Sie die ID ändern. Diese URL wird in MVE oder einer beliebigen Clientanwendung verwendet. Klicken Sie im linken Bereich auf  Anwendungspools . Wählen Sie  WSEnrollmentPolicyServer  aus, und klicken Sie dann im rechten Bereich auf  Aktionen Erweiterte Einstellungen . Wählen Sie unter  Prozessmodell  das Identitätsfeld aus. Wählen Sie im Dialogfeld  Anwendungspool-Identität  das benutzerdefinierte Konto aus, und geben Sie dann  CEPSvc  als Domänenbenutzernamen ein. Schließen Sie alle Dialogfelder, und recyceln Sie dann IIS im rechten Bereich der  IIS-Verwaltungskonsole . Geben Sie in PowerShell  iisreset  ein, um IIS neu zu starten. CEP Konfigurieren CEP konfigurieren"},{"UUID":"f9749864-9cd6-40c6-b1ec-d6ea726043fa","title":"Konfigurieren der integrierten Windows Authentifizierung","link":"managing-certificates-using-MSCEWS-group.html","desc":"CES konfigurieren Das  Install-AdcsEnrollmentWebService","descFull":"CES konfigurieren Das  Install-AdcsEnrollmentWebService  cmdlet konfiguriert  den Certificate Enrollment Web Service (CES). Es wird auch verwendet, um andere Instanzen des Dienstes innerhalb einer vorhandenen Installation zu erstellen. Melden Sie sich mit dem  CESAdmin -Benutzernamen beim CES-Server an, und starten Sie dann PowerShell im Administratormodus. Führen Sie den Befehl  Import-Module ServerManager  aus. Führen Sie den Befehl  Add-WindowsFeature Adcs-Enroll-Web-Svc  aus. Führen Sie den Befehl  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig \"CA1.contoso.com\\contoso-CA1-CA\" -SSLCertThumbprint \"sslCertThumbPrint\" -AuthenticationType Kerberos  aus. Ersetzen Sie < sslCertThumbPrint > durch den Thumbprint des für den CES-Server erstellten SSL-Zertifikats, nachdem Sie die Leerzeichen zwischen den Thumbprint-Werten gelöscht haben. Ersetzen Sie  CA1.contoso.com  durch den CA-Computernamen. Ersetzen Sie  contoso-CA1-CA  durch den gemeinsamen CA-Namen. Schließen Sie die Installation ab, indem Sie entweder  Y  oder  A  auswählen. Starten Sie die IIS-Verwaltungskonsole. Erweitern Sie im Bereich  Verbindungen  den Webserver, der CES hostet. Erweitern Sie  Sites , erweitern Sie  Standard-Website , und klicken Sie dann auf den Namen der entsprechenden virtuellen Installationsanwendung:  contoso-CA1-CA _CES_Kerberos . Klicken Sie im linken Bereich auf  Anwendungspools . Wählen Sie  WSEnrollmentServer  aus, und klicken Sie dann im rechten Bereich auf  Aktionen Erweiterte Einstellungen . Wählen Sie unter  Prozessmodell  das Identitätsfeld aus. Wählen Sie im Dialogfeld  Anwendungspool-Identität  das benutzerdefinierte Konto aus, und geben Sie dann  CESSvc  als Domänenbenutzernamen ein. Schließen Sie alle Dialogfelder und recyceln Sie dann IIS im rechten Bereich der  IIS-Verwaltungskonsole . Geben Sie in PowerShell  iisreset  ein, um IIS neu zu starten. Aktivieren Sie für CESSvc-Domänenbenutzer die Delegierung. Weitere Informationen finden Sie unter  . CES Konfigurieren CES konfigurieren"},{"UUID":"ee82108f-71c8-44e6-b6bd-b41d9b698e23","title":"Konfigurieren der Clientzertifikat-Authentifizierung","link":"managing-certificates-using-MSCEWS-group.html","desc":"CEP konfigurieren Das cmdlet ","descFull":"CEP konfigurieren Das cmdlet  Install-AdcsRegistrmentPolicyWebService konfiguriert CEP. Es wird auch verwendet, um andere Instanzen des Dienstes innerhalb einer vorhandenen Installation zu erstellen. Melden Sie sich mit dem  CEPAdmin -Benutzernamen an, und starten Sie dann PowerShell im Administratormodus. Führen Sie den Befehl  Import-Module ServerManager  aus. Führen Sie den Befehl  Add-WindowsFeature Adcs-Enroll-Web-Pol  aus. Führen Sie den Befehl  Install-AdcsEnrollmentPolicyWebService -AuthenticationType Certificate -SSLCertThumbprint \"sslCertThumbPrint\"  aus. Ersetzen Sie < sslCertThumbPrint > durch den Thumbprint des für den CEP-Server erstellten SSL-Zertifikats, nachdem Sie die Leerzeichen zwischen den Thumbprint-Werten gelöscht haben. Schließen Sie die Installation ab, indem Sie entweder  Y  oder  A  auswählen. Starten Sie die IIS-Verwaltungskonsole. Erweitern Sie im Bereich  Verbindungen  den Webserver, der CEP hostet. Erweitern Sie  Sites , erweitern Sie  Standard-Website , und klicken Sie dann auf den Namen der entsprechenden virtuellen Installationsanwendung  ADPolicyProvider_CEP_Certificate . Doppelklicken Sie in der virtuellen Anwendung  Home  auf Anwendungseinstellungen, und doppelklicken Sie dann  auf FriendlyName . Geben Sie unter  Wert  einen Namen ein, und schließen Sie das Dialogfeld. Doppelklicken Sie auf  URI , und kopieren Sie dann  Wert . Wenn Sie eine andere Authentifizierungsmethode auf demselben CEP-Server konfigurieren möchten, müssen Sie die ID ändern. Diese URL wird in MVE oder einer beliebigen Clientanwendung verwendet. Klicken Sie im linken Bereich auf  Anwendungspools . Wählen Sie  WSEnrollmentPolicyServer  aus, und klicken Sie dann im rechten Bereich auf  Aktionen Erweiterte Einstellungen . Wählen Sie unter  Prozessmodell  das Identitätsfeld aus. Wählen Sie im Dialogfeld  Anwendungspool-Identität  das benutzerdefinierte Konto aus, und geben Sie dann  CEPSvc  als Domänenbenutzernamen ein. Schließen Sie alle Dialogfelder, und recyceln Sie dann IIS im rechten Bereich der  IIS-Verwaltungskonsole . Geben Sie in PowerShell  iisreset  ein, um IIS neu zu starten. CEP Konfigurieren CEP konfigurieren"},{"UUID":"f9a7bfee-b474-407c-a508-ecd81d8cc41a","title":"Konfigurieren der Clientzertifikat-Authentifizierung","link":"managing-certificates-using-MSCEWS-group.html","desc":"CES konfigurieren Das  Install-AdcsEnrollmentWebService","descFull":"CES konfigurieren Das  Install-AdcsEnrollmentWebService  cmdlet konfiguriert  den Certificate Enrollment Web Service (CES). Es wird auch verwendet, um andere Instanzen des Dienstes innerhalb einer vorhandenen Installation zu erstellen. Melden Sie sich mit dem  CESAdmin -Benutzernamen beim CES-Server an, und starten Sie dann PowerShell im Administratormodus. Führen Sie den Befehl  Import-Module ServerManager  aus. Führen Sie den Befehl  Add-WindowsFeature Adcs-Enroll-Web-Svc  aus. Führen Sie den Befehl  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig \"CA1.contoso.com\\contoso-CA1-CA\" -SSLCertThumbprint \"sslCertThumbPrint\" -AuthenticationType Certificate  aus. Ersetzen Sie < sslCertThumbPrint > durch den Thumbprint des für den CES-Server erstellten SSL-Zertifikats, nachdem Sie die Leerzeichen zwischen den Thumbprint-Werten gelöscht haben. Ersetzen Sie  CA1.contoso.com  durch den CA-Computernamen. Ersetzen Sie  contoso-CA1-CA  durch den gemeinsamen CA-Namen. Wenn Sie bereits eine Authentifizierungsmethode auf dem Host konfiguriert haben, entfernen Sie  ApplicationPoolIdentity  aus dem Befehl. Schließen Sie die Installation ab, indem Sie entweder  Y  oder  A  auswählen. Starten Sie die IIS-Verwaltungskonsole. Erweitern Sie im Bereich  Verbindungen  den Webserver, der CEP hostet. Erweitern Sie  Sites , erweitern Sie  Standard-Website , und klicken Sie dann auf den Namen der entsprechenden virtuellen Installationsanwendung:  contoso-CA1-CA _CES_Certificate . Klicken Sie im linken Bereich auf  Anwendungspools . Wählen Sie  WSEnrollmentServer  aus und klicken Sie dann im rechten Bereich auf  Aktionen Erweiterte Einstellungen . Wählen Sie unter  Prozessmodell  das Identitätsfeld aus. Wählen Sie im Dialogfeld  Anwendungspool-Identität  das benutzerdefinierte Konto aus, und geben Sie dann  CESSvc  als Domänenbenutzernamen ein. Schließen Sie alle Dialogfelder und recyceln Sie dann IIS im rechten Bereich der  IIS-Verwaltungskonsole . Geben Sie in PowerShell  iisreset  ein, um IIS neu zu starten. Aktivieren Sie für CESSvc-Domänenbenutzer die Delegierung. Weitere Informationen finden Sie unter  . CES Konfigurieren CES konfigurieren"},{"UUID":"1b20451b-cc8c-4652-8724-7160ce711f3c","title":"Konfigurieren der Clientzertifikat-Authentifizierung","link":"managing-certificates-using-MSCEWS-group.html","desc":"Erstellen eines Clientzertifikats Öffnen Sie","descFull":"Erstellen eines Clientzertifikats Öffnen Sie von einem beliebigen Domänenbenutzerkonto aus  certlm.msc . Klicken Sie auf  Zertifikate Persönlich Zertifikate Alle Aufgaben Neues Zertifikat anfordern . Klicken Sie auf  Weiter . Klicken Sie auf  Active Directory-Registrierung Clientzugriff . Gehen Sie wie folgt vor, wenn Sie die Optionen zur  Active Directory-Registrierung  nicht verwenden möchten: Klicken Sie auf  Von mir konfiguriert Neue hinzufügen . Geben Sie den Enrollment Policy Server-URI als CEP-Serveradresse für Username_Password oder die Kerberos-Authentifizierung ein. Wählen Sie als Authentifizierungstyp  Integrierte Windows-Authentifizierung aus. Klicken Sie auf  Server validieren . Klicken Sie nach der erfolgreichen Validierung auf  Hinzufügen . Klicken Sie auf  Weiter . Wählen Sie eine beliebige Vorlage aus. Klicken Sie auf  Details Eigenschaften . Klicken Sie auf  Integrieren . Geben Sie auf der Registerkarte  Betreff  einen vollständigen Domänennamen (FQDN) an. Wählen Sie auf der Registerkarte  Privater Schlüssel  die Option  Privaten Schlüssel exportierbar machen . Klicken Sie auf  Anwenden Integrieren . Führen Sie nach der Registrierung des Clientzertifikats die folgenden Schritte aus, um das Clientzertifikat im PFX-Format zu exportieren. Klicken Sie auf  Zertifikat Alle Aufgaben Exportieren . Klicken Sie auf  Weiter Ja, privaten Schlüssel exportieren . Klicken Sie auf  Weiter . Geben Sie das vom Client bereitgestellte Kennwort ein. Klicken Sie auf  Weiter . Geben Sie den Dateinamen im Dialogfeld  Zertifikatexport  an. Klicken Sie auf  Weiter Fertig stellen . Clientzertifikat- Erstellen eines Clientzertifikats"},{"UUID":"cb5189db-1e2c-4e78-89db-9890985dd30d","title":"Konfigurieren der Authentifizierung mit Benutzername und Kennwort","link":"managing-certificates-using-MSCEWS-group.html","desc":"CEP konfigurieren Das cmdlet ","descFull":"CEP konfigurieren Das cmdlet  Install-AdcsRegistrmentPolicyWebService  konfiguriert den Certificate Enrollment Policy Web Service (CEP). Es wird auch verwendet, um andere Instanzen des Dienstes innerhalb einer vorhandenen Installation zu erstellen. Melden Sie sich mit dem  CEPAdmin -Benutzernamen an, und starten Sie dann PowerShell im Administratormodus. Führen Sie den Befehl  Import-Module ServerManager  aus. Führen Sie den Befehl  Add-WindowsFeature Adcs-Enroll-Web-Pol  aus. Führen Sie den Befehl  Install-AdcsEnrollmentPolicyWebService -AuthenticationType UserName -SSLCertThumbprint \"sslCertThumbPrint\"  aus. Ersetzen Sie < sslCertThumbPrint > durch den Thumbprint des für den CEP-Server erstellten SSL-Zertifikats, nachdem Sie die Leerzeichen zwischen den Thumbprint-Werten gelöscht haben. Schließen Sie die Installation ab, indem Sie entweder  Y  oder  A  auswählen. Starten Sie die IIS-Verwaltungskonsole. Erweitern Sie im Bereich  Verbindungen  den Webserver, der CEP hostet. Erweitern Sie  Sites , erweitern Sie  Standard-Website , und klicken Sie dann auf den Namen der entsprechenden virtuellen Installationsanwendung:  ADPolicyProvider_CEP_UsernamePassword . Doppelklicken Sie in der virtuellen Anwendung  Home  auf Anwendungseinstellungen, und doppelklicken Sie dann  auf FriendlyName . Geben Sie unter  Wert  einen Namen ein, und schließen Sie das Dialogfeld. Doppelklicken Sie auf  URI , und kopieren Sie dann  Wert . Wenn Sie eine andere Authentifizierungsmethode auf demselben CEP-Server konfigurieren möchten, müssen Sie die ID ändern. Diese URL wird in MVE oder einer beliebigen Clientanwendung verwendet. Klicken Sie im linken Bereich auf  Anwendungspools . Wählen Sie  WSEnrollmentPolicyServer  aus, und klicken Sie dann im rechten Bereich auf  Aktionen Erweiterte Einstellungen . Wählen Sie unter  Prozessmodell  das Identitätsfeld aus. Wählen Sie im Dialogfeld  Anwendungspool-Identität  das benutzerdefinierte Konto aus, und geben Sie dann  CEPSvc  ein. Schließen Sie alle Dialogfelder, und recyceln Sie dann IIS im rechten Bereich der  IIS-Verwaltungskonsole . Geben Sie in PowerShell  iisreset  ein, um IIS neu zu starten. CEP Konfigurieren CEP konfigurieren"},{"UUID":"ed236d2c-c977-4805-9975-c10efb23340c","title":"Konfigurieren der Authentifizierung mit Benutzername und Kennwort","link":"managing-certificates-using-MSCEWS-group.html","desc":"CES konfigurieren Das  Install-AdcsEnrollmentWebService","descFull":"CES konfigurieren Das  Install-AdcsEnrollmentWebService  cmdlet konfiguriert  den Certificate Enrollment Web Service (CES). Es wird auch verwendet, um andere Instanzen des Dienstes innerhalb einer vorhandenen Installation zu erstellen. Melden Sie sich mit dem  CESAdmin -Benutzernamen beim CES-Server an, und starten Sie dann PowerShell im Administratormodus. Führen Sie den Befehl  Import-Module ServerManager  aus. Führen Sie den Befehl  Add-WindowsFeature Adcs-Enroll-Web-Svc  aus. Führen Sie den Befehl  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig \"CA1.contoso.com\\contoso-CA1-CA\" -SSLCertThumbprint \"sslCertThumbPrint\" -AuthenticationType UserName  aus. Ersetzen Sie < sslCertThumbprint > durch den Thumbprint des für den CES-Server erstellten SSL-Zertifikats, nachdem Sie die Leerzeichen zwischen den Thumbprint-Werten gelöscht haben. Ersetzen Sie  CA1.contoso.com  durch den CA-Computernamen. Ersetzen Sie  contoso-CA1-CA  durch den gemeinsamen CA-Namen. Wenn Sie bereits eine Authentifizierungsmethode auf dem Host konfiguriert haben, entfernen Sie  ApplicationPoolIdentity  aus dem Befehl. Schließen Sie die Installation ab, indem Sie entweder  Y  oder  A  auswählen. Starten Sie die IIS-Verwaltungskonsole. Erweitern Sie im Bereich  Verbindungen  den Webserver, der CES hostet. Erweitern Sie  Sites , erweitern Sie  Standard-Website , und klicken Sie dann auf den Namen der entsprechenden virtuellen Installationsanwendung:  contoso-CA1-CA_CES_UsernamePassword . Klicken Sie im linken Bereich auf  Anwendungspools . Wählen Sie  WSEnrollmentServer  aus und klicken Sie dann im rechten Bereich unter  Aktionen  auf  Aktionen Erweiterte Einstellungen . Wählen Sie unter  Prozessmodell  das Identitätsfeld aus. Wählen Sie im Dialogfeld  Anwendungspool-Identität  das benutzerdefinierte Konto aus, und geben Sie dann  CESSvc  als Domänenbenutzernamen ein. Schließen Sie alle Dialogfelder und recyceln Sie dann IIS im rechten Bereich der  IIS-Verwaltungskonsole . Geben Sie in PowerShell  iisreset  ein, um IIS neu zu starten. CES Konfigurieren CES konfigurieren"},{"UUID":"f666d7a8-ed5e-4ce6-bdf0-592b0d6463b9","title":"Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Installieren von OpenXPKI CA Verbinden","descFull":"Installieren von OpenXPKI CA Verbinden Sie den Computer mit PuTTY oder einem anderen Client. Führen Sie auf dem Client den Befehl  sudo su -  aus, um zum Root-Benutzer zu gelangen. Geben Sie das Root-Kennwort ein. Ändern Sie in  nano /etc/apt/sources.list  die Quelle zum Installieren der Updates. Aktualisieren Sie die Datei. Beispiel: #\n\n# deb cdrom:[Debian GNU/Linux 8.11.1 _Jessie_ - Official amd64 CD Binary-1 20190211-02:10]/ jessie local main\n# deb cdrom:[Debian GNU/Linux 8.11.1 _Jessie_ - Official amd64 CD Binary-1 20190211-02:10]/ jessie local main\n\ndeb http://security.debian.org/ jessie/updates main\ndeb-src http://security.debian.org/ jessie/updates main\n\n# jessie-updates, previously known as 'volatile'\n# A network mirror was not selected during install.  The following entries\n# are provided as examples, but you should amend them as appropriate\n# for your mirror of choice.\n#\ndeb http://ftp.debian.org/debian/jessie-updates main\ndeb-src http://ftp.debian.org/debian/jessie-updates main\ndeb http://ftp.us.debian.org/debian/jessie main\n Speichern Sie die Datei. Führen Sie die folgenden Befehle aus: apt-get Update apt-get Upgrade Aktualisieren Sie die CA-Zertifikatlisten auf dem Server mit  apt-get install ca-certificates . Installieren Sie  en_US.utf8 locale  mit  dpkg-reconfigure locales . Wählen Sie das Gebietsschema  en_US.UTF-8 UTF-8  aus, und machen Sie es anschließend zum standardmäßigen Gebietsschema für das System. Verwenden Sie die Tabulatortaste und die Leertaste zum Auswählen und Navigieren im Menü. Prüfen Sie die Gebietsschemas, die Sie mit  locale –a  generiert haben. Beispielausgabe C\nC.UTF-8\nen_IN\nen_IN.utf8\nen_US.utf8\nPOSIX Kopieren Sie den Fingerabdruck des OpenXPKI-Pakets mit  nano /home/Release.key . Kopieren Sie den Schlüssel beispielsweise in  /home . Geben Sie  9B156AD0 F0E6A6C7 86FABE7A D8363C4E 1611A2BE 2B251336 01D1CDB4 6C24BEF3  als Wert ein. Führen Sie den folgenden Befehl aus: gpg --print-md sha256 /home/Release.key Fügen Sie das Paket mit dem Befehl  wget https://packages.openxpki.org/v2/debian/Release.key -O - | apt-key add -  hinzu. Fügen Sie das Repository mit  echo \"deb http://packages.openxpki.org/v2/debian/jessie release\" > /etc/apt/sources.list.d/openxpki.list  und anschließend  aptitude update  zu Ihrer Quellenliste (jessie) hinzu. Installieren Sie MySQL und Perl MySQL-Binding mit  aptitude install mysql-server libdbd-mysql-perl . Installieren Sie apache2.2-common mit  aptitude install apache2.2-common . Installieren Sie in  nano /etc/apt/sources.list  das fastcgi-Modul, um die Benutzeroberfläche zu beschleunigen. Wir empfehlen die Verwendung von  mod_fcgid . Fügen Sie die Zeile  deb http://http.us.debian.org/debian/jessie main  in der Datei hinzu, und speichern Sie sie. Führen Sie die folgenden Befehle aus: apt-get Update aptitude install libapache2-mod-fcgid Aktivieren Sie das fastcgi-Modul mit  a2enmod fcgid . Installieren Sie das OpenXPKI-Kernpaket mit  aptitude install libopenxpki-perl openxpki-cgi-session-driver openxpki-i18n . Starten Sie den  Apache  Server mit  service apache2 restart  neu. Prüfen Sie mit  openxpkiadm version , ob die Installation erfolgreich war. Wenn die Installation erfolgreich war, zeigt das System die Version der installierten OpenXPKI an. Beispiel:  Version (core): 2.5.5 . Erstellen Sie die leere Datenbank, und weisen Sie anschließend den Datenbankbenutzer mit  mysql -u root –p  zu. Dieser Befehl muss in den Client eingegeben werden. Andernfalls können Sie das Kennwort nicht eingeben. Geben Sie das Passwort für MySQL ein. In diesem Beispiel ist  root  der MySQL-Benutzer. openxpki  ist der Benutzer, auf dem OpenXPKI installiert ist. CREATE DATABASE openxpki CHARSET utf8; \nCREATE USER 'openxpki'@'localhost' IDENTIFIED BY 'openxpki';\nGRANT ALL ON openxpki.* TO 'openxpki'@'localhost';\nflush privileges; Wenn der MySQL-Service nicht läuft, führen Sie  /etc/init.d/mysql start  aus, um den Service zu starten. Geben Sie  quit  ein, um MySQL zu beenden. Speichern Sie die verwendeten Zugangsdaten in  /etc/openxpki/config.d/system/database.yaml . Beispielhafter Datei-Inhalt debug: 0\ntype: MySQL\nname: openxpki\nhost: localhost\nport: 3306\nuser: openxpki \npasswd: openxpki Ändern Sie  user  und  passwd  so, dass sie mit dem MySQL-Benutzernamen und -Kennwort übereinstimmen. Speichern Sie die Datei. Führen Sie für ein leeres Datenbankschema  zcat /usr/share/doc/libopenxpki-perl/examples/schema-mysql.sql.gz | \\mysql -u root --password --database openxpki  aus der bereitgestellten Schemadatei aus. Geben Sie das Kennwort für die Datenbank ein. Installieren von OpenXPKI CA XPKI CA öffnen Installieren"},{"UUID":"8ae46bd6-ed5f-4525-9fcb-b773fa5e3429","title":"Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Konfigurieren von OpenXPKI CA mit","descFull":"Konfigurieren von OpenXPKI CA mit Standardskript Das Standardskript konfiguriert nur den Standardbereich  ca-one . CDP und CRLs sind nicht konfiguriert. Entpacken Sie das Beispielskript für die Installation des Zertifikats mit  gunzip -k /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh.gz . Führen Sie das Skript mit  bash /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh  aus. Bestätigen Sie das Setup mit  openxpkiadm alias --realm ca-one . Beispielausgabe === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set Prüfen Sie mit  openxpkictl start , ob die Installation erfolgreich war. Beispielausgabe Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Gehen Sie folgendermaßen vor, um auf den OpenXPKI-Server zuzugreifen: Geben Sie in einem Webbrowser  http://ipaddress/openxpki/  ein. Melden Sie sich als  Bediener  an. Das Standardkennwort lautet  openxpki . Die Bedieneranmeldung hat zwei vorkonfigurierte Bedienerkonten,  raop  und  raop2 . Erstellen Sie eine Zertifikatsanforderung, und testen Sie sie. Konfigurieren von OpenXPKI CA mit Standardskript XPKI CA öffnen Konfigurieren mit Standardskript"},{"UUID":"d4714357-6e31-41d7-983b-e24e604f8503","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Übersicht Stellen Sie zu Beginn","descFull":"Übersicht Stellen Sie zu Beginn sicher, dass Sie über die grundlegenden Kenntnisse für das Erstellen von OpenSSL-Zertifikaten verfügen. Erstellen Sie zum manuellen Konfigurieren der OpenXPKI CA Folgendes: Root-CA-Zertifikat Weitere Informationen finden Sie unter  . CA-Signaturgeberzertifikat, signiert von der Root-CA. Weitere Informationen finden Sie unter  . Datentresorzertifikat, selbstsigniert. Weitere Informationen finden Sie unter  . SCEP-Zertifikat, vom Signaturgeberzertifikat signiert. Verwenden Sie bei der Auswahl des Signatur-Hash entweder SHA256 oder SHA512. Die Änderung der Größe des öffentlichen Schlüssels ist optional. In diesem Fall verwenden wir das Verzeichnis  /etc/certs/openxpki_ca-one/  zur Zertifikatgenerierung. Sie können jedoch jedes beliebige Verzeichnis verwenden. Manuelles Konfigurieren von OpenXPKI CA XPKI CA öffnen Manuell konfigurieren"},{"UUID":"1dbdddb8-2cb4-4734-baad-98f09d957d24","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Erstellen einer OpenSSL-Konfigurationsdatei Führen Sie","descFull":"Erstellen einer OpenSSL-Konfigurationsdatei Führen Sie den folgenden Befehl aus: nano /etc/certs/openxpki_ca-one/openssl.conf Wenn Ihr Server unter Verwendung des FQDN (Fully Qualified Domain Name) erreichbar ist, verwenden Sie den DNS des Servers anstelle seiner IP-Adresse. Beispieldatei # x509_extensions               = v3_ca_extensions\n# x509_extensions               = v3_issuing_extensions\n# x509_extensions               = v3_datavault_extensions\n# x509_extensions               = v3_scep_extensions\n# x509_extensions               = v3_web_extensions\n# x509_extensions               = v3_ca_reqexts # not for root self-signed, only for issuing\n## x509_extensions              = v3_datavault_reqexts # not required self-signed\n# x509_extensions               = v3_scep_reqexts\n# x509_extensions               = v3_web_reqexts\n\n[ req ]\ndefault_bits            = 4096\ndistinguished_name      = req_distinguished_name\n\n[ req_distinguished_name ]\ndomainComponent         = Domain Component\ncommonName              = Common Name\n\n[ v3_ca_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\n\n[ v3_datavault_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\n\n[ v3_scep_reqexts ]\nsubjectKeyIdentifier    = hash\n\n[ v3_web_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\n\n[ v3_ca_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_issuing_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer:always\ncrlDistributionPoints   = URI:http://FQDN of the server/CertEnroll/MYOPENXPKI.crl\nauthorityInfoAccess     = caIssuers;URI:http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\n\n[ v3_datavault_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_scep_extensions ]\nsubjectKeyIdentifier    = hash\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid,issuer\n\n[ v3_web_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\nbasicConstraints        = critical,CA:FALSE\nsubjectAltName          = DNS:stlopenxpki.lexmark.com\ncrlDistributionPoints   = URI:http://FQDN of the server/CertEnroll/MYOPENXPKI_ISSUINGCA.crl\nauthorityInfoAccess     = caIssuers;URI:http://FQDN of the server/CertEnroll/MYOPENXPKI_ISSUINGCA.crt\n Ändern Sie die IP-Adresse und den CA-Zertifikatnamen mit den Setup-Informationen. Speichern Sie die Datei. Erstellen von OpenSSL-Konfigurationsdateien OpenSSL-Konfigurationsdatei Erstellen"},{"UUID":"e0c65426-c652-44c1-bd19-e27162cfebf5","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Erstellen einer Kennwortdatei für Zertifikatschlüssel","descFull":"Erstellen einer Kennwortdatei für Zertifikatschlüssel Führen Sie den folgenden Befehl aus: nano /etc/certs/openxpki_ca-one/pd.pass Geben Sie Ihr Kennwort ein. Speichern Sie die Datei. Erstellen von Kennwortdateien für Zertifikatschlüssel Kennwortdateien für Zertifikatschlüssel Erstellen Zertifikatschlüssel Erstellen von Kennwortdateien"},{"UUID":"b386938b-5290-4d1f-831e-50b75e8de808","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Erstellen eines Root-CA-Zertifikats Sie können","descFull":"Erstellen eines Root-CA-Zertifikats Sie können ein selbstsigniertes Root-CA-Zertifikat erstellen oder eine Zertifikatsanforderung generieren und diese anschließend von der Root-CA signieren lassen. Führen Sie die folgenden Befehle aus: Ersetzen Sie die Schlüssellänge, den Signaturalgorithmus und den Zertifikatnamen durch die entsprechenden Werte. openssl genrsa -out /etc/certs/openxpki_ca-one/ca-root-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 openssl req -new -key /etc/certs/openxpki_ca-one/ca-root-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ROOTCA -out /etc/certs/openxpki_ca-one/ca-root-1.csr openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_ca_extensions -x509 -days 3560 -in /etc/certs/openxpki_ca-one/ca-root-1.csr -key /etc/certs/openxpki_ca-one/ca-root-1.key -out /etc/certs/openxpki_ca-one/ca-root-1.crt -sha256 Erstellen von Root-CA-Zertifikaten Root-CA-Zertifikate Erstellen"},{"UUID":"3253d01d-de19-4054-a9bb-8e725b5280a2","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Erstellen eines Signaturgeberzertifikats Ersetzen Sie","descFull":"Erstellen eines Signaturgeberzertifikats Ersetzen Sie die Schlüssellänge, den Signaturalgorithmus und den Zertifikatnamen durch die entsprechenden Werte. Führen Sie den folgenden Befehl aus: openssl genrsa -out /etc/certs/openxpki_ca-one/ca-signer-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 Ändern Sie den Betreff in der Anforderung mit Ihren CA-Informationen mit  openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_ca_reqexts -new -key /etc/certs/openxpki_ca-one/ca-signer-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ISSUINGCA -out /etc/certs/openxpki_ca-one/ca-signer-1.csr . Rufen Sie das von der Root-CA signierte Zertifikat mit  openssl x509 -req -extfile /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_issuing_extensions -days 3650 -in /etc/certs/openxpki_ca-one/ca-signer-1.csr -CA /etc/certs/openxpki_ca-one/ca-root-1.crt -CAkey /etc/certs/openxpki_ca-one/ca-root-1.key -CAcreateserial -out /etc/certs/openxpki_ca-one/ca-signer-1.crt -sha256  ab. Erstellen von Signaturgeberzertifikaten Signaturgeberzertifikate Erstellen"},{"UUID":"59756e71-56a7-4ed7-ad15-7696ca84a4f7","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Erstellen eines Tresorzertifikats Das Tresorzertifikat","descFull":"Erstellen eines Tresorzertifikats Das Tresorzertifikat ist selbstsigniert. Ersetzen Sie die Schlüssellänge, den Signaturalgorithmus und den Zertifikatnamen durch die entsprechenden Werte. Führen Sie den folgenden Befehl aus: openssl genrsa -out /etc/certs/openxpki_ca-one/vault-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 Ändern Sie den Betreff in Ihren CA-Informationen mit  openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_datavault_reqexts -new -key /etc/certs/openxpki_ca-one/vault-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/DC=STLOPENXPKI_INTERNAL/CN=MYOPENXPKI_DATAVAULT -out /etc/certs/openxpki_ca-one/vault-1.csr . Führen Sie den folgenden Befehl aus: openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_datavault_extensions -x509 -days 3560 -in /etc/certs/openxpki_ca-one/vault-1.csr -key /etc/certs/openxpki_ca-one/vault-1.key -out /etc/certs/openxpki_ca-one/vault-1.crt Erstellen von Tresorzertifikaten Tresorzertifikate Erstellen"},{"UUID":"a3d465c7-358d-49ea-ab6d-8a4ae264d883","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Erstellen eines SCEP-Zertifikats Das SCEP-Zertifikat","descFull":"Erstellen eines SCEP-Zertifikats Das SCEP-Zertifikat wird vom Signaturgeberzertifikat signiert. Führen Sie die folgenden Befehle aus: Ersetzen Sie die Schlüssellänge, den Signaturalgorithmus und den Zertifikatnamen durch die entsprechenden Werte. openssl genrsa -out /etc/certs/openxpki_ca-one/scep-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_scep_reqexts -new -key /etc/certs/openxpki_ca-one/scep-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_SCEPCA -out /etc/certs/openxpki_ca-one/scep-1.csr openssl x509 -req -extfile /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_scep_extensions -days 900 -in /etc/certs/openxpki_ca-one/scep-1.csr -CA /etc/certs/openxpki_ca-one/ca-signer-1.crt -CAkey /etc/certs/openxpki_ca-one/ca-signer-1.key -CAcreateserial -out /etc/certs/openxpki_ca-one/scep-1.crt -sha256 Erstellen von SCEP-Zertifikaten SCEP-Zertifikate Erstellen"},{"UUID":"33f9e705-587f-468a-b727-918da4dee759","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Kopieren der Schlüsseldatei und Erstellen","descFull":"Kopieren der Schlüsseldatei und Erstellen eines Symlinks Kopieren Sie die Schlüsseldateien nach  /etc/openxpki/ca/ca-one/ . Die Schlüsseldateien müssen von OpenXPKI gelesen werden können. cp /etc/certs/openxpki_ca-one/ca-signer-1.key /etc/openxpki/ca/ca-one/\n\ncp /etc/certs/openxpki_ca-one/vault-1.key /etc/openxpki/ca/ca-one/\n\ncp /etc/certs/openxpki_ca-one/scep-1.key /etc/openxpki/ca/ca-one/ Erstellen Sie den Symlink. Symlinks sind Aliase, die von der Standardkonfiguration verwendet werden. ln -s /etc/openxpki/ca/ca-one/ca-signer-1.key /etc/openxpki/ca/ca-one/ca-signer-1.pem\n\nln -s /etc/openxpki/ca/ca-one/scep-1.key /etc/openxpki/ca/ca-one/scep-1.pem\n\nln -s /etc/openxpki/ca/ca-one/vault-1.key /etc/openxpki/ca/ca-one/vault-1.pem Kopieren von Schlüsseldateien Erstellen von Symlinks Schlüsseldateien Kopieren Symlinks Erstellen"},{"UUID":"1809bd6e-3219-4c6f-8285-8424d014b7b3","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Importieren von Zertifikaten Importieren Sie","descFull":"Importieren von Zertifikaten Importieren Sie das Root-Zertifikat, das Signaturgeberzertifikat, das Tresorzertifikat und das SCEP-Zertifikat mit den entsprechenden Token in die Datenbank. Führen Sie die folgenden Befehle aus: openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/ca-root-1.crt openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/ca-signer-1.crt --realm ca-one --token certsign openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/scep-1.crt --realm ca-one --token scep openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/vault-1.crt --realm ca-one --token datasafe Prüfen Sie mit  openxpkiadm alias --realm ca-one , ob der Import erfolgreich war. Beispielausgabe === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set\n Importieren von Zertifikaten Zertifikate Importieren"},{"UUID":"b7da64cc-19c4-48a6-a5c4-219a07046e51","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Starten von OpenXPKI Führen Sie","descFull":"Starten von OpenXPKI Führen Sie den Befehl  openxpkictl start  aus. Beispielausgabe Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Gehen Sie folgendermaßen vor, um auf den OpenXPKI-Server zuzugreifen: Geben Sie in einem Webbrowser  http://ipaddress/openxpki/  ein. Anstelle von  ipaddress  können Sie auch den FQDN des Servers verwenden. Melden Sie sich als  Bediener  an. Das Standardkennwort lautet  openxpki . Die Bedieneranmeldung hat zwei vorkonfigurierte Bedienerkonten,  raop  und  raop2 . Erstellen Sie eine Zertifikatsanforderung, und testen Sie sie. Starten von OpenXPKI OpenXPKI Starten"},{"UUID":"59494fe5-f345-4438-be0d-c63989b6ac0c","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Generieren von CRL-Informationen Wenn Ihr","descFull":"Generieren von CRL-Informationen Wenn Ihr Server über FQDN erreichbar ist, verwenden Sie den DNS des Servers anstelle seiner IP-Adresse. Stoppen Sie den OpenXPKI-Service mit  Openxpkictl stop . Aktualisieren Sie in  nano /etc/openxpki/config.d/realm/ca-one/publishing.yaml  den Abschnitt  connectors: cdp  wie folgt: class: Connector::Builtin::File::Path\nLOCATION: /var/www/openxpki/CertEnroll/\nfile: \"[% ARGS.0 %].crl\"\ncontent: \"[% pem %]\" Aktualisieren Sie in  nano /etc/openxpki/config.d/realm/ca-one/profile/default.yaml  Folgendes: crl_distribution_points:  section critical: 0\nuri:\n    - http://FQDN of the server/CertEnroll/[% ISSUER.CN.0 %].crl\n    - ldap://localhost/[% ISSUER.DN %] authority_info_access:  section critical: 0\nca_issuers: http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\nocsp: http://ocsp.openxpki.org/ Ändern Sie die IP-Adresse und den CA-Zertifikatnamen entsprechend Ihrem CA-Server. Gehen Sie in  nano /etc/openxpki/config.d/realm/ca-one/crl/default.yaml  wie folgt vor: Aktualisieren Sie ggf.  nextupdate  und  renewal . Fügen Sie  ca_issuers  zum folgenden Abschnitt hinzu: extensions:\n    \t\tauthority_info_access:\n        \t\t\tcritical: 0\n        \t\t\t# ca_issuers and ocsp can be scalar or list\n        \t\t\tca_issuers: http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\n       \t\t\t#ocsp: http://ocsp.openxpki.org/\n Ändern Sie die IP-Adresse und den CA-Zertifikatnamen entsprechend Ihrem CA-Server. Starten Sie den OpenXPKI-Service mit  Openxpkictl start . Generieren von CRL-Informationen CRL-Informationen Erstellen"},{"UUID":"a01a0657-7d2e-4b8c-a2c1-7a79903e59be","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Konfigurieren der CRL-Zugänglichkeit Beenden Sie","descFull":"Konfigurieren der CRL-Zugänglichkeit Beenden Sie den Apache-Dienst mit  service apache2 stop . Erstellen Sie ein Verzeichnis  CertEnroll  für crl im Verzeichnis  /var/www/openxpki/ . Legen Sie  openxpki  als Eigentümer dieses Verzeichnisses fest, und konfigurieren Sie anschließend die Berechtigungen für das Lesen und Ausführen von Apache sowie für andere Dienste als schreibgeschützt. chown openxpki /var/www/openxpki/CertEnroll chmod 755 /var/www/openxpki/CertEnroll Fügen Sie eine Referenz zur Apache-Datei alias.conf mit  nano /etc/apache2/mods-enabled/alias.conf  hinzu. Fügen Sie nach dem Abschnitt  <Directory \"/usr/share/apache2/icons\">  Folgendes hinzu:         \tAlias /CertEnroll/ \"/var/www/openxpki/CertEnroll/\"\n         \t<Directory \"/var/www/openxpki/CertEnroll\">\n               Options FollowSymlinks\n               AllowOverride None\n               Require all granted\n         \t</Directory> Fügen Sie eine Referenz in der Datei apache2.conf mit  nano /etc/apache2/apache2.conf  hinzu. Fügen Sie im Abschnitt  Apache2 HTTPD server  Folgendes hinzu:          \t<Directory /var/www/openxpki/CertEnroll>\n               Options FollowSymlinks\n               AllowOverride None\n               Allow from all\n         \t</Directory> Starten Sie den Apache-Dienst mit  service apache2 start . Konfigurieren  der CRL-Zugänglichkeit CRL-Zugänglichkeit konfigurieren"},{"UUID":"8b1d9dea-3559-4fd7-8e8a-20136ba45bec","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Aktivieren des SCEP-Dienstes Stoppen Sie","descFull":"Aktivieren des SCEP-Dienstes Stoppen Sie den OpenXPKI-Service mit  openxpkictl stop . Installieren Sie das openca-tools-Paket mit  aptitude install openca-tools . Starten Sie den OpenXPKI-Service mit  openxpkictl start . Testen Sie den Service mit einem beliebigen Client, z. B. CertNanny mit SSCEP. SSCEP ist ein Befehlszeilenclient für SCEP. Sie können SSCEP über  https://github.com/certnanny/sscop  herunterladen. Aktivieren des SCEP-Dienstes SCEP-Wartung Aktivieren Simple Certificate Enrollment Protocol Aktivieren"},{"UUID":"75ba9c93-d715-494a-b61b-ec98922ed5b9","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Aktivieren des Zertifikats \"Unterzeichner im","descFull":"Aktivieren des Zertifikats \"Unterzeichner im Auftrag\" (Registrierungsagent) Für automatische Zertifikatsanforderungen verwenden wir die \"Unterzeichner im Auftrag\"-Zertifikatfunktion von OpenXPKI. Stoppen Sie den OpenXPKI-Dienst mit  openxpkictl stop . Fügen Sie in  nano /etc/openxpki/config.d/realm/ca-one/SCEP/generic.yaml  im Abschnitt  autorisierten_signer:  eine Regel für den Betreff-Name des Signaturgeberzertifikats hin. rule1:\n        \t\t# Full DN\n            \t\tsubject: CN=Markvision_.*\n In dieser Regel ist jeder Zertifikat-CN, der mit  Markvision_  beginnt, das \"Unterzeichner im Auftrag\"-Zertifikat. Der Betreff-Name wird in MVE für die Generierung des Signaturgebers im \"Unterzeichner im Auftrag\"-Zertifikat festgelegt. Überprüfen Sie den Abstand und den Einzug in der Skriptdatei. Wenn der CN in MVE geändert wird, fügen Sie den aktualisierten CN in OpenXPKI hinzu. Sie können nur ein Zertifikat als \"Unterzeichner im Auftrag\" festlegen und anschließend den vollständigen CN angeben. Speichern Sie die Datei. Starten Sie den OpenXPKI-Service mit  openxpkictl start . Aktivieren von \"Unterzeichner im Auftrag\"-Zertifikaten \"Unterzeichner im Auftrag\"-Zertifikate Aktivieren"},{"UUID":"f9a9e1b8-26fe-43e9-842c-6c16ab8cacc8","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Aktivieren der automatischen Genehmigung von","descFull":"Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in OpenXPKI CA Stoppen Sie den OpenXPKI-Service mit  openxpkictl stop . Aktualisieren Sie in  nano /etc/openxpki/config.d/realm/ca-one/scep/generic.yaml  Folgendes:  eligible:  section: Alter Inhalt eligible:\n\t\t\tinitial:\n\t\t\t\tvalue@: connector:scep.generic.connector.initial\n       \t\targs: '[% context.cert_subject_parts.CN.0 %]'\n       \t\texpect:\n       \t\t\t- Build\n       \t\t\t- New Neuer Inhalt eligible:\n\t\t\tinitial:\n\t\t\t\tvalue: 1\n\t\t\t\t# value@: connector:scep.generic.connector.initial\n\t\t\t\t# args: '[% context.cert_subject_parts.CN.0 %]'\n\t\t\t\t# expect:\n\t\t\t\t#\t- Build\n\t\t\t\t#\t- New Überprüfen Sie den Abstand und den Einzug in der Skriptdatei. Um Zertifikate manuell zu genehmigen, kennzeichnen Sie  value: 1  als Kommentar, und entfernen Sie das Kommentarzeichen in den anderen Zeilen, die zuvor als Kommentare gekennzeichnet waren. Speichern Sie die Datei. Starten Sie den OpenXPKI-Service mit  openxpkictl start . Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in OpenXPKI CA Automatische Genehmigung von Zertifikatsanforderungen Aktivieren in OpenXPKI CA Zertifikatsanforderungen in OpenXPKI CA Automatische Genehmigung"},{"UUID":"8668352d-ee0b-4609-a324-bec3afaeb6fd","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Kopieren und Festlegen des Verzeichnisses","descFull":"Kopieren und Festlegen des Verzeichnisses Kopieren Sie die Beispielverzeichnisstruktur  /etc/openxpki/config.d/realm/ca-one  in ein neues Verzeichnis ( cp -avr /etc/openxpki/config.d/realm/ca-one /etc/openxpki/config.d/realm/ca-two ) in dem Bereichsverzeichnis. Aktualisieren Sie in  /etc/openxpki/config.d/system/realms.yaml  den folgenden Bereich: Alter Inhalt # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\nca-one:\n    label: Verbose name of this realm\n    baseurl: https://pki.example.com/openxpki/\n\n#ca-two:\n#    label: Verbose name of this realm\n#    baseurl: https://pki.acme.org/openxpki/ Neuer Inhalt # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\nca-one:\n    label: CA-ONE\n    baseurl: https://pki.example.com/openxpki/\n\nca-two:\n    label: CA-TWO\n    baseurl: https://pki.example.com/openxpki/ Speichern Sie die Datei. Kopieren des Verzeichnisses Einrichten des Verzeichnisses"},{"UUID":"86240d4d-9eab-4fe4-a64e-8d58a9a385c3","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Erstellen von Zertifikaten Die folgenden","descFull":"Erstellen von Zertifikaten Die folgenden Anweisungen zeigen, wie das Signaturgeberzertifikat, das Tresorzertifikat und das SCEP-Zertifikat generiert werden. Die Root-CA signiert das Signaturgeberzertifikat, und das Signaturgeberzertifikat signiert das SCEP-Zertifikat. Das Tresorzertifikat ist selbstsigniert. Generieren Sie Zertifikate, und signieren Sie sie anschließend. Weitere Informationen finden Sie unter  . Ändern Sie den gemeinsamen Zertifikatnamen, damit der Benutzer leicht zwischen verschiedenen Zertifikaten für verschiedene Bereiche unterscheiden kann. Sie können  DC=CA-ONE  in  DC=CA-TWO  ändern. Die Zertifikatdateien werden im Verzeichnis  /etc/certs/openxpki_ca-two/  erstellt. Kopieren Sie die Schlüsseldateien nach  /etc/openxpki/ca/ca-two/ . Die Schlüsseldateien müssen von OpenXPKI gelesen werden können. cp /etc/certs/openxpki_ca-two/ca-signer-1.key /etc/openxpki/ca/ca-two/\n\ncp /etc/certs/openxpki_ca-two/vault-1.key /etc/openxpki/ca/ca-two/\n\ncp /etc/certs/openxpki_ca-two/scep-1.key /etc/openxpki/ca/ca-two/ Erstellen Sie den Symlink. Erstellen Sie außerdem einen Symlink für das Root-CA-Zertifikat. Symlinks sind Aliase, die von der Standardkonfiguration verwendet werden. ln -s /etc/openxpki/ca/ca-one/ca-root-1.crt /etc/openxpki/ca/ca-two/ca-root-1.crt\n\nln -s /etc/openxpki/ca/ca-two/ca-signer-1.key /etc/openxpki/ca/ca-two/ca-signer-1.pem\n\nln -s /etc/openxpki/ca/ca-two/scep-1.key /etc/openxpki/ca/ca-two/scep-1.pem\n\nln -s /etc/openxpki/ca/ca-two/vault-1.key /etc/openxpki/ca/ca-two/vault-1.pem Importieren Sie das Signaturgeberzertifikat, das Tresorzertifikat und das SCEP-Zertifikat in die Datenbank mit den entsprechenden Token für  ca-two . openxpkiadm certificate import --file /etc/certs/openxpki_ca-two/ca-signer-1.crt --realm ca-two –issuer /etc/openxpki/ca/ca-two/ca-one-1.crt --token certsign\n\nopenxpkiadm certificate import --file /etc/certs/openxpki_ca-two/scep-1.crt --realm ca-two --token scep\n\nopenxpkiadm certificate import --file /etc/certs/openxpki_ca-two/vault-1.crt --realm ca-two --token datasafe Prüfen Sie mit  openxpkiadm alias --realm ca-two , ob der Import erfolgreich war. Beispielausgabe === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set\n In diesem Fall sind die Root-CA-Informationen für  ca-one  und  ca-two  identisch. Wenn Sie das Kennwort des Zertifikatschlüssels während der Zertifikatserstellung geändert haben, aktualisieren Sie  nano /etc/openxpki/config.d/realm/ca-two/crypto.yaml . Generieren Sie die CRLs für diesen Bereich. Weitere Informationen finden Sie unter  . Veröffentlichen Sie die CRLs für diesen Bereich. Weitere Informationen finden Sie unter  . Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Beispielausgabe Stopping OpenXPKI\nStopping gracefully, 3 (sub)processes remaining...\nDONE.\nStarting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Gehen Sie folgendermaßen vor, um auf den OpenXPKI-Server zuzugreifen: Geben Sie in einem Webbrowser  http://ipaddress/openxpki/  ein. Melden Sie sich als  Bediener  an. Das Standardkennwort lautet  openxpki . Die Bedieneranmeldung hat zwei vorkonfigurierte Bedienerkonten,  raop  und  raop2 . Erstellen von Zertifikaten Zertifikate Erstellen"},{"UUID":"d490d3d0-0540-4ee8-a7cf-c86deeb7d3cc","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Konfigurieren des SCEP-Endpunkts für mehrere","descFull":"Konfigurieren des SCEP-Endpunkts für mehrere Bereiche Der SCEP-Endpunkt der Standardbereichs ist  http://<ipaddress>/scep/scep . Wenn Sie mehrere Bereiche haben, konfigurieren Sie einen eindeutigen SCEP-Endpunkt (andere Konfigurationsdatei) für jeden Bereich. In den folgenden Anweisungen verwenden wir zwei PKI-Bereiche:  ca-one  und  ca-two . Kopieren Sie die Standardkonfigurationsdatei in  cp /etc/openxpki/scep/default.conf /etc/openxpki/scep/ca-one.conf . Benennen Sie die Datei als  ca-one.conf . Ändern Sie in  nano /etc/openxpki/scep/ca-one.conf  den Bereichswert in  realm=ca-one . Erstellen Sie eine weitere Konfigurationsdatei in  cp /etc/openxpki/scep/default.conf /etc/openxpki/scep/ca-two.conf . Benennen Sie die Datei als  ca-two.conf . Ändern Sie in  nano /etc/openxpki/scep/ca-two.conf  den Bereichswert in  realm=ca-two . Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Die SCEP-Endpunkte sind die folgenden: ca-one  –  http://ipaddress/scep/ca-one ca-two  –  http://ipaddress/scep/ca-two Wenn Sie zwischen Anmeldeinformationen und Standardzertifikatvorlagen für verschiedene PKI-Bereiche unterscheiden möchten, benötigen Sie möglicherweise eine erweiterte Konfiguration. Konfigurieren von SCEP-Endpunkten für mehrere Bereiche SCEP-Endpunkte Konfigurieren für mehrere Bereiche"},{"UUID":"a2a05d6c-29bf-456f-b7a7-f03a1864bc63","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Gleichzeitiges aktivieren mehrerer aktiver Zertifikate","descFull":"Gleichzeitiges aktivieren mehrerer aktiver Zertifikate mit demselben Betreff Standardmäßig kann in OpenXPKI nur ein Zertifikat mit demselben Betreff-Namen gleichzeitig aktiv sein. Wenn Sie jedoch mehrere benannte Zertifikate durchsetzen, müssen mehrere aktive Zertifikate mit demselben Betreff-Namen gleichzeitig vorhanden sein. Ändern Sie in  /etc/openxpki/config.d/realm/REALM NAME/scep/generic.yaml  im Abschnitt  policy  den Wert für  max_active_certs  von  1  in  0 . REALM NAME ist der Name des Bereichs. Zum Beispiel:  ca-one . Überprüfen Sie den Abstand und den Einzug in der Skriptdatei. Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Aktivieren von mehreren aktiven Zertifikaten Gleiches Thema"},{"UUID":"86101be6-9921-426b-a794-01d1f7d70ee9","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Festlegen der Standard-Anschlussnummer für OpenXPKI","descFull":"Festlegen der Standard-Anschlussnummer für OpenXPKI CA Standardmäßig hört Apache auf Anschlussnummer 80. Legen Sie die Standard-Anschlussnummer für OpenXPKI CA fest, um Konflikte zu vermeiden. Fügen Sie in  /etc/apache2/ports.conf  einen Anschluss hinzu, oder ändern Sie ihn. Zum Beispiel  Listen 8080 . Fügen Sie in  /etc/apache2/sites-enabled/000-default.conf  den Abschnitt  VirtualHost  hinzu, oder ändern Sie ihn, um einen neuen Anschluss zuzuordnen. Zum Beispiel:  <VirtualHost *:8080> . Starten Sie den Apache-Server mit  systemctl restart apache2  neu. Um den Status zu prüfen, führen Sie  netstat -tlpn| grep apache  aus. Die OpenXPKI SCEP-URL lautet jetzt  http://ipaddress:8080/scep/ca-one , und die Web-URL lautet  http://ip address:8080/openxpki . Einrichten von Standard-Anschlussnummern für OpenXPKI CA Standard-Anschlussnummern Einstellung für OpenXPKI CA"},{"UUID":"7aad6d47-13ca-4237-8ffc-241d413860cc","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Ablehnen von Zertifikatsanforderungen ohne ","descFull":"Ablehnen von Zertifikatsanforderungen ohne  Kennwortabfrage  in OpenXPKI CA Standardmäßig akzeptiert OpenXPKI Anforderungen, ohne das Kennwort abzufragen. Die Zertifikatsanforderung wird nicht abgelehnt, und die CA und der CA-Administrator bestimmen, ob die Anforderung genehmigt oder abgelehnt werden soll. Um potenzielle Sicherheitsprobleme zu vermeiden, deaktivieren Sie diese Funktion, damit Zertifikatsanforderungen, die ungültige Kennwörter enthalten, sofort abgelehnt werden. In MVE ist  Kennwort abfragen  nur erforderlich, wenn das Registrierungsagent-Zertifikat generiert wird. Ändern Sie in  etc/openxpki/config.d/realm/REALM NAME/scep/generic.yaml  im Abschnitt  policy  den Wert für  allow_man_authen  von  1  in  0 . REALM NAME ist der Name des Bereichs. Zum Beispiel:  ca-one . Überprüfen Sie den Abstand und den Einzug in der Skriptdatei. Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Ablehnen von Zertifikatsanforderungen ohne  Kennwortabfrage  in OpenXPKI CA Zertifikatsanforderungen ohne  Kennwortabfrage Ablehnen in OpenXPKI CA"},{"UUID":"800d61de-3900-4d66-a2ab-6954a551976c","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Hinzufügen der Clientauthentifizierungs-EKU zu Zertifikaten","descFull":"Hinzufügen der Clientauthentifizierungs-EKU zu Zertifikaten Ändern Sie in  /etc/openxpki/config.d/realm/REALM NAME/profile/I18N_OPENXPKI_PROFILE_TLS_SERVER.yaml  im Bereich  extended_key_usage:  den Wert für  client_auth:  in  1 . REALM NAME ist der Name des Bereichs. Zum Beispiel:  ca-one . Überprüfen Sie den Abstand und den Einzug in der Skriptdatei. Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Hinzufügen der Clientauthentifizierungs-EKU zu Zertifikaten Clientauthentifizierungs-EKU Hinzufügen in Zertifikaten"},{"UUID":"da4b37de-c2a1-407d-8a24-c861c980d8d9","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Abrufen des vollständigen Zertifikatsbetreffs bei","descFull":"Abrufen des vollständigen Zertifikatsbetreffs bei Anforderung über SCEP Standardmäßig liest OpenXPKI nur den CN des Betreffs des anfragenden Zertifikats. Die restlichen Informationen, wie Land, Ort und DC, sind hartcodiert. Wenn ein Zertifikat beispielsweise  C=US ,  ST=KY ,  L=Lexington ,  O=Lexmark ,  OU=ISS ,  CN=ET0021B7C34AEC.dhcp.dev.lexmark.com  ist, dann wird der Betreff nach dem Signieren des Zertifikats durch SCEP in  DC=Test Deployment ,  DC= OpenXPKI ,  CN=ET0021B7C34AEC.dhcp.dev.lexmark.com  geändert. REALM NAME ist der Name des Bereichs. Zum Beispiel:  ca-one . Ändern Sie in  /etc/openxpki/config.d/realm/REALM NAME/profile/I18N_OPENXPKI_PROFILE_TLS_SERVER.yaml  im Bereich  enroll  den Wert für  dn  wie folgt: CN=[% CN.0 %][% IF OU %][% FOREACH entry = OU %],OU=[% entry %][% END %][% END %][% IF O %][% FOREACH entry = O %],O=[% entry %][% END %][% END %][% IF L %],L=[% L.0 %][% END %][% IF ST %],ST=[% ST.0 %][% END %][% IF C %],C=[% C.0 %][% END %][% IF DC %][% FOREACH entry = DC %],DC=[% entry %][% END %][% END %][% IF EMAIL %][% FOREACH entry = EMAIL %],EMAIL=[% entry %][% END %][% END %] Speichern Sie die Datei. Erstellen Sie eine Datei mit dem Namen  l.yaml  im Verzeichnis  /etc/openxpki/config.d/realm/REALM NAME/profile/template . Fügen Sie Folgendes hinzu: id: L\nlabel: L\ndescription: I18N_OPENXPKI_UI_PROFILE_L_DESC\npreset: L\ntype: freetext\nwidth: 60\nplaceholder: Kolkata Speichern Sie die Datei. Erstellen Sie eine Datei mit dem Namen  st.yaml  im Verzeichnis  /etc/openxpki/config.d/realm/REALM NAME/profile/template . Fügen Sie Folgendes hinzu: id: ST\nlabel: ST\ndescription: I18N_OPENXPKI_UI_PROFILE_ST_DESC\npreset: ST\ntype: freetext\nwidth: 60\nplaceholder: WB Speichern Sie die Datei. OpenXPKI muss Eigentümer beider Dateien und lesbar, schreibbar und ausführbar sein. Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Abrufen von vollständigen Zertifikatsthemen beim Abfragen über SCEP Vollständige Zertifikatsthemen Anforderung über SCEP"},{"UUID":"8bcfe519-c891-4f50-a6f5-5e2f20505db1","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Entziehen von Zertifikaten und Veröffentlichen","descFull":"Entziehen von Zertifikaten und Veröffentlichen von CRL Greifen Sie auf den OpenXPKI-Server zu. Geben Sie in einem Webbrowser  http://ipaddress/openxpki/  ein. Melden Sie sich als  Bediener  an. Das Standardkennwort lautet  openxpki . Die Bedieneranmeldung hat zwei vorkonfigurierte Bedienerkonten,  raop  und  raop2 . Klicken Sie auf  Workflow-Suche Jetzt suchen . Klicken Sie auf ein Zertifikat, das Sie widerrufen möchten, und klicken Sie anschließend auf den Zertifikatlink. Klicken Sie im Bereich  Aktion  auf  Widerrufsanforderung . Geben Sie die entsprechenden Werte ein, und klicken Sie anschließend auf  Fortfahren Anfrage abschicken . Genehmigen Sie die Anfrage auf der nächsten Seite. Der Zertifikatswiderruf wartet auf die nächste CRL-Veröffentlichung. Klicken Sie im Abschnitt  PKI-Operation  auf  Zertifikatwiderrufsliste (CRL) ausstellen . Klicken Sie auf  Erstellung der Widerruflisten Zertifikatsvorlage Fortfahren . Klicken Sie im Abschnitt  PKI-Operation  auf  CA/CRL veröffentlichen . Klicken Sie auf  Workflow-Suche Jetzt suchen . Klicken Sie auf das widerrufene Zertifikat mit dem Typ  certificate_revocation_request_v2 . Klicken Sie auf  Aktivierung erzwingen . In der neuen CRL finden Sie die Seriennummer und den Widerrufsgrund des widerrufenen Zertifikats. Widerrufen von Zertifikaten Zertifikate Widerrufen Veröffentlichen von CRL CRL Veröffentlichen"},{"UUID":"a1a14a76-7fac-4e89-a983-57b621a05560","title":"Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Installieren von OpenXPKI CA Verbinden","descFull":"Installieren von OpenXPKI CA Verbinden Sie den Computer mit PuTTY oder einem anderen Client. Führen Sie auf dem Client den Befehl  sudo su -  aus, um zum Root-Benutzer zu gelangen. Geben Sie das Root-Kennwort ein. Ändern Sie in  nano /etc/apt/sources.list  die Quelle zum Installieren der Updates. Aktualisieren Sie die Datei. Beispiel: #\n\n# deb cdrom:[Debian GNU/Linux testing _Buster_ - Official Snapshot amd64 DVD Binary-1 20190527-04:04]/ buster contrib main\n# deb cdrom:[Debian GNU/Linux testing _Buster_ - Official Snapshot amd64 DVD Binary-1 20190527-04:04]/ buster contrib main\n\ndeb http://security.debian.org/debian-security buster/updates main contrib\ndeb-src http://security.debian.org/debian-security buster/updates main contrib\n\n# buster-updates, previously known as 'volatile'\n# A network mirror was not selected during install. The following entries\n# are provided as examples, but you should amend them as appropriate\n# for your mirror of choice.\n#\ndeb http://ftp.debian.org/debian/ buster-updates main\ndeb-src http://ftp.debian.org/debian/ buster-updates main\ndeb http://ftp.us.debian.org/debian/ buster main\n Speichern Sie die Datei. Führen Sie die folgenden Befehle aus: apt-get Update apt-get Upgrade Aktualisieren Sie die CA-Zertifikatlisten auf dem Server mit  apt-get install ca-certificates . Installieren Sie  en_US.utf8 locale  mit  dpkg-reconfigure locales . Wählen Sie das Gebietsschema  en_US.UTF-8 UTF-8  aus, und machen Sie es anschließend zum standardmäßigen Gebietsschema für das System. Verwenden Sie die Tabulatortaste und die Leertaste zum Auswählen und Navigieren im Menü. Prüfen Sie die Gebietsschemas, die Sie mit  locale –a  generiert haben. Beispielausgabe C\nC.UTF-8\nen_IN\nen_IN.utf8\nen_US.utf8\nPOSIX Kopieren Sie den Fingerabdruck des OpenXPKI-Pakets mit  nano /home/Release.key . Kopieren Sie den Schlüssel beispielsweise in  /home . Geben Sie  55D89776 006F632B E0196E3E D2495509 BAFDDC74 22FEAAD2 F055074E 0FE3A724  als Wert ein. Führen Sie den folgenden Befehl aus: gpg --print-md sha256 /home/Release.key Fügen Sie das Paket mit dem Befehl  wget https://packages.openxpki.org/v3/debian/Release.key -O - | apt-key add -  hinzu. Fügen Sie das Repository mit  echo \"deb http://packages.openxpki.org/v3/debian/ buster release\" > /etc/apt/sources.list.d/openxpki.list  und anschließend  apt update  zu Ihrer Quellenliste (buster) hinzu. Installieren Sie MySQL und Perl MySQL-Binding mit  apt install mariadb-server libdbd-mariadb-perl . Installieren Sie apache2.2-common mit  apt install apache2 . Installieren Sie in  nano /etc/apt/sources.list  das fastcgi-Modul, um die Benutzeroberfläche zu beschleunigen. Wir empfehlen die Verwendung von  mod_fcgid . Fügen Sie die Zeile  deb http://http.us.debian.org/debian/buster main  in der Datei hinzu und speichern Sie sie. Führen Sie die folgenden Befehle aus: apt-get Update apt install libapache2-mod-fcgid Aktivieren Sie das fastcgi-Modul mit  a2enmod fcgid . Installieren Sie das OpenXPKI-Kernpaket mit  apt install libopenxpki-perl openxpki-cgi-session-driver openxpki-i18n . Starten Sie den  Apache  Server mit  service apache2 restart  neu. Prüfen Sie mit  openxpkiadm version , ob die Installation erfolgreich war. Wenn die Installation erfolgreich war, zeigt das System die Version der installierten OpenXPKI an. Beispiel:  Version (core): 3.18.2 . Erstellen Sie die leere Datenbank, und weisen Sie anschließend den Datenbankbenutzer mit  mariadb -u root -p  zu. Dieser Befehl muss in den Client eingegeben werden. Andernfalls können Sie das Kennwort nicht eingeben. Geben Sie das Passwort für MySQL ein. In diesem Beispiel ist  root  der MySQL-Benutzer. openxpki  ist der Benutzer, auf dem OpenXPKI installiert ist. CREATE DATABASE openxpki CHARSET utf8; \nCREATE USER 'openxpki'@'localhost' IDENTIFIED BY 'openxpki';\nGRANT ALL ON openxpki.* TO 'openxpki'@'localhost';\nflush privileges; Wenn der MySQL-Service nicht läuft, führen Sie  /etc/init.d/mysql start  aus, um den Service zu starten. Geben Sie  quit  ein, um MySQL zu beenden. Speichern Sie die verwendeten Zugangsdaten in  /etc/openxpki/config.d/system/database.yaml . Beispielhafter Datei-Inhalt main:\ndebug: 0\ntype: MariaDB\nname: openxpki\nhost: localhost\nport: 3306\nuser: openxpki \npasswd: openxpki Ändern Sie  user  und  passwd  so, dass sie mit dem MariaDB-Benutzernamen und -Kennwort übereinstimmen. Speichern Sie die Datei. Führen Sie für ein leeres Datenbankschema  zcat /usr/share/doc/libopenxpki-perl/examples/schema-mariadb.sql.gz | \\ mysql -u root --password --database openxpki  aus der bereitgestellten Schemadatei aus. Geben Sie das Kennwort für die Datenbank ein. Installieren von OpenXPKI CA OpenXPKI CA Installieren"},{"UUID":"0a980a03-7a3e-4444-8983-a339de63354e","title":"Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Konfigurieren von OpenXPKI CA mit","descFull":"Konfigurieren von OpenXPKI CA mit Standardskript Das Standardskript konfiguriert nur den Standardbereich  ca-one . CDP und CRLs sind nicht konfiguriert. Führen Sie das Skript mit  bash /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh  aus. Bestätigen Sie die Installation mit  openxpkiadm alias --realm democa . Beispielausgabe === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set Prüfen Sie mit  openxpkictl start , ob die Installation erfolgreich war. Beispielausgabe Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Gehen Sie folgendermaßen vor, um auf den OpenXPKI-Server zuzugreifen: Geben Sie in einem Webbrowser  http://ipaddress/openxpki/  ein. Fügen Sie den Benutzernamen und die entsprechenden Kennwörter in einer  userdb.yaml -Datei hinzu. Gehen Sie wie folgt vor, um den Benutzernamen und das Kennwort hinzuzufügen: Checken Sie aus zu  /home/pkiadm  und dann  nano userdb.yaml . Fügen Sie Folgendes ein: estRA:  \n       digest:\"{ssha256}somePassword”\n       role: RA Operator In diesem Fall bezieht sich estRA auf den Benutzernamen. Geben Sie  openxpkiadm hashpwd  ein, um das Kennwort zu generieren. Wenn eine Meldung angezeigt wird, in der nach dem Kennwort und einem verschlüsselten ssha256-Kennwort gefragt wird, kopieren Sie es und fügen Sie es in den Digest eines beliebigen Benutzers ein. Die verfügbaren Rollen in der Bedieneranmeldung sind „RA-Bediener“, „CA-Bediener“ und „Benutzer“. Geben Sie den Benutzernamen und das Kennwort ein. Erstellen Sie eine Zertifikatsanforderung, und testen Sie sie. Konfigurieren von OpenXPKI CA mit Standardskript OpenXPKI CA Konfigurieren mit Standardskript"},{"UUID":"5de77d2f-b7a9-47f5-b6ec-73e3b9dc1d17","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Übersicht Stellen Sie zu Beginn","descFull":"Übersicht Stellen Sie zu Beginn sicher, dass Sie über die grundlegenden Kenntnisse für das Erstellen von OpenSSL-Zertifikaten verfügen. Erstellen Sie zum manuellen Konfigurieren der OpenXPKI CA Folgendes: Root-CA-Zertifikat Weitere Informationen finden Sie unter  . CA-Signaturgeberzertifikat, signiert von der Root-CA. Weitere Informationen finden Sie unter  . Datentresorzertifikat, selbstsigniert. Weitere Informationen finden Sie unter  . Web-Zertifikat, vom Signaturgeberzertifikat signiert. Weitere Informationen finden Sie unter  . Verwenden Sie bei der Auswahl des Signatur-Hash entweder SHA256 oder SHA512. Die Änderung der Größe des öffentlichen Schlüssels ist optional. Ab Version 3.10 können Sie die Schlüssel direkt mit dem Befehl openxpkiadm alias verwalten: Führen Sie  mkdir -p /etc/openxpki/local/keys  aus, um das Verzeichnis zu erstellen. Der Standardspeicherort des Verzeichnisses ist  /etc/openxpki/local/keys . Führen Sie  openxpkictl start  aus, um den Server zu starten. In diesem Fall verwenden wir das Verzeichnis  /etc/certs/openxpki_democa/  zur Zertifikatgenerierung. Sie können jedoch jedes beliebige Verzeichnis verwenden. Manuelles Konfigurieren von OpenXPKI CA OpenXPKI CA Manuell konfigurieren"},{"UUID":"b5125505-9e02-4470-8c01-5da0d10211e5","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Erstellen einer OpenSSL-Konfigurationsdatei Die OpenSSL-Konfigurationsdatei","descFull":"Erstellen einer OpenSSL-Konfigurationsdatei Die OpenSSL-Konfigurationsdatei enthält X.509-Erweiterungen zum Generieren und Signieren von Zertifikatsanforderungen. Führen Sie den folgenden Befehl aus: nano /etc/certs/openxpki_democa/openssl.conf Wenn Ihr Server unter Verwendung des FQDN (Fully Qualified Domain Name) erreichbar ist, verwenden Sie den DNS des Servers anstelle seiner IP-Adresse. Beispieldatei # x509_extensions               = v3_ca_extensions\n# x509_extensions               = v3_issuing_extensions\n# x509_extensions               = v3_datavault_extensions\n# x509_extensions               = v3_scep_extensions\n# x509_extensions               = v3_web_extensions\n# x509_extensions               = v3_ca_reqexts # not for root self-signed, only for issuing\n## x509_extensions              = v3_datavault_reqexts # not required self-signed\n# x509_extensions               = v3_scep_reqexts\n# x509_extensions               = v3_web_reqexts\n\n[ req ]\ndefault_bits            = 4096\ndistinguished_name      = req_distinguished_name\n\n[ req_distinguished_name ]\ndomainComponent         = Domain Component\ncommonName              = Common Name\n\n[ v3_ca_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\n\n[ v3_datavault_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\n\n[ v3_scep_reqexts ]\nsubjectKeyIdentifier    = hash\n\n[ v3_web_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\n\n[ v3_ca_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_issuing_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer:always\ncrlDistributionPoints   = URI:https://FQDN of your system/openxpki/CertEnroll/MYOPENXPKI.crl\nauthorityInfoAccess     = caIssuers;URI:https://FQDN of your system/download/MYOPENXPKI.crt\n\n[ v3_datavault_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_scep_extensions ]\nsubjectKeyIdentifier    = hash\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid,issuer\n\n[ v3_web_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\nbasicConstraints        = critical,CA:FALSE\nsubjectAltName          = DNS:FQDN of est server\ncrlDistributionPoints   = URI:https://FQDN of your system/openxpki/CertEnroll/MYOPENXPKI_ISSUINGCA.cr\nauthorityInfoAccess     = caIssuers;URI:https://FQDN of your system/download/MYOPENXPKI_ISSUINGCA.crt\n Ersetzen Sie die IP-Adresse und den CA-Zertifikatnamen mit den Setup-Informationen. Speichern Sie die Datei. OpenSSL-Konfigurationsdatei Erstellen"},{"UUID":"6ed1e6bf-8381-49a8-96d0-62167dcd28fa","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Erstellen einer Kennwortdatei für Zertifikatschlüssel","descFull":"Erstellen einer Kennwortdatei für Zertifikatschlüssel Führen Sie den folgenden Befehl aus: nano /etc/certs/openxpki_democa/pd.pass Geben Sie Ihr Kennwort ein. Speichern Sie die Datei. Kennwortdateien für Zertifikatschlüssel Erstellen Zertifikatschlüssel Erstellen von Kennwortdateien"},{"UUID":"60a8ee51-c96f-4577-8f04-1653c81e5500","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Erstellen eines Root-CA-Zertifikats Sie können","descFull":"Erstellen eines Root-CA-Zertifikats Sie können ein selbstsigniertes Root-CA-Zertifikat erstellen oder eine Zertifikatsanforderung generieren und diese anschließend von der Root-CA signieren lassen. Ersetzen Sie die Schlüssellänge, den Signaturalgorithmus und den Zertifikatnamen durch die entsprechenden Werte. Führen Sie den folgenden Befehl aus: openssl genrsa -out /etc/certs/openxpki_democa/ca-root-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Ersetzen Sie den Betreff in der Anforderung durch Ihre CA-Informationen mit  openssl req -new -key /etc/certs/openxpki_democa/ca-root-1.key -out /etc/certs/openxpki_democa/ca-root-1.csr . Rufen Sie das von der Root-CA  signierte Zertifikat mit  openssl req -config /etc/certs/openxpki_democa/openssl.conf -extensions v3_ca_extensions - x509 -days 3560 -in /etc/certs/openxpki_democa/ca-root-1.csr -key /etc/certs/openxpki_democa/ca-root-1.key -out /etc/certs/openxpki_democa/ca-root-1.crt - sha256  auf. Gehen Sie zu   /etc/certs/openxpki_democa/ , wo  ca-root-1.crt  gespeichert ist. Führen Sie den folgenden Befehl aus: openxpkiadm certificate import --file ca-root-1.crt Root-CA-Zertifikate Erstellen"},{"UUID":"178957d6-4caa-410a-b87d-4737437d056b","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Erstellen eines Signaturgeberzertifikats Ersetzen Sie","descFull":"Erstellen eines Signaturgeberzertifikats Ersetzen Sie die Schlüssellänge, den Signaturalgorithmus und den Zertifikatnamen durch die entsprechenden Werte. Führen Sie den folgenden Befehl aus: openssl genrsa -out /etc/certs/openxpki_democa/ca-signer-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Ersetzen Sie den Betreff in der Anforderung mit Ihren CA-Informationen mit  openssl req -config /etc/certs/openxpki_democa/openssl.conf -reqexts v3_ca_reqexts -new -key /etc/certs/openxpki_democa/ca-signer-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ISSUINGCA -out / etc/certs/openxpki_democa/ca-signer-1.csr . Rufen Sie das von der Root-CA signierte Zertifikat mit  openssl x509 -req -extfile /etc/certs/openxpki_democa/openssl.conf -extensions v3_issuing_extensions -days 3650 -in /etc/certs/openxpki_democa/ca-signer-1.csr -CA /etc/certs/openxpki_democa/ca-root-1.crt -CAkey /etc/certs/openxpki_democa/ca-root-1.key -CAcreateserial -out /etc/certs/openxpki_democa/ca-signer-1.crt -sha256  ab. Führen Sie den folgenden Befehl aus: openxpkiadm alias --realm democa --token certsign --file ca-signer-1.crt --key ca-signer-1.key Signaturgeberzertifikate Erstellen"},{"UUID":"4b35f17c-457e-455f-91da-7e6082346fd5","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Erstellen eines Tresorzertifikats Das Tresorzertifikat","descFull":"Erstellen eines Tresorzertifikats Das Tresorzertifikat ist selbstsigniert. Ersetzen Sie die Schlüssellänge, den Signaturalgorithmus und den Zertifikatnamen durch die entsprechenden Werte. Führen Sie den folgenden Befehl aus: openssl req -new -x509 -keyout vault.key -out vault.crt -days 1100 -config /etc/certs/openxpki_democa/openssl.conf Ändern Sie den Betreff in der Anforderung mit Ihren CA-Informationen mit  openxpkiadm certificate import --file vault.crt . Führen Sie den folgenden Befehl aus: openxpkiadm alias --realm democa --token datasafe --file vault.crt --key vault.key Geben Sie die erforderlichen Werte an, behalten Sie  /CN=DataVault  als Betreff bei. Tresorzertifikate Erstellen"},{"UUID":"2f95de6a-7918-4e32-b041-ad8783978150","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Erstellen eines Webzertifikats Führen Sie","descFull":"Erstellen eines Webzertifikats Führen Sie den folgenden Befehl aus: openssl genrsa -out /etc/certs/openxpki_democa/web-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Ersetzen Sie den Betreff in der Anforderung mit Ihren CA-Informationen mit  openssl req -config /etc/certs/openxpki_democa/openssl.conf -reqexts v3_web_reqexts -new -key /etc/certs/openxpki_democa/web-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=FQDN of your system -out /etc/certs/openxpki_democa/web-1.csr . Führen Sie den folgenden Befehl aus: openssl x509 -req -extfile /etc/certs/openxpki_democa/openssl.conf -extensions v3_web_extensions -days 900 -in /etc/certs/openxpki_democa/web-1.csr -CA /etc/certs/openxpki_democa/ca-signer-1.crt -CAkey /etc/certs/openxpki_democa/ca-signer-1.key -CAcreateserial -out /etc/certs/openxpki_democa/web-1.crt -sha256 Webzertifikat Erstellen"},{"UUID":"ff69c222-23e3-4764-8cc7-36ed663d1ae8","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Einrichten des Webservers Führen Sie","descFull":"Einrichten des Webservers Führen Sie die folgenden Befehle aus: a2enmod ssl rewrite headers a2ensite openxpki a2dissite 000-default default-ssl mkdir -m755 -p /etc/openxpki/tls/chain cp /etc/certs/openxpki_democa/ca-root-1.crt /etc/openxpki/tls/chain/ cp /etc/certs/openxpki_democa/ca-signer-1.crt /etc/openxpki/tls/chain/ c_rehash /etc/openxpki/tls/chain/ mkdir -m755 -p /etc/openxpki/tls/endentity mkdir -m700 -p /etc/openxpki/tls/private cp /etc/certs/openxpki_democa/web-1.crt /etc/openxpki/tls/endentity/openxpki.crt cat /etc/certs/openxpki_democa/ca-signer-1.crt >> /etc/openxpki/tls/endentity/openxpki.crt openssl rsa -in /etc/certs/openxpki_democa/web-1.key -passin file:/etc/certs/openxpki_democa/pd.pass -out /etc/openxpki/tls/private/openxpki.pem chmod 400 /etc/openxpki/tls/private/openxpki.pem Starten Sie den Apache-Dienst mit  apache2 restart  neu. Führen Sie den folgenden Befehl aus, um den erfolgreichen Import der Dateien zu prüfen: openxpkiadm alias --realm democa Beispielausgabe === functional token ===\nca-signer (certsign):\n  \t\tAlias     : ca-signer-2\n  \t\tIdentifier: XjC6MPbsnyfLZkI9Poi9vm4Z5rk\n \t\t NotBefore : 2022-04-06 10:03:01\n  \t\tNotAfter  : 2032-04-03 10:03:01\n\nvault (datasafe):\n  \t\tAlias     : vault-2\n  \t\tIdentifier: G8ekluAsskGVC0N-jZhB2n9kvdM\n  \t\tNotBefore : 2022-04-06 09:53:57\n  \t\tNotAfter  : 2025-04-10 09:53:57\n\nscep (scep):\n  \t\tnot set\n\nratoken (cmcra):\n  \t\tnot set\n\n=== root ca ===\ncurrent root ca:\n  \t\tAlias     : root-2\n  \t\tIdentifier: prTHU5vCfcJuCnQWyb5wUknvXQM\n  \t\tNotBefore : 2022-04-06 09:40:27\n  \t\tNotAfter  : 2032-01-04 09:40:27\n Einrichten des Webservers Webserver Einrichten"},{"UUID":"39c4ab8d-b449-4eb0-afe9-3ea9ff1b1889","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Verfügbar machen des Kennworts des","descFull":"Verfügbar machen des Kennworts des Zertifikatschlüssels für OpenXPKI Ändern Sie den Wert in der Datei  nano /etc/openxpki/config.d/system/crypto.yaml . Kommentare für Cache aufheben:  Daemon unter secret: Standard : secret:\n  default:\n    label: Global Secret group\n    export: 0\n    method: literal\n    value: root\n    cache: daemon Zertifikatschlüssel-Kennwort Bereitstellung für openXPKI"},{"UUID":"3ffaf365-c0ad-4d9a-8ca7-7fc1a442c58d","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Starten von OpenXPKI Führen Sie","descFull":"Starten von OpenXPKI Führen Sie den Befehl  openxpkictl start  aus. Beispielausgabe Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Greifen Sie auf den OpenXPKI-Server zu: Geben Sie in einem Webbrowser  http://ipaddress/openxpki/  ein. Fügen Sie die Benutzernamen und entsprechenden Kennwörter in einer  userdb.yaml -Datei hinzu: Checken Sie aus zu  /home/pkiadm  und dann zu  nano userdb.yaml . Fügen Sie Folgendes ein: estRA:  \n       digest:\"{ssha256}somePassword”\n       role: RA Operator Hier verweist  estRA  auf den Benutzernamen. Geben Sie  openxpkiadm hashpwd  ein, um das Kennwort zu generieren. Eine Meldung mit dem Kennwort und einem verschlüsselten ssha256-Kennwort wird angezeigt. Kopieren Sie das Kennwort und fügen Sie es dann in den Digest eines beliebigen Benutzers ein. Die Bedieneranmeldung verfügt über zwei vorkonfigurierte Rollen: RA-Bediener, CA-Bediener und Benutzer. Geben Sie den Benutzernamen und das Kennwort ein. Erstellen Sie eine Zertifikatsanforderung, und testen Sie sie. OpenXPKI Starten"},{"UUID":"c38e4e6d-e84a-4731-8b00-704d436ae773","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Generieren von CRL-Informationen Wenn Ihr","descFull":"Generieren von CRL-Informationen Wenn Ihr Server über FQDN erreichbar ist, verwenden Sie den DNS des Servers anstelle seiner IP-Adresse. Stoppen Sie den OpenXPKI-Service mit  openxpkictl stop . Aktualisieren Sie in  nano /etc/openxpki/config.d/realm/democa/publishing.yaml  den Abschnitt  connectors: cdp  wie folgt: class: Connector::Builtin::File::Path\nLOCATION: /var/www/openxpki/CertEnroll/\nfile: \"[% ARGS.0 %].crl\"\ncontent: \"[% pem %]\" Aktualisieren Sie in  nano /etc/openxpki/config.d/realm/democa/profile/default.yaml  Folgendes: crl_distribution_points:  section critical: 0\nuri:\n    - https://FQDN of the est/openxkpi/CenrtEnroll/[% ISSUER.CN.0 %].crl\n    - ldap://localhost/[% ISSUER.DN %]\n authority_info_access:  section critical: 0\nca_issuers: http://FQDN of the est/download/MYOPENXPKI.crt\nocsp: http://ocsp.openxpki.org/ Ändern Sie die IP-Adresse und den CA-Zertifikatnamen entsprechend Ihrem CA-Server. Der Pfad Authority_Info_Access (AIA) wird im  Download  -Ordner gespeichert. Sie können den Speicherort jedoch nach Ihren Wünschen festlegen. Gehen Sie in  nano /etc/openxpki/config.d/realm/democa/crl/default.yaml  wie folgt vor: Aktualisieren Sie ggf.  nextupdate  und  renewal . Fügen Sie  ca_issuers  zum folgenden Abschnitt hinzu: extensions:\n    \t\tauthority_info_access:\n        \t\t\tcritical: 0\n        \t\t\t# ca_issuers and ocsp can be scalar or list\n        \t\t\tca_issuers: https://FQDN of the est/download/MYOPENXPKI.crt\n       \t\t\t#ocsp: http://ocsp.openxpki.org/\n Ändern Sie die IP-Adresse und den CA-Zertifikatnamen entsprechend Ihrem CA-Server. Starten Sie den OpenXPKI-Service mit  openxpkictl start . CRL-Informationen Erstellen"},{"UUID":"2fe9b154-703c-4fcf-a334-fa9217953388","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Veröffentlichen von CRL-Informationen Nach dem","descFull":"Veröffentlichen von CRL-Informationen Nach dem Erstellen der CRLs müssen Sie diese veröffentlichen, damit alle darauf zugreifen können. Beenden Sie den Apache-Dienst mit  service apache2 stop . Erstellen Sie ein Verzeichnis  CertEnroll  für CRL im Verzeichnis  /var/www/openxpki/ . Legen Sie  openxpki  als Eigentümer dieses Verzeichnisses fest, und konfigurieren Sie anschließend die Berechtigungen für das Lesen und Ausführen von Apache sowie für andere Dienste als schreibgeschützt. chown openxpki /var/www/openxpki/CertEnroll chmod 755 /var/www/openxpki/CertEnroll Fügen Sie eine Referenz zur Apache-Datei alias.conf mit  nano /etc/apache2/mods-enabled/alias.conf  hinzu. Fügen Sie nach dem Abschnitt  <Directory \"/usr/share/apache2/icons\">  Folgendes hinzu:         \tAlias /CertEnroll/ \"/var/www/openxpki/CertEnroll/\"\n         \t<Directory \"/var/www/openxpki/CertEnroll\">\n               Options FollowSymlinks\n               AllowOverride None\n               Require all granted\n         \t</Directory> Fügen Sie eine Referenz in der Datei apache2.conf mit  nano /etc/apache2/apache2.conf  hinzu. Fügen Sie im Abschnitt  Apache2 HTTPD server  Folgendes hinzu:          \t<Directory /var/www/openxpki/CertEnroll>\n               Options FollowSymlinks\n               AllowOverride None\n               Allow from all\n         \t</Directory> Starten Sie den Apache-Dienst mit  service apache2 start . CRL-Informationen Veröffentlichen"},{"UUID":"53347f85-4f89-49d1-9fdc-704e91920aa4","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Aktivieren der automatischen Genehmigung von","descFull":"Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in OpenXPKI CA Stoppen Sie den OpenXPKI-Service mit  openxpkictl stop . Aktualisieren Sie in  /etc/openxpki/config.d/realm/democa/est/default.yaml  die  Berechtigung:  section: Alter Inhalt eligible:\n\t\t\tinitial:\n\t\t\t\tvalue@: connector:scep.generic.connector.initial\n       \t\targs: '[% context.cert_subject_parts.CN.0 %]'\n       \t\texpect:\n       \t\t\t- Build\n       \t\t\t- New Neuer Inhalt eligible:\n\t\t\tinitial:\n\t\t\t\tvalue: 1\n\t\t\t\t# value@: connector:scep.generic.connector.initial\n\t\t\t\t# args: '[% context.cert_subject_parts.CN.0 %]'\n\t\t\t\t# expect:\n\t\t\t\t#\t- Build\n\t\t\t\t#\t- New Überprüfen Sie den Abstand und den Einzug in der Skriptdatei. Um Zertifikate manuell zu genehmigen, kennzeichnen Sie  value: 1  als Kommentar, und entfernen Sie das Kommentarzeichen in den anderen Zeilen, die zuvor als Kommentare gekennzeichnet waren. Speichern Sie die Datei. Starten Sie den OpenXPKI-Service mit  openxpkictl start . Automatische Genehmigung von Zertifikatanforderungen Aktivieren in OpenXPKI CA Zertifikatanforderungen in OpenXPKI CA Automatische Genehmigung"},{"UUID":"624e4cb2-c812-4a18-bdac-d16210cd46b9","title":"Manuelles Konfigurieren von OpenXPKI CA","link":"managing-certificates-using-EST-group.html","desc":"Ändern von Details, um ca-cert-Download","descFull":"Ändern von Details, um ca-cert-Download zu aktivieren Führen Sie den folgenden Befehl aus: nano /usr/lib/cgi-bin/est.fcgi Ersetzen Sie  my $mime = \"application/pkcs7-mime; smime-type=certs-only\";  mit  my $mime = \"application/pkcs7-mime\"; . Starten Sie den OpenXPKI-Service mit  openxpkictl . ca‑certs download Details werden zur Aktivierung geändert"},{"UUID":"cca82c00-cbbd-46b7-bdda-c5d8d0699117","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Kopieren und Festlegen des Verzeichnisses","descFull":"Kopieren und Festlegen des Verzeichnisses Erstellen Sie ein Verzeichnis, nämlich  democa2 , für den zweiten Bereich in  /etc/openxpki/config.d/realm . Kopieren Sie die Beispielverzeichnisstruktur  /etc/openxpki/config.d/realm/ca-one  in ein neues Verzeichnis ( cp -r /etc/openxpki/config.d/realm.tpl/*/etc/openxpki/config.d/realm/democa2 ) in dem Bereichsverzeichnis. Aktualisieren Sie in  /etc/openxpki/config.d/system/realms.yaml  den folgenden Bereich: Alter Inhalt # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\ndemoca:\n    label: Verbose name of this realm\n    baseurl: https://pki.example.com/openxpki/\n\n#democa2:\n#    label: Verbose name of this realm\n#    baseurl: https://pki.acme.org/openxpki/ Neuer Inhalt # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\ndemoca:\n    label: Example.org Demo CA\n    baseurl: https://pki.example.com/openxpki/\n\ndemoca2:\n    label: Example.org Demo CA2\n    baseurl: https://pki.example.com/openxpki/ Speichern Sie die Datei. Kopieren des Verzeichnisses Einstellen des Verzeichnisses Verzeichnis Kopieren und Einstellen"},{"UUID":"3e2bfa39-0238-4bad-8fcc-8831f4273de6","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Konfigurieren des EST-Endpunkts für mehrere","descFull":"Konfigurieren des EST-Endpunkts für mehrere Bereiche Sie können den EST-Endpunkt mit einem Tupel konfigurieren, das aus dem Berechtigungsteil der URI und der optionalen Beschriftung besteht (z. B. www.example.com:80 und arbitraryLabel1). In den folgenden Anweisungen verwenden wir zwei PKI-Bereiche:  democa  und  democa2 . Kopieren Sie die Standardkonfigurationsdatei in  cp /etc/openxpki/est/default.conf /etc/openxpki/est/democa.conf . Benennen Sie die Datei  democa.conf . Ändern Sie in  nano /etc/openxpki/est/democa.conf  den Bereichswert zu  realm=democa . Je nach Ihren Anforderungen müssen Sie möglicherweise die entsprechenden Zeilen für die Abschnitte  simpleenroll ,  simplereenroll ,  csrattrs  und  cacerts  aufheben. Lassen Sie die Umgebungsabschnitte kommentiert. Führen Sie den gleichen Vorgang für  default.conf  aus. Erstellen Sie eine weitere Konfigurationsdatei in  cp /etc/openxpki/est/default.conf /etc/openxpki/est/democa2.conf . Benennen Sie die Datei  democa2.conf . Ändern Sie in  nano /etc/openxpki/est/democa2.conf  den Bereichswert zu  realm=democa2 Je nach Ihren Anforderungen müssen Sie möglicherweise die entsprechenden Zeilen für die Abschnitte  simpleenroll ,  simplereenroll ,  csrattrs  und  cacerts  aufheben. Lassen Sie die Umgebungsabschnitte kommentiert. Kopieren Sie die Datei  default.yaml  in die folgenden Speicherorte: cp /etc/openxpki/config.d/realm/democa/est/default.yaml /etc/openxpki/config.d/realm/democa/est/democa.yaml Benennen Sie die Datei  democa.yaml . Kopieren Sie die Datei  default.yaml  in die folgenden Speicherorte: cp /etc/openxpki/config.d/realm/democa2/est/default.yaml /etc/openxpki/config.d/realm/democa2/est/democa2.yaml Benennen Sie die Datei  democa2.yaml . Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Wählen Sie die folgenden URLs aus, um den EST-Server zu öffnen, der einem Bereich über einen Webbrowser entspricht: democa — http://ipaddress/est/democa democa2 — http://ipaddress/est/democa2 Wenn Sie zwischen Anmeldeinformationen und Standardzertifikatvorlagen für verschiedene PKI-Bereiche unterscheiden möchten, benötigen Sie möglicherweise eine erweiterte Konfiguration. Konfigurieren von EST-Endpunkten für mehrere Bereiche EST-Endpunkte Konfigurieren für mehrere Bereiche"},{"UUID":"9a925cf5-43a3-41e6-b59f-579fadd029d3","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Erstellen eines Signaturgeberzertifikats Die folgenden","descFull":"Erstellen eines Signaturgeberzertifikats Die folgenden Anweisungen zeigen, wie ein Signaturgeberzertifikat im zweiten Bereich generiert wird. Sie können dieselben Stamm- und Tresorzertifikate wie im ersten Bereich verwenden. Erstellen Sie eine OpenSSL-Konfigurationsdatei in  nano /etc/certs/openxpki_democa2/openssl.conf . Ändern Sie den gemeinsamen Zertifikatnamen, damit der Benutzer leicht zwischen verschiedenen Zertifikaten für verschiedene Bereiche unterscheiden kann. Die Zertifikatdateien werden im Verzeichnis  /etc/certs/openxpki_democa2/  erstellt. Wechseln Sie zum Verzeichnis des Tresorzertifikats im ersten Bereich und importieren Sie das Zertifikat aus dem ersten Bereich. Führen Sie den folgenden Code aus: openxpkiadm alias --realm democa2 --token datasafe --file vault.crt Zertifikate Erstellen Signaturgeberzertifikate Erstellen"},{"UUID":"8495689e-43af-4bf8-93f2-d0a6cb27327a","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Erstellen einer Kennwortdatei für Zertifikatschlüssel","descFull":"Erstellen einer Kennwortdatei für Zertifikatschlüssel Führen Sie den folgenden Befehl aus: nano /etc/certs/openxpki_democa2/pd.pass Geben Sie Ihr Kennwort ein. Erstellen Sie ein Signaturgeberzertifikat. Weitere Informationen finden Sie unter  . Prüfen Sie mit  openxpkiadm alias --realm democa2 , ob der Import erfolgreich war. Wenn Sie das Schlüsselkennwort des Zertifikats während der Zertifikatserstellung geändert haben, aktualisieren Sie  nano /etc/openxpki/config.d/realm/democa2/crypto.yaml . Generieren Sie die CRLs für den zweiten Bereich. Weitere Informationen finden Sie unter  . Stellen Sie sicher, dass Sie den richtigen CA-Zertifikatsnamen entsprechend des Bereichs verwenden. Veröffentlichen Sie die CRLs für diesen Bereich. Weitere Informationen finden Sie unter  . Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Beispielausgabe Stopping OpenXPKI\nStopping gracefully, 3 (sub)processes remaining...\nDONE.\nStarting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Erstellen von Kennwortdateien für Zertifikatschlüssel Kennwortdateien für Zertifikatschlüssel Erstellen Zertifikatschlüssel Erstellen von Kennwortdateien"},{"UUID":"4fe8d725-467d-449c-a314-1677070f932c","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Gleichzeitiges Aktivieren mehrerer aktiver Zertifikate","descFull":"Gleichzeitiges Aktivieren mehrerer aktiver Zertifikate mit demselben Betreff Standardmäßig kann in OpenXPKI nur ein Zertifikat mit demselben Betreff-Namen gleichzeitig aktiv sein. Wenn Sie jedoch mehrere benannte Zertifikate durchsetzen, müssen mehrere aktive Zertifikate mit demselben Betreff-Namen gleichzeitig vorhanden sein. Ändern Sie in  /etc/openxpki/config.d/realm/REALM NAME/est/< REALM NAME >.yaml  im Abschnitt  Richtlinie  den Wert für  max_active_certs  von  1  zu  0 . REALM NAME ist der Name des Bereichs. Zum Beispiel:  ca-one . Überprüfen Sie den Abstand und den Einzug in der Skriptdatei. Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Mehrere aktive Zertifikate mit demselben Betreff Aktivieren Zertifikate mit demselben Betreff Aktivieren"},{"UUID":"4ecd59e2-a16d-463e-b6da-ea7b2546a833","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Festlegen der Standard-Anschlussnummer für OpenXPKI","descFull":"Festlegen der Standard-Anschlussnummer für OpenXPKI CA Standardmäßig hört Apache für https auf Anschlussnummer 443. Legen Sie die Standard-Anschlussnummer für OpenXPKI CA fest, um Konflikte zu vermeiden. Ändern Sie in  /etc/apache2/Ports.conf  den 443-Anschluss zu einem anderen Anschluss. Beispiel: Alter Inhalt Listen 80\n\n<IfModule ssl_module>\n   Listen 443\n</IfModule>\n\n<IfModule mod_gnutls.c>\n  Listen 443\n</IfModule> Neuer Inhalt Listen 80\n\n<IfModule ssl_module>\n   Listen 9443\n</IfModule>\n\n<IfModule mod_gnutls.c>\n  Listen 9443\n</IfModule> Fügen Sie in  /etc/apache2/sites-available/openxpki.conf  den Abschnitt  VirtualHost  hinzu, oder ändern Sie ihn, um einen neuen Anschluss zuzuordnen. Zum Beispiel:  <VirtualHost *:443>  zu  <VirtualHost *:9443> . Fügen Sie in   /etc/apache2/sites-available/default-ssl.conf VirtualHost  hinzu, oder ändern Sie ihn, um einen neuen Anschluss zuzuordnen. Zum Beispiel: <VirtualHost *:443>  zu  <VirtualHost *:9443> . Starten Sie den Apache-Server mit  systemctl restart apache2  neu. Wenn Sie nach der  SSL-/TLS  -Passphrase gefragt werden, geben Sie das Kennwort ein, während Sie das TLS-Webserverzertifikat im EST-Server hinzufügen. Geben Sie in  tinddopenxpkiweb01.dhcp.dev.lexmark.com:9443 (RSA): die Passphrase für die  SSL-/TLS  -Schlüssel ein. Um den Status zu prüfen, führen Sie  netstat -tlpn| grep apache  aus. Die OpenXPKI SCEP-URL lautet jetzt  https://ipaddress  und die Web-URL ist  FQDN:9443/openxpki . Standard-Anschlussnummern für OpenXPKI CA Ändern Standard-Anschlussnummern Änderungen für OpenXPKI CA OpenXPKI CA-Standardanschlussnummern Ändern"},{"UUID":"0b4af7ab-fe6f-43bc-bc38-ff617e66c53b","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Aktivieren der Standardauthentifizierung Führen Sie","descFull":"Aktivieren der Standardauthentifizierung Führen Sie den folgenden Befehl aus: apt -y install apache2-utils Erstellen Sie ein Benutzerkonto, das Zugriff auf den Server hat. Geben Sie folgende Informationen ein: htpasswd -c /etc/apache2/.htpasswd <username>\n                New password:     \n                Re-type new password:\n                Adding password for user <username> Gehen Sie zum Verzeichnis  cd /etc/apache2/sites-enabled/ . Fügen Sie in  nano openxpki.conf  die folgenden Zeilen in  <VirtualHost *: 443 block>  ein: #HTTPS BASIC AUTH FOR LABELS\nLocation /.well-known/est/*/simpleenroll\n    AuthType Basic\n    AuthName \"estrealm\"\n    AuthUserFile /etc/apache2/.htpasswd\n    require valid-user\n    </Location>\n    #HTTPS BASIC AUTH FOR NO LABEL\n    <Location /.well-known/est/simpleenroll>\n    AuthType Basic\n    AuthName \"estrealm\"\n    AuthUserFile /etc/apache2/.htpasswd\n    require valid-user\n    </Location> Add   ErrorDocument 401 %{unescape:%00}   vor  SSLEngine  im selben virtuellen Hostblock. Beispiel ServerAlias *\nDocumentRoot /var/www/\nErrorDocument 401 %{unescape:%00}\nSSLEngine On Starten Sie den Apache-Dienst  apache2 service  mit  service apache2 restart  neu. Die Standardauthentifizierung funktioniert mit dem oben genannten Benutzernamen und Kennwort. Aktivieren der Standardauthentifizierung Standardauthentifizierung Aktivieren"},{"UUID":"6f8e6781-f75f-43e6-86bd-894631dab7ee","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Aktivieren der Clientzertifikat-Authentifizierung Rufen Sie","descFull":"Aktivieren der Clientzertifikat-Authentifizierung Rufen Sie das folgende Verzeichnis auf:  cd /etc/apache2/sites-enabled/ . Für den erforderlichen Host in  nano openxpki.conf  muss  SSLVerifyClient require  hinzugefügt werden. Wenn Sie beispielsweise Port 443 verwenden, ändern Sie den Abschnitt  VirtualHost  wie folgt: <VirtualHost *:443>\nSSLVerifyClient require\n</VirtualHost> Entfernen Sie den Befehl  SSLVerifyClient optional_no_ca . Speichern Sie die Datei und geben Sie dann  quit  ein, um MySQL zu beenden. Rufen Sie das folgende Verzeichnis auf:  cd /etc/openxpki/config.d/realm/democa/est . Öffnen Sie  default.yaml  und  democa.yaml . Wenn die Bezeichnung anders ist, ändern Sie die YAML-Datei. Führen Sie den folgenden Befehl aus: vi default.yaml Fügen Sie im Abschnitt  authorized_signer  Folgendes hinzu: authorized_signer:\nrule2:\n\t\t\tsubject: CN=,. Wenn der Betreff-Name des Clientzertifikats  test123  lautet, fügen Sie Folgendes im Abschnitt  authorized_signer  hinzu: authorized_signer:\nrule1:\n\t\t# Full DN\t\n\t\tsubject: CN=.+:pkiclient,.\nrule2:\t\n\t\tsubject: CN=test123,.* Speichern Sie die Datei und geben Sie  quit  ein, um MySQL zu verlassen. Starten Sie den OpenXPKI-Dienst mit  openxpkictl restart  neu. Starten Sie den Apache-Dienst mit  service apache2 restart  neu. Standardauthentifizierung Aktivieren"},{"UUID":"bd7db28c-1a2b-4aec-946e-a67970f27872","title":"Erstellen eines zweiten Bereichs","link":"managing-certificates-using-EST-group.html","desc":"Wodurch wird der SAN-Unterschied verursacht,","descFull":"Wodurch wird der SAN-Unterschied verursacht, der verhindert, dass das System die CRL abruft? Der SAN-Unterschied kann auftreten, wenn Sie die CRL-Informationen aktivieren. Dieser Fehler weist darauf hin, dass die IP oder der Hostname nicht mit dem Wert des SAN im Webzertifikat übereinstimmt. Um diesen Fehler zu vermeiden, verwenden Sie den FQDN im Pfad der CRL anstelle der IP. Sie können auch das Webzertifikat konfigurieren und den FQDN Ihres Systems im Feld SAN verwenden. Warum sind die Token ca-signer-1 und vault-1 offline? Wenn die Seite  Systemstatus  anzeigt, dass die Token ca-signer-1 und vault-1 offline sind, führen Sie folgende Schritte aus: Ändern Sie den Schlüsselwert in  /etc/openxpki/config.d/realm/realm name/crypto.yaml . Starten Sie den OpenXPKI-Dienst neu. Häufig gestellte Fragen FAQs"},{"UUID":"55f5b840-8a8b-4694-93cb-2cb6ef15184e","title":"Verwalten von Druckerwarnungen","link":"managing-printer-alerts-overview-topic.html","desc":"Übersicht Alarme werden ausgelöst, wenn","descFull":"Übersicht Alarme werden ausgelöst, wenn beim Drucker ein Benutzereingriff erforderlich ist. Mithilfe von Aktionen können Sie benutzerdefinierte E-Mail-Nachrichten versenden oder Skripten ausführen, wenn eine Warnung auftritt. Ereignisse legen fest, welche Aktionen ausgeführt werden, wenn bestimmte Alarme aktiv sind. Zur Registrierung für Warnungen von einem Drucker müssen Sie Aktionen erstellen und diese anschließend einem Ereignis zuweisen. Weisen Sie das Ereignis den Druckern zu, die überwacht werden sollen. Diese Funktion trifft nicht auf gesicherte Drucker zu. Übersicht über das Verwalten von Druckerwarnungen Übersicht Verwalten von Druckerwarnungen"},{"UUID":"532e5f4d-7bed-48e0-aa90-a452aac9bc64","title":"Verwalten von Druckerwarnungen","link":"creating-action-topic.html","desc":"Erstellen einer Aktion Bei einer","descFull":"Erstellen einer Aktion Bei einer Aktion handelt es sich entweder um eine E-Mail-Benachrichtigung oder um ein Ereignisanzeigeprotokoll. Einem Ereignis zugewiesene Aktionen werden ausgelöst, wenn eine Druckerwarnung auftritt. Klicken Sie im Menü  Drucker  auf  Ereignisse & Aktionen Aktionen Erstellen . Geben Sie einen eindeutigen Namen für die Aktion und ihre Beschreibung ein. Wählen Sie einen Aktionstyp aus. E-Mail Stellen Sie zunächst sicher, dass die E-Mail-Einstellungen konfiguriert sind. Weitere Informationen finden Sie unter  . Wählen Sie im Menü  Typ  die Option  E‑Mail  aus. Geben Sie die entsprechenden Werte in die Felder ein. Sie können die verfügbaren Platzhalter teilweise oder vollständig als Betreffzeile oder als Teil einer E-Mail-Nachricht verwenden. Weitere Informationen finden Sie unter  . Klicken Sie auf  Aktion erstellen . Ereignisprotokoll Wählen Sie im Menü  Typ  die Option  Ereignisprotokoll  aus. Geben Sie die Ereignisparameter ein. Sie können auch die verfügbaren Platzhalter im Drop-Down-Menü verwenden. Weitere Informationen finden Sie unter  . Klicken Sie auf  Aktion erstellen . Aktionen erstellen Erstellen von Aktionen Platzhalter E-Mail-Aktion Protokollieren der Ereignisaktion"},{"UUID":"07b8599f-c7e0-4664-8fcb-60488ea05d93","title":"Verwalten von Druckerwarnungen","link":"understanding-action-placeholders-topic.html","desc":"Informationen zu Aktionsplatzhaltern Sie können","descFull":"Informationen zu Aktionsplatzhaltern Sie können die verfügbaren Platzhalter in der Betreffzeile oder der E-Mail-Nachricht verwenden. Platzhalter sind variable Elemente, die bei Verwendung durch die tatsächlichen Werte ersetzt werden. ${eventHandler.timestamp} : Datum und Uhrzeit der Verarbeitung des Ereignisses durch MVE. Beispiel:  14. März 2017 13:42:24 . ${eventHandler.name} : Der Name des Ereignisses. ${configurationItem.name} : Der Systemname des Druckers, der die Warnung ausgelöst hat. ${configurationItem.address} : Die MAC-Adresse des Druckers, der die Warnung ausgelöst hat. ${configurationItem.ipAddress} : Die IP-Adresse des Druckers, der die Warnung ausgelöst hat. ${configurationItem.ipHostname} : Der Hostname des Druckers, der die Warnung ausgelöst hat. ${configurationItem.model} : Der Modellname des Druckers, der die Warnung ausgelöst hat. ${configurationItem.serialNumber} : Die Seriennummer des Druckers, der die Warnung ausgelöst hat. ${configurationItem.propertyTag} : Die Kennzeichnung des Druckers, der die Warnung ausgelöst hat. ${configurationItem.contactName} : Der Kontaktname des Druckers, der die Warnung ausgelöst hat. ${configurationItem.contactLocation} : Der Kontaktstandort des Druckers, der die Warnung ausgelöst hat. ${configurationItem.manufacturer} : Der Hersteller des Druckers, der die Warnung ausgelöst hat. ${alert.name} : Der Name der ausgelösten Warnung. ${alert.state} : Der Status der Warnung. Er kann \"Aktiv\" oder \"Gelöscht\" lauten. ${alert.location} : Die Stelle im Drucker, an der die ausgelöste Warnung aufgetreten ist. \"${alert.type} : Der Schweregrad der ausgelösten Warnung, z. B.  Warnung  oder  Eingriff erforderlich . Informationen zu Aktionsplatzhaltern Aktionsplatzhalter Erläuterungen Aktion Platzhalter"},{"UUID":"78ecaea8-6d90-46de-bcdc-73220a2992a9","title":"Verwalten von Druckerwarnungen","link":"managing-actions-topic.html","desc":"Verwalten von Aktionen Klicken Sie","descFull":"Verwalten von Aktionen Klicken Sie im Menü \"Drucker\" auf  Ereignisse & Aktionen Aktionen . Gehen Sie wie folgt vor: Aktion bearbeiten Wählen Sie eine Aktion aus, und klicken Sie dann auf  Bearbeiten . Konfigurieren Sie die Einstellungen. Klicken Sie auf  Änderungen speichern . Aktionen löschen Wählen Sie eine oder mehrere Aktionen aus. Klicken Sie auf  Löschen , und bestätigen Sie dann das Löschen. Aktion testen Wählen Sie eine Aktion aus, und klicken Sie auf  Testen . Zur Überprüfung der Testergebnisse zeigen Sie die Aufgabenprotokolle an. Weitere Informationen finden Sie unter  . Wenn Sie eine E-Mail-Aktion testen, sollten Sie prüfen, ob die E-Mail an den Empfänger gesendet wurde. Verwalten von Aktionen Aktionen Verwalten Aktionen Bearbeiten Aktionen Löschen Aktionen Wird getestet Bearbeiten von Aktionen Löschen von Aktionen Testen von Aktionen"},{"UUID":"9e6b631d-94f0-47c6-9e41-f5771ed5cfec","title":"Verwalten von Druckerwarnungen","link":"creating-event-topic.html","desc":"Erstellen von Ereignissen Sie können","descFull":"Erstellen von Ereignissen Sie können Warnungen in Ihrer Druckerflotte überwachen. Erstellen Sie ein Ereignis, und richten Sie dann eine Aktion ein, die ausgeführt wird, wenn die angegebenen Warnungen auftreten. Ereignisse werden bei gesicherten Druckern nicht unterstützt. Klicken Sie im Menü \"Drucker\" auf  Ereignisse & Aktionen Ereignisse Erstellen . Geben Sie einen eindeutigen Namen für das Ereignis und seine Beschreibung ein. Wählen Sie im Abschnitt \"Warnungen\" eine oder mehrere Warnungen aus. Weitere Informationen finden Sie unter  . Wählen Sie im Abschnitt \"Aktionen\" eine oder mehrere Aktionen aus, die ausgeführt werden, wenn die ausgewählten Warnungen aktiv sind. Weitere Informationen finden Sie unter  . Aktivieren Sie das System, sodass ausgewählte Aktionen ausgeführt werden, wenn auf dem Drucker Warnungen gelöscht werden. Legen Sie vor dem Ausführen von ausgewählten Aktionen eine Frist fest. Wenn die Warnung vor Fristablauf gelöscht wird, wird die Aktion nicht ausgeführt. Klicken Sie auf  Ereignis erstellen . Ereignis erstellen Ereignis Erstellen"},{"UUID":"77eb00b0-6c65-4987-828f-2d78887df1fb","title":"Verwalten von Druckerwarnungen","link":"understanding-printer-alerts-topic.html","desc":"Informationen zu Druckerwarnungen Alarme werden","descFull":"Informationen zu Druckerwarnungen Alarme werden ausgelöst, wenn beim Drucker ein Benutzereingriff erforderlich ist. Die folgenden Warnungen können einem Ereignis in MVE zugewiesen werden: Papierstau in der automatischen Dokumentenzuführung (ADZ) : Papier staut sich in der ADZ und muss physisch entfernt werden. Papier staut sich am ADZ-Ausgang des Scanners Papier staut sich in ADZ des Scanners Stau am ADZ-Umkehrsensor des Scanners Papier in Scanner-ADZ entfernt Kein Papier in Scanner-ADZ Stau in ADZ-Vorregistrierung des Scanners Stau in ADZ-Registrierung des Scanners Scannerwarnung – Alle Originale erneut einlegen, um den Auftrag erneut zu starten Klappe oder Abdeckung offen : Eine Klappe am Drucker ist offen und muss geschlossen werden. Klappe/Abdeckung prüfen: Ablage Klappe offen Abdeckungswarnung Abdeckung geschlossen Abdeckung geöffnet Abdeckung offen oder DruckTonerkassette fehlt Duplexabdeckung ist offen ADZ-Abdeckung des Scanners geöffnet Scanner-Stauklappe offen Falsche(s) Medienformat oder -sorte : Ein Auftrag wird gedruckt und ein bestimmtes Papier muss in das Fach eingelegt werden. Falsches Briefumschlagformat Falsche manuelle Zuführung Falsche Medien Falsches Medienformat Medien einlegen Speicher voll oder -fehler : Der Drucker weist nur noch wenig Speicherplatz auf und muss Änderungen anwenden. Seite ist zu komplex Die Dateien werden gelöscht Sortierspeicher reicht nicht aus Unzureichender Defragmentierungsspeicher Nicht genug Faxspeicher Nicht genügend Arbeitsspeicher Nicht genug Speicher - angehaltene Aufträge können verloren gehen Nicht genügend Speicher für \"Ressourcen speichern\" Speicher voll Wenig PS-Speicher Zu viele Seiten im Scanner – Scanauftrag abgebrochen Verringerung der Auflösung Fehlfunktion einer Option : Eine Option des Druckers befindet sich in einem Fehlerstatus. Folgende Optionen stehen zur Verfügung: Einzugsoptionen, Ausgabeoptionen, Schriftartenkarten, Benutzer-Flash-Karten, Laufwerke und Finisher. Ausrichtung/Verbindung überprüfen Duplex-Verbindung überprüfen Installation von Finisher/Mailbox prüfen Stromversorgung prüfen Beschädigte Option Beschädigte Option Gerät entnehmen Duplexwarnung Duplexfach fehlt Externer Netzwerkadapter fehlt Finisher-Warnung Finisher-Klappe oder Sicherheitssperre offen Finisher-Papierwand offen Falsches Duplexgerät Falsche Papierzuführung Falsche Ablage Falsches unbekanntes Gerät Falsche Optionsinstallation Eingabewarnung Konfigurationsfehler bei Eingabe Option: Warnung Ablage voll Ablage fast voll Ausgabekonfigurationsfehler Option voll Option fehlt Papiereinzugsmechanismus fehlt Option \"Aufträge drucken\" Gerät wieder einsetzen Ablage wieder einsetzen Zu viele Zufuhrfächer installiert Zu viele Optionen installiert Zu viele Ablagen installiert Fach fehlt Fach fehlt während des Einschaltvorgangs Facherkennungsfehler Papierzuführung nicht kalibriert Option nicht formatiert Nicht unterstützte Option Papierzuführung wieder einsetzen Papierstau : Papier staut sich im Drucker und muss physisch entfernt werden. Interner Papierstau Warnung: Papierstau Papierstau Scanner-Fehler : Am Scanner ist ein Problem aufgetreten. Scannerrückseite – Kabel nicht eingesteckt Scannerrücklauf gesperrt Flachbett/Leitstreifen des Scanners reinigen Scanner deaktiviert Flachbettabdeckung des Scanners offen Scannervorderseite – Kabel nicht eingesteckt Ungültige Scanner-Registrierung Verbrauchsmaterialfehler : Bei einem Verbrauchsmaterial des Druckers ist ein Problem aufgetreten. Falsches Verbrauchsmaterial Falsche Tonerkassette Beschädigtes Verbrauchsmaterial Fixierstation oder Auftragsrolle fehlt Linke Tonerkassette ist fehlerhaft oder fehlt Rechte Tonerkassette ist fehlerhaft oder fehlt Falsches Verbrauchsmaterial Vorbereitung fehlgeschlagen Verbrauchsmaterialwarnung Verbrauchsmaterialstau Verbrauchsmaterial fehlt Auswurfgriff der DruckTonerkassette gezogen DruckTonerkassette nicht richtig eingesetzt Verbrauchsmaterial nicht kalibriert Nicht lizenziertes Verbrauchsmaterial Nicht unterstütztes Verbrauchsmaterial Verbrauchsmaterial oder Füllstand leer : Ein Verbrauchsmaterial des Druckers muss ausgetauscht werden. Papierzuführung leer Verbraucht Drucker zur Wartung bereit Planmäßige Wartung Verbrauchsmaterial leer Verbrauchsmaterial voll Verbrauchsmaterial voll oder fehlt Der Drucker sendet die Warnung als Fehlermeldung und eine Warnung. Wenn eine dieser Warnungen ausgelöst wird, ist die zugehörige Aktion zweimal aufgetreten. Verbrauchsmaterial oder Füllstand niedrig : Ein Verbrauchsmaterial des Druckers geht zur Neige. Frühwarnung 1. wenig Wenig Papier Erneuern Fast leer Fast verbraucht Verbrauchsmaterial niedrig Verbrauchsmaterial fast voll Nicht kategorisierte Warnung oder Bedingung Farbkalibrierungsfehler Datenübertragungsfehler Druckwerk CRC-Fehler Externe Warnung Faxverbindung unterbrochen Lüfter blockiert Hex aktiv Duplexseite einlegen und 'Fortfahren' drücken Interne Warnung Interner Netzwerkadapter muss gewartet werden Warnung für logische Einheit Offline Offline für Warnungsaufforderung Vorgang fehlgeschlagen Benutzereingriff - Warnung Seitenfehler Anschlusswarnung Anschlusskommunikationsfehler Anschluss deaktiviert Strom sparen Ausschalten PS-Auftragszeitsperre PS-Zeitsperre für manuelle Zufuhr Konfiguration erforderlich SIMM-Prüfsummenfehler Verbrauchsmaterial kalibrieren Toner-Patch-Erkennung fehlgeschlagen Unbekannte Warnsituation Unbekannte Konfiguration Unbekannte Warnsituation für Scanner Benutzer gesperrt Allgemeine Warnung Informationen zu Druckerwarnungen Druckerwarnmeldungen Erläuterungen"},{"UUID":"d064e0db-b4f8-4f7f-a471-55b46ca095e2","title":"Verwalten von Druckerwarnungen","link":"managing-events-topic.html","desc":"Verwalten von Ereignissen Klicken Sie","descFull":"Verwalten von Ereignissen Klicken Sie im Menü \"Drucker\" auf  Ereignisse & Aktionen Ereignisse . Führen Sie einen der folgenden Schritte aus: Ereignis bearbeiten Wählen Sie ein Ereignis aus, und klicken Sie dann auf  Bearbeiten . Konfigurieren Sie die Einstellungen. Klicken Sie auf  Änderungen speichern . Ereignisse löschen Wählen Sie ein oder mehrere Ereignisse aus. Klicken Sie auf  Löschen , und bestätigen Sie dann das Löschen. Verwalten von Ereignissen Ereignisse Verwalten Ereignisse Bearbeiten Ereignisse Löschen"},{"UUID":"b7329e7f-696c-427a-b420-1e16cac5b575","title":"Anzeigen von Aufgabestatus und Verlauf","link":"viewing-task-status-history-overview-topic.html","desc":"Übersicht Bei Aufgaben handelt es","descFull":"Übersicht Bei Aufgaben handelt es sich um alle in MVE ausgeführten Druckerverwaltungsaktivitäten. Dazu zählen z. B. Druckersuche, Prüfung und Durchsetzung von Konfigurationen. Auf der Seite  Status  wird der Status aller derzeit ausgeführten Aufgaben und der in den letzten 72 Stunden ausgeführten Aufgaben angezeigt. Informationen der aktuell ausgeführten Aufgaben werden in das Protokoll eingetragen. Aufgaben, die älter sind als 72 Stunden, können nur als einzelne Protokolleinträge auf der Seite  Protokoll  angezeigt werden; Sie können mithilfe der Aufgaben-IDs nach ihnen suchen. Übersicht über das Anzeigen von Aufgabestatus und Verlauf Übersicht Anzeigen von Aufgabestatus und Verlauf"},{"UUID":"bda806eb-c667-4fc7-af58-13ab9579be6e","title":"Anzeigen von Aufgabestatus und Verlauf","link":"viewing-task-status-topic.html","desc":"Anzeigen des Aufgabenstatus Klicken Sie","descFull":"Anzeigen des Aufgabenstatus Klicken Sie im Menü \"Aufgaben\" auf  Status . Der Aufgabenstatus wird in Echtzeit aktualisiert. Anzeigen des Aufgabenstatus Aufgabenstatus Anzeigen"},{"UUID":"b8ba8b33-04f1-43dc-b45f-2dff1a9b5d41","title":"Anzeigen von Aufgabestatus und Verlauf","link":"stopping-tasks-topic.html","desc":"Aufgaben werden angehalten Klicken Sie","descFull":"Aufgaben werden angehalten Klicken Sie im Menü \"Aufgaben\" auf  Status . Wählen Sie im derzeit ausgeführten Abschnitt \"Aufgaben\" eine oder mehrere Aufgaben aus. Klicken Sie auf  Stopp . Aufgaben werden angehalten Tasks Anhalten"},{"UUID":"4beac5f1-5a91-46ca-9573-bc71616f8f7e","title":"Anzeigen von Aufgabestatus und Verlauf","link":"viewing-logs-topic.html","desc":"Anzeigen von Protokollen Klicken Sie","descFull":"Anzeigen von Protokollen Klicken Sie im Menü \"Aufgaben\" auf  Protokolle . Wählen Sie Aufgabenkategorien, Aufgabenarten oder einen Zeitraum aus. Über das Suchfeld können Sie nach mehreren Aufgaben-IDs suchen. Trennen Sie mehrere Aufgaben-IDs durch Komma, oder geben Sie mit einem Bindestrich einen Bereich an. Beispielsweise  11, 23, 30-35 . Klicken Sie auf  Nach CSV exportieren , um die Suchergebnisse zu exportieren. Anzeigen von Protokollen Protokolle Anzeigen"},{"UUID":"4ac0d8bd-03c7-4a28-9706-f2175e41cbc3","title":"Anzeigen von Aufgabestatus und Verlauf","link":"clearing-logs-topic.html","desc":"Protokolle löschen Klicken Sie im","descFull":"Protokolle löschen Klicken Sie im Menü \"Aufgaben\" auf  Protokoll . Klicken Sie auf  Protokoll löschen  und wählen Sie dann ein Datum aus. Klicken Sie auf  Protokoll löschen . Protokolle löschen Protokolle Beseitigen"},{"UUID":"063a2f3b-ca7e-4f7f-a77b-5df3584c9776","title":"Anzeigen von Aufgabestatus und Verlauf","link":"exporting-logs-topic.html","desc":"Exportieren von Protokollen Klicken Sie","descFull":"Exportieren von Protokollen Klicken Sie im Menü  Aufgaben  auf  Protokoll . Wählen Sie Aufgabenkategorien, Aufgabenarten oder einen Zeitraum aus. Klicken Sie auf  Nach CSV exportieren . Exportieren von Protokollen Protokolle Exportieren"},{"UUID":"618fae16-bb85-4c3a-8266-0ad4ccff5261","title":"Festlegen von Zeitplänen für Aufgaben","link":"creating-schedule-topic.html","desc":"Erstellen eines Zeitplans Klicken Sie","descFull":"Erstellen eines Zeitplans Klicken Sie im Menü  Aufgaben  auf  Zeitplan Erstellen . Geben Sie im Abschnitt  Allgemein  einen eindeutigen Namen für die geplanten Aufgaben und eine Beschreibung ein. Führen Sie im Abschnitt  Aufgabe  einen der folgenden Schritte aus: Prüfung planen Wählen Sie  Prüfung  aus. Wählen Sie einen gespeicherten Suchvorgang aus. Übereinstimmungsprüfung planen Wählen Sie  Übereinstimmung  aus. Wählen Sie einen gespeicherten Suchvorgang aus. Druckerstatusprüfung planen Wählen Sie  Aktueller Status  aus. Wählen Sie einen gespeicherten Suchvorgang aus. Wählen Sie eine Aktion aus. Konfigurationsbereitstellung planen Wählen Sie  Datei bereitstellen  aus. Wählen Sie einen gespeicherten Suchvorgang aus. Navigieren Sie zur Datei, und wählen Sie anschließend den Dateityp aus. Wählen Sie bei Bedarf eine Bereitstellungsmethode bzw. das Protokoll aus. Suche planen Wählen Sie  Suche  aus. Wählen Sie ein Suchprofil aus. Konfigurationsdurchsetzung planen Wählen Sie  Durchsetzung  aus. Wählen Sie einen gespeicherten Suchvorgang aus. Zertifikatüberprüfung planen Wählen Sie  Zertifikat validieren  aus. Während der Validierung kommuniziert MVE mit dem CA-Server, um die Zertifikatskette und die Zertifikatsperrliste (Certificate Revocation List, CRL) herunterzuladen. Das Zertifikat des Anmeldeagenten wird ebenfalls generiert. Mit diesem Zertifikat kann der CA-Server MVE vertrauen. Export einer Ansicht planen Wählen Sie  Export anzeigen  aus. Wählen Sie einen gespeicherten Suchvorgang aus. Wählen Sie eine Anzeigevorlage aus. Geben Sie die Liste von E-Mail-Adressen ein, an die die exportierten Dateien gesendet werden. Stellen Sie im Abschnitt  Zeitplan  das Datum, die Uhrzeit und die Häufigkeit der Aufgabe ein. Klicken Sie auf  Geplante Aufgabe erstellen . Erstellen eines Zeitplans Zeitplan erstellen"},{"UUID":"1d0ea467-a3c6-4134-9270-75e585f4166e","title":"Festlegen von Zeitplänen für Aufgaben","link":"managing-schedules-topic.html","desc":"Verwalten von geplanten Aufgaben Klicken","descFull":"Verwalten von geplanten Aufgaben Klicken Sie im Menü  Aufgaben  auf  Zeitplan . Führen Sie einen der folgenden Schritte aus: Eine geplante Aufgabe bearbeiten Wählen Sie eine Aufgabe aus, und klicken Sie dann auf  Bearbeiten . Konfigurieren Sie die Einstellungen. Klicken Sie auf  Geplante Aufgabe bearbeiten . Die Informationen über die letzte Ausführung werden entfernt, wenn eine geplante Aufgabe bearbeitet wird. Löschen Sie eine geplante Aufgabe Wählen Sie eine Aufgabe aus, und klicken Sie auf  Löschen . Klicken Sie auf  Geplante Aufgabe löschen . Verwalten von Zeitplänen Zeitpläne Verwalten Zeitpläne bearbeiten Zeitpläne löschen Zeitpläne bearbeiten Zeitpläne löschen"},{"UUID":"9e1b82b2-9be6-4fed-aa3d-d03b86aa40f2","title":"Ausführen weiterer Verwaltungsaufgaben","link":"configuring-system-settings-topic.html","desc":"Konfigurieren allgemeiner Einstellungen Klicken Sie","descFull":"Konfigurieren allgemeiner Einstellungen Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  Allgemein , und wählen Sie dann eine Hostnamen-Quelle aus. Drucker : Das System ruft den Hostnamen beim Drucker ab. Reverse DNS Lookup : Das System ruft den Hostnamen mithilfe der IP-Adresse aus der DNS-Tabelle ab. Stellen Sie die Häufigkeit der erneuten Warnregistrierung ein. Drucker können durch Änderungen den Warnregistrierungsstatus verlieren, so zum Beispiel bei Neustart oder Aktualisierungen der Firmware. MVE versucht den Status automatisch bei Ende des aktuellen Intervalls, das in der Häufigkeit der erneuten Warnregistrierung eingestellt ist, wiederherzustellen. Klicken Sie auf  Änderungen speichern . Konfigurieren allgemeiner Einstellungen Allgemeine Einstellungen Konfigurieren"},{"UUID":"d2608d68-9ec9-48a6-a8af-071054ed6201","title":"Ausführen weiterer Verwaltungsaufgaben","link":"configuring-email-settings-topic.html","desc":"Konfigurieren der E-Mail-Einstellungen Aktivieren Sie","descFull":"Konfigurieren der E-Mail-Einstellungen Aktivieren Sie die SMTP-Konfiguration, damit MVE Datenexportdateien und Ereignisbenachrichtigungen per E-Mail senden kann. Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  E-Mail , und wählen Sie dann  E-Mail SMTP-Konfiguration aktivieren . Geben Sie den SMTP-Mailserver und -Anschluss ein. Wählen Sie die richtige Verschlüsselung aus. Wählen Sie für die SSL-Verschlüsselung den Anschluss 465 aus. Wählen Sie für die TLS/STARTTLS-Verschlüsselung den Anschluss 587 aus. Geben Sie die E-Mail-Adresse des Absenders ein. Wenn der Benutzer sich vor dem E-Mail-Versand anmelden muss, wählen Sie die Option  Anmeldung erforderlich , und geben Sie die Benutzeranmeldeinformationen ein. Klicken Sie auf  Änderungen speichern . Konfigurieren der E-Mail-Einstellungen E-Mail-Einstellungen Konfigurieren"},{"UUID":"9ee7ac12-bace-411d-8253-5f1a5d375da5","title":"Ausführen weiterer Verwaltungsaufgaben","link":"adding-login-disclaimer-topic.html","desc":"Hinzufügen eines Haftungsausschlusses bei Anmeldung","descFull":"Hinzufügen eines Haftungsausschlusses bei Anmeldung Sie können einen Haftungsausschluss bei Anmeldung konfigurieren, der angezeigt wird, wenn Benutzer sich bei einer neuen Sitzung anmelden. Benutzer müssen den Haftungsausschluss akzeptieren, bevor Sie auf MVE zugreifen können. Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  Haftungsausschluss , und wählen Sie dann  Haftungsausschluss vor der Anmeldung aktivieren . Geben Sie den Text des Haftungsausschlusses ein. Klicken Sie auf  Änderungen speichern . Hinzufügen eines Haftungsausschlusses bei Anmeldung Haftungsausschluss bei Anmeldung Hinzufügen"},{"UUID":"622942f4-fd5f-40e8-8537-72b7211182f3","title":"Ausführen weiterer Verwaltungsaufgaben","link":"signing-mve-certificate-topic.html","desc":"Signieren des MVE-Zertifikats Secure Socket","descFull":"Signieren des MVE-Zertifikats Secure Socket Layer (SSL) oder Transport Layer Security (TLS) ist ein gängiges Sicherheitsprotokoll, das die Kommunikation zwischen einem Server und Client mittels Datenverschlüsselung und Zertifikatauthentifizierung schützt. In MVE wird TLS zum Schutz der sensiblen Informationen zwischen MVE-Server und Webbrowser verwendet. Die geschützten Informationen können folgende sein: Druckerkennwörter, Sicherheitsrichtlinien, MVE-Benutzeranmeldeinformationen oder Drucker-Authentifizierungsinformationen, z. B. LDAP oder Kerberos. TLS ermöglicht die Verschlüsselung dieser Daten durch den MVE-Server und den Webbrowser vor dem Sendevorgang und die Entschlüsselung nach dem Empfang. Außerdem setzt SSL voraus, dass sich der Server mit einem Zertifikat beim Web-Browser authentifiziert, um seine Identität nachzuweisen. Dieses Zertifikat ist entweder selbst oder von einer vertrauenswürdigen Zertifizierungsstelle eines Drittanbieters signiert. Standardmäßig ist MVE für die Verwendung eines selbst signierten Zertifikats konfiguriert. Laden Sie die Signieraufforderung für das Zertifikat herunter. Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  TLS herunterladen . Wählen Sie  Signierungsanforderung für Zertifikat  aus. Die Signierungsanforderung für das Zertifikat enthält Subject Alternative Names (SANs – Listen von alternativen Namen für den Inhaber des Zertifikats). Verwenden Sie eine vertrauenswürdige Zertifizierungsstelle zum Signieren des Zertifikats. Installieren Sie das durch eine vertrauenswürdige Zertifizierungsstelle signierte Zertifikat. Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  TLS Signiertes Zertifikat installieren . Laden Sie das durch eine vertrauenswürdige Zertifizierungsstelle signierte Zertifikat hoch, und klicken Sie anschließend auf  Zertifikat installieren . Klicken Sie auf  MVE-Dienst neu starten . Durch einen Neustart des MVE-Dienstes wird das System neu gestartet, und der Server ist u. U. für einige Minuten nicht verfügbar. Stellen Sie vor dem Neustart des Dienstes sicher, dass aktuell keine Aufgaben ausgeführt werden. Signieren des MVE-Zertifikats MVE-Zertifikat signieren"},{"UUID":"815ebe43-31fa-4bde-a453-6af0d98b4da4","title":"Ausführen weiterer Verwaltungsaufgaben","link":"removing-user-information-topic.html","desc":"Entfernen von Benutzerinformationen und Verweisen","descFull":"Entfernen von Benutzerinformationen und Verweisen MVE erfüllt die Datenschutzrichtlinien der DSGVO (Datenschutz-Grundverordnung). MVE kann so konfiguriert werden, dass das Recht auf Vergessenwerden gilt und private Benutzerinformationen aus dem System entfernt werden. Entfernen von Benutzern Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  Benutzer , und wählen Sie dann einen oder mehrere Benutzer aus. Klicken Sie auf  Löschen Benutzer löschen . Entfernen von Benutzerinformationen in LDAP Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  LDAP . Entfernen Sie alle benutzerbezogenen Informationen in den Suchfiltern und den Bindungseinstellungen. Entfernen von Benutzerinformationen im E-Mail-Server Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  E-Mail . Entfernen Sie alle benutzerbezogenen Informationen, z. B. Benutzeranmeldeinformationen, die für die Authentifizierung mit dem E-Mail-Server verwendet werden. Entfernen von Benutzerinformationen in den Aufgabenprotokollen Weitere Informationen finden Sie unter  . Entfernen von Benutzerinformationen in einer Konfiguration Klicken Sie im Menü  Konfigurationen  auf  Alle Konfigurationen . Klicken Sie auf den Konfigurationsnamen. Entfernen Sie auf der Registerkarte  Standard  alle benutzerbezogenen Werte aus den Druckereinstellungen, z. B. Kontaktname und Kontaktstandort. Entfernen von Benutzerinformationen in einer erweiterten Sicherheitskomponente Klicken Sie im Menü  Konfigurationen  auf  Alle erweiterten Sicherheitskomponenten . Klicken Sie auf den Komponentennamen. Entfernen Sie im Abschnitt  Erweiterte Sicherheitseinstellungen  alle benutzerbezogenen Werte. Entfernen von Benutzerinformationen in gespeicherten Suchen Klicken Sie im Menü  Drucker  auf  Gespeicherte Suchvorgänge . Klicken Sie auf einen gespeicherten Suchvorgang. Entfernen Sie alle Suchkriterien, die benutzerbezogene Werte verwenden, z. B. Kontaktname und Kontaktstandort. Entfernen von Benutzerinformationen in Schlüsselwörtern Klicken Sie im Menü  Drucker  auf  Druckerliste . Heben Sie die Zuweisung von benutzerbezogenen Schlüsselwörtern zu den Druckern auf. Klicken Sie im Menü  Drucker  auf  Schlüsselwörter . Entfernen Sie alle Schlüsselwörter, die benutzerbezogene Informationen verwenden. Entfernen von Benutzerinformationen in Ereignissen und Aktionen Klicken Sie im Menü  Drucker  auf  Ereignisse & Aktionen . Entfernen Sie alle Aktionen, die E-Mail-Verweise auf Benutzer enthalten. Entfernen von Benutzerinformationen und Verweisen Benutzerinformationen Entfernen"},{"UUID":"d9a96138-f6b3-4890-8072-194ea91054cb","title":"Häufig gestellte Fragen","link":"faq-chapter.html","desc":"Markvision Enterprise – FAQ Warum kann","descFull":"Markvision Enterprise – FAQ Warum kann ich beim Erstellen einer Konfiguration aus der Liste \"Unterstützte Modelle\" nicht mehrere Drucker auswählen? Konfigurationseinstellungen und Befehle sind für die Druckermodelle unterschiedlich. Können andere Benutzer auf meine gespeicherten Suchvorgänge zugreifen? Ja. Alle Benutzer können auf gespeicherte Suchvorgänge zugreifen. Wo befinden sich die Protokolldateien? Sie finden die Installationsprotokolldateien im versteckten Verzeichnis des Benutzers, der MVE installiert. Beispiel:  C:\\Benutzer\\Administrator\\AppData\\Local\\Temp\\mveLexmark-install.log . Sie finden die  *.log -Anwendungsprotokolldateien im Ordner  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\logs , wobei es sich bei  installation_dir  um den Installationsordner von MVE handelt. Was ist der Unterschied zwischen Hostname und Reverse DNS Lookup? Ein Hostname ist ein eindeutiger Name, der einem Netzwerkdrucker zugewiesen wurde. Jeder Hostname entspricht einer IP-Adresse. Reverse DNS Lookup wird verwendet, um den angegebenen Hostnamen und Domänennamen einer bestimmten IP-Adresse zu ermitteln. Wo finde ich Reverse DNS Lookup in MVE? Reverse DNS Lookup befindet sich unter \"Allgemeine Einstellungen\". Weitere Informationen finden Sie unter  . Wie kann ich manuell Regeln für die Windows-Firewall hinzufügen? Führen Sie die Eingabeaufforderung als Administrator aus, und geben Sie Folgendes ein: firewall add allowedprogram \" installation_dir /Lexmark/Markvision Enterprise/tomcat/bin/tomcat9.exe\" \"Markvision Enterprise Tomcat\" firewall add portopening UDP 9187 \"Markvision Enterprise NPA UDP\" firewall add portopening UDP 6100 \"Markvision Enterprise LST UDP\" Dabei handelt es sich bei  installation_dir  um den Installationsordner von MVE. Wie richte ich MVE ein, um einen anderen Anschluss als Port 443 zu verwenden? Beenden Sie den Markvision Enterprise-Dienst. Öffnen Sie das Dialogfeld  Ausführen , und geben Sie anschließend  services.msc  ein. Klicken Sie mit der rechten Maustaste auf  Markvision Enterprise , und klicken Sie anschließend auf  Stopp . Öffnen Sie die Datei  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml . Dabei handelt es sich bei  installation_dir  um den Installationsordner von MVE. Ändern Sie den  Anschluss-Port -Wert auf einen anderen nicht verwendeten Anschluss. <Connector port=\"443\" protocol=\"org.apache.coyote.http11.Http11NioProtocol\" \nsslImplementationName=\"org.apache.tomcat.util.net.jsse.JSSEImplementation\" \nSSLEnabled=\"true\" scheme=\"https\" secure=\"true\" clientAuth=\"false\" \ncompression=\"on\" compressableMimeType=\"text/html,text/xml,text/plain,text/css,\ntext/javascript,application/javascript,application/json\" maxThreads=\"150\" \nmaxHttpHeaderSize=\"16384\" minSpareThreads=\"25\" enableLookups=\"false\" \nacceptCount=\"100\" connectionTimeout=\"120000\" disableUploadTimeout=\"true\" \nURIEncoding=\"UTF-8\" server=\"Apache\" sslEnabledProtocols=\"TLSv1,TLSv1.1,TLSv1.2\" \nsslProtocol=\"TLS\" keystoreFile=\"C:/Program Files/Lexmark/Markvision Enterprise/\n../mve_truststore.p12\" keystorePass=\"markvision\" keyAlias=\"mve\" keyPass=\"markvision\" \nkeystoreType=\"PKCS12\" ciphers=\"TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256,\nTLS_ECDHE_RSA_WITH_AES_128_CBC_SHA,TLS_RSA_WITH_AES_128_CBC_SHA256,\nTLS_RSA_WITH_AES_128_CBC_SHA\"/> Ändern Sie den  redirectPort -Wert auf dieselbe Anschlussnummer, die beim Anschluss-Port verwendet wird. <Connector port=\"9788\" maxHttpHeaderSize=\"16384\" maxThreads=\"150\" minSpareThreads=\"25\" \nenableLookups=\"false\" redirectPort=\"443\" acceptCount=\"100\" connectionTimeout=\"120000\" \ndisableUploadTimeout=\"true\" compression=\"on\" compressableMimeType=\"text/html,text/xml,\ntext/plain,text/css,text/javascript,application/javascript,application/json\" \nURIEncoding=\"UTF-8\" server=\"Apache\"/> Starten Sie den Markvision Enterprise-Dienst erneut. Öffnen Sie das Dialogfeld  Ausführen , und geben Sie anschließend  services.msc  ein. Klicken Sie mit der rechten Maustaste auf  Markvision Enterprise , und klicken Sie anschließend auf  Neu starten . Zugriff auf MVE mithilfe des neuen Anschlusses. Öffnen Sie beispielsweise einen Web-Browser, und geben Sie in das Feld \"URL\" Folgendes ein:  https:// MVE_SERVER : port /mve . Dabei ist  MVE_SERVER  der Hostname bzw. die IP-Adresse der auf dem Server gehosteten MVE-Software, und  Port  ist die Anschluss-Port-Nummer. Wie kann ich die Ziffern und TLS-Versionen anpassen, die MVE verwendet? Beenden Sie den Markvision Enterprise-Dienst. Öffnen Sie das Dialogfeld  Ausführen , und geben Sie anschließend  services.msc  ein. Klicken Sie mit der rechten Maustaste auf  Markvision Enterprise , und klicken Sie anschließend auf  Stopp . Öffnen Sie die Datei  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml . Dabei handelt es sich bei  installation_dir  um den Installationsordner von MVE. Konfigurieren Sie die Ziffern und TLS-Versionen. Weitere Informationen zur Konfiguration finden Sie in den  Anweisungen für die Apache Tomcat SSL-/TLS-Konfiguration . Weitere Informationen zu den Protokollen und Ziffernwerten finden Sie in der  Dokumentation für Apache Tomcat SSL-Support-Informationen . Starten Sie den Markvision Enterprise-Dienst erneut. Öffnen Sie das Dialogfeld  Ausführen , und geben Sie anschließend  services.msc  ein. Klicken Sie mit der rechten Maustaste auf  Markvision Enterprise , und klicken Sie anschließend auf  Neu starten . Wie verwalte ich CRL-Dateien bei der Verwendung von Microsoft CA Enterprise? Rufen Sie die CRL-Datei vom CA-Server ab. Für Microsoft CA Enterprise wird die CRL nicht automatisch über SCEP heruntergeladen. Weitere Informationen erhalten Sie im  Konfigurationshandbuch für Microsoft Certificate Authority . Speichern Sie die CRL-Datei im Ordner  installation_dir \\Lexmark\\Markvision Enterprise\\apps\\library\\crl , wobei  installation_dir  der Installationsordner von MVE ist. Konfigurieren Sie die Zertifizierungsstelle in MVE. Dieser Prozess wird nur für das SCEP-Protokoll verwendet. Unterstützte Modelle Konfiguration Reverse DNS Lookup Host Name Lookup Reverse-Lookup Protokolldateien Suchen Anwendungsprotokolldateien Suchen Installationsprotokolldateien Suchen Gespeicherte Suchvorgänge aufrufen Windows-Firewall Regeln hinzufügen AES256-Verschlüsselung Konfigurieren Ports Konfigurieren Ziffern Anpassen TLS-Versionen Anpassen Microsoft Enterprise CA Konfigurieren"},{"UUID":"c63df5ae-c15e-4049-a06b-3f005b8d7b5e","title":"Fehlerbehebung","link":"trb-forgotten-password-mve-topic.html","desc":"Benutzer hat das Passwort vergessen","descFull":"Benutzer hat das Passwort vergessen Setzen Sie das Passwort des Benutzers zurück. Sie müssen über Administratorrechte verfügen, um das Passwort zurückzusetzen. Klicken Sie in der oberen rechten Ecke der Seite auf  . Klicken Sie auf  Benutzer , und wählen Sie dann einen Benutzer aus. Klicken Sie auf  Bearbeiten , und ändern Sie dann das Passwort. Klicken Sie auf  Änderungen speichern . Wenn Sie Ihr Passwort vergessen haben, gehen Sie wie folgt vor: Wenden Sie sich an einen anderen Administrator, um Ihr Passwort zurückzusetzen. Setzen Sie sich mit dem Lexmark Kundendienst in Verbindung. Benutzer hat das Passwort vergessen Fehlerbehebung Benutzer hat das Passwort vergessen Passwort zurücksetzen"},{"UUID":"3fded53a-6abf-4cae-b110-db7f985d7648","title":"Fehlerbehebung","link":"trb-admin-forgotten-password-mve-topic.html","desc":"Administrator hat das Kennwort vergessen.","descFull":"Administrator hat das Kennwort vergessen. Erstellen Sie ein weiteres Administratorkonto, und löschen Sie dann das vorherige Konto. Sie können das Markvision Enterprise-Kennwortdienstprogramm verwenden, um ein weiteres Administratorkonto zu erstellen. Navigieren Sie zu dem Ordner, in dem Markvision Enterprise installiert ist. Beispiel:  C:\\Program Files\\ Starten Sie die Datei  mvepwdutility-windows.exe  im Verzeichnis Lexmark\\Markvision Enterprise\\. Wählen Sie eine Sprache aus und klicken Sie dann auf  OK Weiter . Wählen Sie  Benutzerkonto hinzufügen Weiter  aus. Geben Sie die Benutzeranmeldeinformationen ein. Klicken Sie auf  Weiter . Greifen Sie auf MVE zu, und löschen Sie dann den vorherigen Administrator. Weitere Informationen finden Sie unter  . Administrator hat das Kennwort vergessen. Fehlerbehebung Administrator hat das Kennwort vergessen."},{"UUID":"30d1de66-c97f-462c-b9d5-d286f368d804","title":"Fehlerbehebung","link":"trb-page-loading-infinitely-topic.html","desc":"Seite wird nicht geladen Dieses","descFull":"Seite wird nicht geladen Dieses Problem kann auftreten, wenn Sie den Webbrowser geschlossen haben, ohne sich abzumelden. Probieren Sie eine oder mehrere der folgenden Vorgehensweisen: Löschen Sie den Cache, und löschen Sie die Cookies in Ihrem Webbrowser Greifen Sie auf die MVE-Anmeldeseite zu, und melden Sie sich dann mit Ihren Anmeldeinformationen an. Öffnen Sie einen Web-Browser, und geben Sie dann Folgendes ein:  https:// MVE_SERVER /mve/login , wobei  MVE_SERVER  der Hostname oder die IP-Adresse der auf dem Server gehosteten MVE-Software ist. Seite wird ohne Ende geladen Fehlerbehebung Seite wird ohne Ende geladen"},{"UUID":"31b680ef-ad48-4739-9896-35ce3b450446","title":"Fehlerbehebung","link":"trb-cannot-discover-network-device-topic.html","desc":"Netzwerkdrucker kann nicht gefunden werden","descFull":"Netzwerkdrucker kann nicht gefunden werden Probieren Sie eine oder mehrere der folgenden Methoden: Stellen Sie sicher, dass der Drucker eingeschaltet ist. Stellen Sie sicher, dass das Netzkabel sicher an den Drucker und eine ordnungsgemäß geerdete Netzsteckdose angeschlossen ist. Verbindung des Druckers mit dem Netzwerk Starten Sie den Drucker neu. Stellen Sie sicher, dass TCP/IP auf dem Drucker aktiviert ist. Stellen Sie sicher, dass die von MVE verwendeten Anschlüsse geöffnet sind und dass SNMP und mDNS aktiviert sind. Weitere Informationen finden Sie unter  . Wenden Sie sich an Ihren Ansprechpartner bei Lexmark. Fehlerbehebung Netzwerkgerät kann nicht gefunden werden Netzwerkgerät kann nicht gefunden werden"},{"UUID":"c684fb69-206e-40a5-a7b3-46aba78e79c5","title":"Fehlerbehebung","link":"trb-incorrect-device-information-topic.html","desc":"Falsche Druckerinformationen Durchführen von Audits","descFull":"Falsche Druckerinformationen Durchführen von Audits Weitere Informationen finden Sie unter  . Falsche Druckerinformationen Fehlerbehebung Falsche Druckerinformationen"},{"UUID":"b47ed8f9-f122-454f-87a2-cdb6b2205b05","title":"Fehlerbehebung","link":"trb-mve-does-not-recognize-secured-printer-topic.html","desc":"MVE erkennt einen Drucker nicht","descFull":"MVE erkennt einen Drucker nicht als gesicherten Drucker. Stellen Sie sicher, dass der Drucker gesichert ist. Weitere Informationen zum Sichern von Druckern finden Sie im Dokument  Markvision Enterprise und Druckersicherheit . Stellen Sie sicher, dass mDNS eingeschaltet und nicht blockiert ist. Löschen Sie den Drucker, und führen Sie die Druckererkennung erneut aus. Weitere Informationen finden Sie unter  . MVE erkennt einen Drucker nicht als gesicherten Drucker. Fehlerbehebung MVE erkennt einen Drucker nicht als gesicherten Drucker."},{"UUID":"73196bf0-dba3-49b6-8d55-e843c2188d0a","title":"Fehlerbehebung","link":"trb-config-enforcement-fails-topic.html","desc":"Das Erzwingen von Konfigurationen mit","descFull":"Das Erzwingen von Konfigurationen mit mehreren Anwendungen schlägt beim ersten Versuch fehl, ist jedoch bei den nachfolgenden Versuchen erfolgreich. Erhöhen der Zeitsperren Navigieren Sie zu dem Ordner, in dem Markvision Enterprise installiert ist. Beispiel:  C:\\Program Files\\ Navigieren Sie zum Ordner Lexmark\\MarkVision Enterprise\\apps\\dm-mve\\WEB-INF\\classes. Öffnen Sie mit einem Texteditor die Datei  platform.properties . Bearbeiten Sie den Wert  cdcl.ws.readTimeout . Der Wert wird in Millisekunden angegeben. 90.000 Millisekunden entsprechen zum Beispiel 90 Sekunden. Öffnen Sie mit einem Texteditor die Datei  devCom.properties . Bearbeiten Sie die Werte  lst.responseTimeoutsRetries . Der Wert wird in Millisekunden angegeben. 10.000 Millisekunden entsprechen zum Beispiel 10 Sekunden. Beispiel:  lst.responseTimeoutsRetries=10000 15000 20000 . Der erste Verbindungsversuch erfolgt nach 10 Sekunden, der zweite Verbindungsversuch nach 15 Sekunden und der dritte Verbindungsversuch nach 20 Sekunden. Wenn Sie LDAP GSSAPI verwenden, erstellen Sie gegebenenfalls eine Datei  parameters.properties . Fügen Sie die folgende Einstellung hinzu:  lst.negotiation.timeout=400 Der Wert wird in Sekunden angegeben. Speichern Sie die Änderungen. Das Erzwingen von Konfigurationen mit mehreren Anwendungen schlägt beim ersten Versuch fehl, ist jedoch bei den nachfolgenden Versuchen erfolgreich. Fehlerbehebung Das Erzwingen von Konfigurationen mit mehreren Anwendungen schlägt beim ersten Versuch fehl, ist jedoch bei den nachfolgenden Versuchen erfolgreich."},{"UUID":"e5c2a309-6b5b-4be5-beeb-d48a53202399","title":"Fehlerbehebung","link":"trb-enforcement-printer-cert-fails-topic.html","desc":"Die Durchsetzung von Konfigurationen mit","descFull":"Die Durchsetzung von Konfigurationen mit Druckerzertifikat schlägt fehl Manchmal wird während der Durchsetzung kein neues Zertifikat ausgestellt. Erhöhen Sie die Anzahl der Anmeldungswiederholungen Fügen Sie den folgenden Schlüssel in die  Datei platform.properties  ein: enrol.maxEnrolmentRetry=10 Der Wert für die Wiederholung muss größer als fünf sein. Durchsetzung von Konfigurationen mit Druckerzertifikat schlägt fehl Fehlerbehebung Durchsetzung von Konfigurationen mit Druckerzertifikat schlägt fehl"},{"UUID":"091d9fdb-7229-40db-93e6-7d7211fb24e6","title":"OpenXPKI Zertifizierungsstelle","link":"trb-openxpki-ca-group.html","desc":"Zertifikatausstellung mit dem OpenXPKI CA-Server","descFull":"Zertifikatausstellung mit dem OpenXPKI CA-Server fehlgeschlagen Stellen Sie sicher, dass der Schlüssel \"Unterzeichner im Auftrag\" in MVE mit dem Schlüssel des autorisierten Unterzeichners im CA-Server übereinstimmt. Beispiel: Wenn der folgende der  ca.onBehhalf.cn -Schlüssel in der Datei  platform.properties  in MVE ist, ca.onBehalf.cn=Markvision_SQA-2012-23AB.lrdc.lexmark.ds muss der folgende der  authorized_signer -Schlüssel in der Datei  generic.yaml  im CA-Server sein. rule1:\n\t\t\t# Full DN\n\t\t\t\t\tSubject: CN=Markvision_SQA-2012-23AB.lrdc.lexmark.ds Weitere Informationen zum Konfigurieren des OpenXPKI CA-Servers finden Sie im  Konfigurationshandbuch für OpenXPKI Certificate Authority . Zertifikatausstellung mit dem OpenXPKI CA-Server fehlgeschlagen Fehlerbehebung Zertifikatausstellung mit dem OpenXPKI CA-Server fehlgeschlagen"},{"UUID":"87e35967-25cb-4a84-9932-25f530f54e92","title":"OpenXPKI Zertifizierungsstelle","link":"trb-openxpki-ca-group.html","desc":"Ein interner Fehler tritt auf.","descFull":"Ein interner Fehler tritt auf. Installieren Sie das Gebietsschema en_US.utf8. Führen Sie den Befehl  dpkg-reconfigure locales  aus. Installieren Sie das Gebietsschema  en_US.utf8  (locale -a | grep en_US). Fehlerbehebung Interner Serverfehler Interner Serverfehler"},{"UUID":"84d1252a-ea7b-4b5c-87bc-5f5ddf0563bc","title":"OpenXPKI Zertifizierungsstelle","link":"trb-openxpki-ca-group.html","desc":"Die Anmeldeaufforderung wird nicht angezeigt.","descFull":"Die Anmeldeaufforderung wird nicht angezeigt. Beim Zugriff auf  http://yourhost/openxpki/  erhalten Sie nur das Open Source TrustCenter-Banner ohne Anmeldeaufforderung. Aktivieren Sie  fcgid . Führen Sie die folgenden Befehle aus: a2enmod fcgid service apache2 restart Fehlerbehebung Anmeldeaufforderung wird nicht angezeigt Anmeldeaufforderung wird nicht angezeigt"},{"UUID":"5110857c-02c1-4c2c-b812-76524e9d0343","title":"OpenXPKI Zertifizierungsstelle","link":"trb-openxpki-ca-group.html","desc":"Ein Fehler \"Verschachtelter Connector ohne","descFull":"Ein Fehler \"Verschachtelter Connector ohne Klasse\" tritt auf. Ein Fehler  AUSNAHME: Verschachtelter Connector ohne Klasse (scep.scep-server-1.connector.initial)  tritt bei /usr/share/perl5/Connector/Multi.pm Zeile 201 auf. Aktualisieren Sie  scep.scep-server-1 . Ersetzen Sie in  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml scep.scep-server-1  durch  scep.generic . Ersetzen Sie  REAL  durch den Namen des Bereichs. Wenn Sie beispielsweise den Standardbereich verwenden, verwenden Sie  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial Fehlerbehebung Verschachtelter Connector ohne Klassenfehler Verschachtelter Connector ohne Klassenfehler"},{"UUID":"88639f42-a93d-4edd-ac9f-e486e89fb71e","title":"OpenXPKI Zertifizierungsstelle","link":"trb-openxpki-ca-group.html","desc":"Zertifikate können nicht manuell genehmigt","descFull":"Zertifikate können nicht manuell genehmigt werden. Die Schaltfläche  Manuell genehmigen  wird beim manuellen Genehmigen von Zertifikaten nicht angezeigt. Aktualisieren Sie  scep.scep-server-1 . Ersetzen Sie in  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml scep.scep-server-1  durch  scep.generic . Ersetzen Sie  REAL  durch den Namen des Bereichs. Wenn Sie beispielsweise den Standardbereich verwenden, verwenden Sie  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial Fehlerbehebung Zertifikate können nicht manuell genehmigt werden Zertifikate können nicht manuell genehmigt werden"},{"UUID":"1928acf1-9651-47b4-a720-21c403fb268a","title":"OpenXPKI Zertifizierungsstelle","link":"trb-openxpki-ca-group.html","desc":"Beim Genehmigen von Registrierungsanforderungen tritt","descFull":"Beim Genehmigen von Registrierungsanforderungen tritt ein Perl-Fehler auf. Aktualisieren Sie  scep.scep-server-1 . Ersetzen Sie in  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml scep.scep-server-1  durch  scep.generic . Ersetzen Sie  REAL  durch den Namen des Bereichs. Wenn Sie beispielsweise den Standardbereich verwenden, verwenden Sie  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial Fehlerbehebung Perl-Fehler Perl-Fehler"},{"UUID":"5b4be707-cf40-4d9b-9457-dc7bdf5158d0","title":"OpenXPKI Zertifizierungsstelle","link":"trb-openxpki-ca-group.html","desc":"Die Token  ca-signer-1 ","descFull":"Die Token  ca-signer-1  und  vault-1  sind offline Die Seite  Systemstatus  zeigt an, dass die Token  ca-signer-1  und  vault-1  offline sind. Probieren Sie eine oder mehrere der folgenden Methoden: Kennwort des Zertifikatschlüssels ändern Ändern Sie das Kennwort des Zertifikatschlüssels in  /etc/openxpki/config.d/realm/ca-one/crypto.yaml . Die korrekten Symlinks erstellen und die Schlüsseldatei kopieren Weitere Informationen finden Sie unter  . Stellen Sie sicher, dass die Schlüsseldatei von OpenXPKI gelesen werden kann. Fehlerbehebung ca-signer-1 ist offline Fehlerbehebung Vault-1 ist offline ca-signer-1 ist offline Fehlerbehebung Vault-1 ist offline Fehlerbehebung"},{"UUID":"2fbb2450-ff83-4ead-8e5e-1239b5d44d94","title":"Anhang","link":"understanding-ports-and-protocols-topic.html","desc":"Erläuterungen zu Anschlüssen und Protokollen","descFull":"Erläuterungen zu Anschlüssen und Protokollen Wie in der folgenden Übersicht dargestellt, setzt MVE verschiedene Anschlüsse und Protokolle für verschiedene Netzwerkkommunikationstypen ein: Die Anschlüsse sind bidirektional und müssen für MVE geöffnet oder aktiv sein, um ordnungsgemäß zu funktionieren. Stellen Sie sicher, dass alle Druckeranschlüsse aktiviert sind. Für einige Kommunikationen ist ein flüchtiger Anschluss erforderlich, das bedeutet ein zugewiesener Bereich verfügbarer Anschlüsse am Server. Wenn ein Client eine temporäre Kommunikationssitzung anfragt, weist der Server dem Client einen dynamischen Anschluss zu. Der Anschluss ist nur kurzzeitig gültig und kann wieder verwendet werden, wenn die vorherige Sitzung abläuft. Kommunikation zwischen Server und Drucker In der folgenden Tabelle sehen Sie die während der Kommunikation zwischen MVE-Server und Netzwerkdruckern verwendeten Anschlüsse und Protokolle. Protokoll MVE-Server Drucker Einsatzgebiet Network Printing Alliance Protocol (Protokoll im NPAP-Format) UDP 9187 UDP 9300 Kommunikation mit Lexmark Netzwerkdruckern. Kommunikation mit Netzwerkdruckern. XML-Netzwerktransport (XMLNT) UDP 9187 UDP 6000 Kommunikation mit einigen Lexmark Netzwerkdruckern. Kommunikation mit einigen Netzwerkdruckern. Lexmark Secure Transport (LST) UDP 6100 Flüchtiger TCP-Anschluss (Transmission Control Protocol) (Quittungsbetrieb) UDP 6100 TCP 6110 (Quittungsbetrieb) Sichere Kommunikation mit einigen Lexmark Netzwerkdruckern. Sichere Kommunikation mit einigen Netzwerkdruckern. Multicast Domain Name System (mDNS) Flüchtiger UDP-Anschluss (User Datagram Protocol) UDP 5353 Suche nach Lexmark Netzwerkdruckern und Festlegen von Druckersicherheitsfunktionen. Suche nach bestimmten Netzwerkdruckern und Festlegen von Druckersicherheitsfunktionen. Dieser Anschluss ist erforderlich, damit MVE mit gesicherten Druckern kommunizieren kann. Simple Network Management Protocol (SNMP) Flüchtiger UDP-Anschluss UDP 161 Suche nach und Kommunikation mit Netzwerkdruckern von Lexmark und von Drittanbietern. Suche nach und Kommunikation mit Netzwerkdruckern. File Transfer Protocol (FTP) Flüchtiger TCP-Anschluss TCP 21 TCP 20 Dateien bereitstellen. Hypertext Transfer Protocol (HTTP) Flüchtiger TCP-Anschluss TCP 80 Dateien bereitstellen oder Konfigurationen durchsetzen. TCP 443 Dateien bereitstellen oder Konfigurationen durchsetzen. Hypertext Transfer Protocol over SSL (HTTPS) Flüchtiger TCP-Anschluss TCP 161 TCP 443 Dateien bereitstellen oder Konfigurationen durchsetzen. RAW Flüchtiger TCP-Anschluss TCP 9100 Dateien bereitstellen oder Konfigurationen durchsetzen. Kommunikation zwischen Drucker und Server Dies sind Anschluss und Protokoll, die während der Kommunikation zwischen Netzwerkdruckern und dem MVE-Server verwendet werden. Protokoll Drucker MVE-Server Einsatzgebiet NPAP UDP 9300 UDP 9187 Generieren und empfangen von Warnungen Kommunikation zwischen Server und Datenbank In der folgenden Tabelle sehen Sie die während der Kommunikation zwischen MVE-Server und Datenbanken verwendeten Anschlüsse. MVE-Server Datenbank Einsatzgebiet Flüchtiger TCP-Anschluss Benutzerdefinierter Anschluss. Der Standardanschluss ist TCP 1433. Kommunikation mit einer SQL Server-Datenbank. Flüchtiger TCP-Anschluss TCP 3050 Kommunikation mit einer Firebird-Datenbank. Kommunikation zwischen Client und Server Dies sind Anschluss und Protokoll, die während der Kommunikation zwischen Browserclient und MVE-Server verwendet werden. Protokoll Browserclient MVE-Server Hypertext Transfer Protocol over SSL (HTTPs) TCP-Anschluss TCP 443 Kommunikation zwischen Server und Mail-Server In der folgenden Tabelle sehen Sie die während der Kommunikation zwischen MVE-Server und Mail-Server verwendeten Anschlüsse und Protokolle. Protokoll MVE-Server SMTP-Server Einsatzgebiet Simple Mail Transfer Protocol (SMTP) Flüchtiger TCP-Anschluss Benutzerdefinierter Anschluss. Der Standardanschluss ist TCP 25. Stellt die E-Mail-Funktionen für den Empfang von Druckerwarnungen bereit. Kommunikation zwischen Server und LDAP-Server Dies sind Anschlüsse und Protokoll, die während der Kommunikation zwischen MVE-Server und einem LDAP-Server verwendet werden, einschließlich Benutzergruppen und Authentifizierungsfunktionen. Protokoll MVE-Server LDAP-Server Einsatzgebiet Lightweight Directory Access Protocol (LDAP) Flüchtiger TCP-Anschluss Benutzerdefinierter Anschluss. Der Standardanschluss ist TCP 389. Authentifizierung von MVE-Benutzern, die einen LDAP-Server verwenden. Lightweight Directory Access Protocol über TLS (LDAPS) Flüchtiger TCP-Anschluss Benutzerdefinierter Anschluss. Der Standardanschluss ist TCP 636. Authentifizierung von MVE-Benutzern, die einen LDAP-Server über TLS verwenden. Kerberos Flüchtiger UDP-Anschluss Benutzerdefinierter Anschluss. Der Standardanschluss ist UDP 88. Authentifizierung von MVE-Benutzern mit Kerberos. Ports Erläuterungen Protokolle Erläuterungen"},{"UUID":"fc999735-4c2d-4a55-9ca0-677c1985acb5","title":"Anhang","link":"enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html","desc":"Aktivieren der automatischen Genehmigung von","descFull":"Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in Microsoft CA Standardmäßig befinden sich alle CA-Server im Ausstehend-Modus, und Sie müssen jede signierte Zertifikatsanforderung manuell genehmigen. Da diese Methode für Bulk-Anforderungen unpraktisch ist, aktivieren Sie die automatische Genehmigung signierter Zertifikate. Klicken Sie im Server-Manager auf  Extras  Zertifizierungsstelle . Klicken Sie im linken Bereich mit der rechten Maustaste auf die Zertifizierungsstelle, und klicken Sie anschließend auf  Eigenschaften  Richtlinienmodul . Klicken Sie auf der Registerkarte  Anforderungsbehandlung  auf  Einstellungen in der Zertifikatsvorlage befolgen, falls zutreffend , und klicken Sie anschließend auf  OK . Wenn  Zertifikatsanforderungsstatus auf ausstehend festlegen  aktiviert ist, müssen Sie das Zertifikat manuell genehmigen. Starten Sie den CA-Dienst neu. Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in Microsoft CA Automatische Genehmigung von Zertifikatsanforderungen Aktivieren in Microsoft CA Zertifikatsanforderungen in Microsoft CA Automatische Genehmigung"},{"UUID":"47255c7d-bd89-4c1d-85ae-bef844b869ee","title":"Anhang","link":"revoking-certificates-topic.html","desc":"Widerrufen von Zertifikaten Stellen Sie","descFull":"Widerrufen von Zertifikaten Stellen Sie zu Beginn sicher, dass der CA-Server für CRLs konfiguriert ist und dass sie verfügbar sind. Öffnen Sie auf dem CA-Server die  Zertifizierungsstelle . Erweitern Sie im linken Bereich die Zertifizierungsstelle, und klicken Sie anschließend auf  Ausgestellte Zertifikate . Klicken Sie mit der rechten Maustaste auf ein Zertifikat, das Sie widerrufen möchten, und klicken Sie anschließend auf  Alle Aufgaben  Zertifikat widerrufen . Wählen Sie einen Grundcode und das Datum und die Uhrzeit für den Widerruf aus, und klicken Sie anschließend auf  Ja . Klicken Sie im linken Bereich mit der rechten Maustaste auf  Widerrufene Zertifikate , und klicken Sie anschließend auf  Alle Aufgaben  Veröffentlichen . Stellen Sie sicher, dass das widerrufene Zertifikat unter  Widerrufene Zertifikate  aufgeführt ist. Sie können die Seriennummer des widerrufenen Zertifikats in der CRL sehen. Widerrufen von Zertifikaten Zertifikate Widerrufen"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"divd0e8"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_c('div',{attrs:{"id":"divd0e11936"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"Markvision Enterprise"}},[_vm._v("\n    Markvision Enterprise\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"change-history.html#change-history_de","title":"&Auml;nderungsverlauf"}},[_vm._v("\n    Änderungsverlauf\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"overview-chapter.html#overview-chapter_de","title":"&Uuml;bersicht"}},[_vm._v("\n    Übersicht\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e252"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"overview-chapter.html#overview-markvision-enterprise_de","title":"Grundlagen zu Markvision Enterprise"}},[_vm._v("\n     Grundlagen zu Markvision Enterprise\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"getting-started-chapter.html#getting-started-chapter_de","title":"Erste Schritte"}},[_vm._v("\n    Erste Schritte\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e281"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"best-practices-topic.html#best-practices_de","title":"Best Practices"}},[_vm._v("\n     Best Practices\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"system-requirements-topic.html#system-requirements_de","title":"Systemvoraussetzungen"}},[_vm._v("\n     Systemvoraussetzungen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-languages-topic.html#supported-languages_de","title":"Unterst&uuml;tzte Sprachen"}},[_vm._v("\n     Unterstützte Sprachen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-printer-models-topic.html#supported-printer-models_de","title":"Unterst&uuml;tzte Druckermodelle"}},[_vm._v("\n     Unterstützte Druckermodelle\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-database-topic.html#setting-up-database_de","title":"Einrichten der Datenbank"}},[_vm._v("\n     Einrichten der Datenbank\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-mve-run-as-user-topic.html#d0e1122","title":"Einrichten einer Benutzeranmeldung"}},[_vm._v("\n     Einrichten einer Benutzeranmeldung\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-markvision-topic.html#installing-markvision_de","title":"Installation von MVE"}},[_vm._v("\n     Installation von MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-mve-silently-topic.html#installing-mve-silently_de","title":"Installieren von MVE im Hintergrund"}},[_vm._v("\n     Installieren von MVE im Hintergrund\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-mve-topic.html#accessing-mve_de","title":"Zugreifen auf MVE"}},[_vm._v("\n     Zugreifen auf MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-language-topic.html#changing-language_de","title":"&Auml;ndern der Sprache"}},[_vm._v("\n     Ändern der Sprache\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-your-password-topic.html#changing-your-password_de","title":"&Auml;ndern des Passworts"}},[_vm._v("\n     Ändern des Passworts\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintaining-application-chapter.html#maintaining-application-chapter_de","title":"Warten der Anwendung"}},[_vm._v("\n    Warten der Anwendung\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1705"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"upgrading-to-latest-version-topic.html#upgrading-to-latest-version_de","title":"Aktualisieren auf MVE&nbsp;4.2"}},[_vm._v("\n     Aktualisieren auf MVE 4.2\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_de","title":"Sichern und Wiederherstellen der Datenbank"}},[_vm._v("\n     Sichern und Wiederherstellen der Datenbank\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-installer-settings-topic.html#changing-installer-settings_de","title":"Aktualisieren der Installationsprogramm-Einstellungen nach der Installation"}},[_vm._v("\n     Aktualisieren der Installationsprogramm-Einstellungen nach der Installation\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-user-access-chapter.html#setting-user-access-chapter_de","title":"Einrichten des Benutzerzugriffs"}},[_vm._v("\n    Einrichten des Benutzerzugriffs\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1977"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-user-access-overview-topic.html#setting-up-user-access-overview_de","title":"&Uuml;bersicht"}},[_vm._v("\n     Übersicht\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-user-roles-topic.html#understanding-user-roles_de","title":"Informationen zu Benutzerrollen"}},[_vm._v("\n     Informationen zu Benutzerrollen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-users-topic.html#managing-users_de","title":"Verwalten von Benutzern"}},[_vm._v("\n     Verwalten von Benutzern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_de","title":"Aktivieren der LDAP-Server-Authentifizierung"}},[_vm._v("\n     Aktivieren der LDAP-Server-Authentifizierung\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_de","title":"Installieren von LDAP-Serverzertifikaten"}},[_vm._v("\n     Installieren von LDAP-Serverzertifikaten\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"discovering-devices-chapter.html#discovering-devices-chapter_de","title":"Erkennen von Druckern"}},[_vm._v("\n    Erkennen von Druckern\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2358"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-discovery-profile-topic.html#creating-discovery-profile_de","title":"Erstellen eines Suchprofils"}},[_vm._v("\n     Erstellen eines Suchprofils\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-discovery-profiles-topic.html#managing-discovery-profiles_de","title":"Verwalten von Suchprofilen"}},[_vm._v("\n     Verwalten von Suchprofilen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_de","title":"Beispielszenario: Erkennen von Druckern"}},[_vm._v("\n     Beispielszenario: Erkennen von Druckern\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_de","title":"Verwalten des Sicherheits-Dashboards"}},[_vm._v("\n    Verwalten des Sicherheits-Dashboards\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2614"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"overview-security-dashboard-topic.html#overview-security-dashboard_de","title":"&Uuml;bersicht"}},[_vm._v("\n     Übersicht\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-dashboard-topic.html#accessing-dashboard_de","title":"Zugriff auf das Sicherheits-Dashboard"}},[_vm._v("\n     Zugriff auf das Sicherheits-Dashboard\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-device-security-information-topic.html#managing-device-security-information_de","title":"Verwalten der Ger&auml;te-Sicherheitsinformationen"}},[_vm._v("\n     Verwalten der Geräte-Sicherheitsinformationen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-device-conformance-check-topic.html#managing-device-conformance-check_de","title":"Verwalten der Ger&auml;tekonformit&auml;tspr&uuml;fung"}},[_vm._v("\n     Verwalten der Gerätekonformitätsprüfung\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"finding-devices-chapter.html#finding-devices-chapter_de","title":"Anzeigen von Druckern"}},[_vm._v("\n    Anzeigen von Druckern\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2702"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-printer-list-topic.html#viewing-printer-list_de","title":"Anzeigen der Druckerliste"}},[_vm._v("\n     Anzeigen der Druckerliste\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-device-information-topic.html#viewing-device-information_de","title":"Anzeigen der Druckerinformationen"}},[_vm._v("\n     Anzeigen der Druckerinformationen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-data-topic.html#exporting-data_de","title":"Exportieren von Druckerdaten"}},[_vm._v("\n     Exportieren von Druckerdaten\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-views-topic.html#managing-views_de","title":"Verwalten von Ansichten"}},[_vm._v("\n     Verwalten von Ansichten\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-printer-listing-view-topic.html#changing-printer-listing-view_de","title":"Druckerlistenansicht &auml;ndern"}},[_vm._v("\n     Druckerlistenansicht ändern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_de","title":"Filtern von Druckern &uuml;ber die Suchleiste"}},[_vm._v("\n     Filtern von Druckern über die Suchleiste\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-keywords-topic.html#managing-keywords_de","title":"Verwalten von Schl&uuml;sselw&ouml;rtern"}},[_vm._v("\n     Verwalten von Schlüsselwörtern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-device-life-cycle-states-topic.html#d0e3162","title":"Verwenden gespeicherter Suchvorg&auml;nge"}},[_vm._v("\n     Verwenden gespeicherter Suchvorgänge\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_de","title":"Beispielszenario: &Uuml;berwachung der Tonerst&auml;nde Ihrer Flotte"}},[_vm._v("\n     Beispielszenario: Überwachung der Tonerstände Ihrer Flotte\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-devices-chapter.html#securing-devices-chapter_de","title":"Sichern der Druckerkommunikation"}},[_vm._v("\n    Sichern der Druckerkommunikation\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4099"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-security-status-topic.html#understanding-security-status_de","title":"Bedeutung des Druckersicherheitsstatus"}},[_vm._v("\n     Bedeutung des Druckersicherheitsstatus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printers-using-default-config-topic.html#securing-printers-using-default-config_de","title":"Sichern von Druckern unter Verwendung der Standardkonfigurationen"}},[_vm._v("\n     Sichern von Druckern unter Verwendung der Standardkonfigurationen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-fac-permissions-topic.html#understanding-fac-permissions_de","title":"Bedeutung von Berechtigungen und Funktionszugriffssteuerungen"}},[_vm._v("\n     Bedeutung von Berechtigungen und Funktionszugriffssteuerungen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-device-security-topic.html#configuring-device-security_de","title":"Konfigurieren der Druckersicherheit"}},[_vm._v("\n     Konfigurieren der Druckersicherheit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_de","title":"Sichern der Kommunikation in der Druckerflotte"}},[_vm._v("\n     Sichern der Kommunikation in der Druckerflotte\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printers-topic.html#securing-printers_de","title":"Andere M&ouml;glichkeiten, Ihre Drucker zu sch&uuml;tzen"}},[_vm._v("\n     Andere Möglichkeiten, Ihre Drucker zu schützen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-assets-chapter.html#managing-assets-chapter_de","title":"Verwalten von Druckern"}},[_vm._v("\n    Verwalten von Druckern\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4463"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restarting-printer-topic.html#restarting-printer_de","title":"Neustarten des Druckers"}},[_vm._v("\n     Neustarten des Druckers\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-ews-topic.html#viewing-ews_de","title":"Anzeigen des Embedded Web Servers des Druckers"}},[_vm._v("\n     Anzeigen des Embedded Web Servers des Druckers\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"auditing-devices-topic.html#auditing-devices_de","title":"&Uuml;berpr&uuml;fen von Druckern"}},[_vm._v("\n     Überprüfen von Druckern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"updating-printer-status-topic.html#updating-printer-status_de","title":"Aktualisieren des Druckerstatus"}},[_vm._v("\n     Aktualisieren des Druckerstatus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-device-state-topic.html#setting-device-state_de","title":"Einstellen des Druckerstatus"}},[_vm._v("\n     Einstellen des Druckerstatus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_de","title":"Zuweisen von Konfigurationen zu Druckern"}},[_vm._v("\n     Zuweisen von Konfigurationen zu Druckern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"unassigning-configurations-topic.html#unassigning-configurations_de","title":"Aufheben der Zuweisung von Konfigurationen"}},[_vm._v("\n     Aufheben der Zuweisung von Konfigurationen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enforcing-configurations-topic.html#enforcing-configurations_de","title":"Durchsetzen von Konfigurationen"}},[_vm._v("\n     Durchsetzen von Konfigurationen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-device-conformance-topic.html#checking-device-conformance_de","title":"Pr&uuml;fen der Drucker&uuml;bereinstimmung mit einer Konfiguration"}},[_vm._v("\n     Prüfen der Druckerübereinstimmung mit einer Konfiguration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"deploying-files-to-printers-topic.html#deploying-files-to-printers_de","title":"Bereitstellen von Dateien f&uuml;r Drucker"}},[_vm._v("\n     Bereitstellen von Dateien für Drucker\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"updating-printer-firmware-topic.html#updating-printer-firmware_de","title":"Aktualisieren der Drucker-Firmware"}},[_vm._v("\n     Aktualisieren der Drucker-Firmware\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_de","title":"Deinstallieren von Anwendungen auf Druckern"}},[_vm._v("\n     Deinstallieren von Anwendungen auf Druckern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-events-to-device-topic.html#assigning-events-to-device_de","title":"Zuweisen von Ereignissen zu Druckern"}},[_vm._v("\n     Zuweisen von Ereignissen zu Druckern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-keyword-topic.html#assigning-keyword_de","title":"Zuweisen von Stichw&ouml;rtern zu Druckern"}},[_vm._v("\n     Zuweisen von Stichwörtern zu Druckern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_de","title":"Eingeben von Anmeldeinformationen f&uuml;r gesicherte Drucker"}},[_vm._v("\n     Eingeben von Anmeldeinformationen für gesicherte Drucker\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_de","title":"Manuelles Konfigurieren von Standarddruckerzertifikaten"}},[_vm._v("\n     Manuelles Konfigurieren von Standarddruckerzertifikaten\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"removing-printers-topic.html#removing-printers_de","title":"Entfernen von Druckern"}},[_vm._v("\n     Entfernen von Druckern\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-configurations-chapter.html#managing-configurations-chapter_de","title":"Verwalten von Konfigurationen"}},[_vm._v("\n    Verwalten von Konfigurationen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5069"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-configurations-overview-topic.html#managing-configurations-overview_de","title":"&Uuml;bersicht"}},[_vm._v("\n     Übersicht\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-configuration-topic.html#creating-configuration_de","title":"Erstellen einer Konfiguration"}},[_vm._v("\n     Erstellen einer Konfiguration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-configuration-from-printer-topic.html#creating-configuration-from-printer_de","title":"Erstellen einer Konfiguration &uuml;ber einen Drucker"}},[_vm._v("\n     Erstellen einer Konfiguration über einen Drucker\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_de","title":"Beispielszenario: Duplizieren einer Konfiguration"}},[_vm._v("\n     Beispielszenario: Duplizieren einer Konfiguration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-advanced-security-component-topic.html#creating-advanced-security-component_de","title":"Erstellen einer erweiterten Sicherheitskomponente von einem Drucker"}},[_vm._v("\n     Erstellen einer erweiterten Sicherheitskomponente von einem Drucker\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-printable-version-topic.html#generating-printable-version_de","title":"Erstellen einer druckbaren Version der Konfigurationseinstellungen"}},[_vm._v("\n     Erstellen einer druckbaren Version der Konfigurationseinstellungen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-dynamic-settings-topic.html#understanding-dynamic-settings_de","title":"Grundlagen zu dynamischen Einstellungen"}},[_vm._v("\n     Grundlagen zu dynamischen Einstellungen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-variable-settings-topic.html#understanding-variable-settings_de","title":"Grundlagen zu Variableneinstellungen"}},[_vm._v("\n     Grundlagen zu Variableneinstellungen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-color-permissions-topic.html#configuring-color-permissions_de","title":"Farbdruckberechtigungen konfigurieren"}},[_vm._v("\n     Farbdruckberechtigungen konfigurieren\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-applications-package-topic.html#creating-applications-package_de","title":"Erstellen eines Anwendungspakets"}},[_vm._v("\n     Erstellen eines Anwendungspakets\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_de","title":"Importieren oder Exportieren einer Konfiguration"}},[_vm._v("\n     Importieren oder Exportieren einer Konfiguration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"importing-files-to-resource-library-topic.html#importing-files-to-resource-library_de","title":"Importieren von Dateien in die Ressourcenbibliothek"}},[_vm._v("\n     Importieren von Dateien in die Ressourcenbibliothek\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_de","title":"Verwalten von Zertifikaten"}},[_vm._v("\n    Verwalten von Zertifikaten\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5593"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-MVE-manage-certificates-automatically-group.html#d0e5596","title":"Einrichten von MVE zur automatischen Verwaltung von Zertifikaten"}},[_vm._v("\n     Einrichten von MVE zur automatischen Verwaltung von Zertifikaten\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-SCEP-group.html#d0e5922","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority &uuml;ber SCEP"}},[_vm._v("\n     Verwalten von Zertifikaten mit Microsoft Certificate Authority über SCEP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-MSCEWS-group.html#d0e6644","title":"Verwalten von Zertifikaten mit Microsoft Certificate Authority &uuml;ber MSCEWS"}},[_vm._v("\n     Verwalten von Zertifikaten mit Microsoft Certificate Authority über MSCEWS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-OpenXPKI-CA-group.html#d0e7629","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority &uuml;ber SCEP"}},[_vm._v("\n     Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über SCEP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-EST-group.html#d0e8696","title":"Verwalten von Zertifikaten mit OpenXPKI Certificate Authority &uuml;ber EST"}},[_vm._v("\n     Verwalten von Zertifikaten mit OpenXPKI Certificate Authority über EST\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-device-alerts-chapter.html#managing-device-alerts-chapter_de","title":"Verwalten von Druckerwarnungen"}},[_vm._v("\n    Verwalten von Druckerwarnungen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9781"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_de","title":"&Uuml;bersicht"}},[_vm._v("\n     Übersicht\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-action-topic.html#creating-action_de","title":"Erstellen einer Aktion"}},[_vm._v("\n     Erstellen einer Aktion\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-action-placeholders-topic.html#understanding-action-placeholders_de","title":"Informationen zu Aktionsplatzhaltern"}},[_vm._v("\n     Informationen zu Aktionsplatzhaltern\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-actions-topic.html#managing-actions_de","title":"Verwalten von Aktionen"}},[_vm._v("\n     Verwalten von Aktionen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-event-topic.html#creating-event_de","title":"Erstellen von Ereignissen"}},[_vm._v("\n     Erstellen von Ereignissen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-printer-alerts-topic.html#understanding-printer-alerts_de","title":"Informationen zu Druckerwarnungen"}},[_vm._v("\n     Informationen zu Druckerwarnungen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-events-topic.html#managing-events_de","title":"Verwalten von Ereignissen"}},[_vm._v("\n     Verwalten von Ereignissen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"viewing-tasks-chapter.html#viewing-tasks-chapter_de","title":"Anzeigen von Aufgabestatus und Verlauf"}},[_vm._v("\n    Anzeigen von Aufgabestatus und Verlauf\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10413"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_de","title":"&Uuml;bersicht"}},[_vm._v("\n     Übersicht\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-task-status-topic.html#viewing-task-status_de","title":"Anzeigen des Aufgabenstatus"}},[_vm._v("\n     Anzeigen des Aufgabenstatus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stopping-tasks-topic.html#stopping-tasks_de","title":"Aufgaben werden angehalten"}},[_vm._v("\n     Aufgaben werden angehalten\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-logs-topic.html#viewing-logs_de","title":"Anzeigen von Protokollen"}},[_vm._v("\n     Anzeigen von Protokollen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-logs-topic.html#clearing-logs_de","title":"Protokolle l&ouml;schen"}},[_vm._v("\n     Protokolle löschen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-logs-topic.html#exporting-logs_de","title":"Exportieren von Protokollen"}},[_vm._v("\n     Exportieren von Protokollen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"scheduling-tasks.html#scheduling-tasks_de","title":"Festlegen von Zeitpl&auml;nen f&uuml;r Aufgaben"}},[_vm._v("\n    Festlegen von Zeitplänen für Aufgaben\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10521"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-schedule-topic.html#creating-schedule_de","title":"Erstellen eines Zeitplans"}},[_vm._v("\n     Erstellen eines Zeitplans\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-schedules-topic.html#managing-schedules_de","title":"Verwalten von geplanten Aufgaben"}},[_vm._v("\n     Verwalten von geplanten Aufgaben\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"admin-tasks-chapter.html#admin-tasks-chapter_de","title":"Ausf&uuml;hren weiterer Verwaltungsaufgaben"}},[_vm._v("\n    Ausführen weiterer Verwaltungsaufgaben\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10663"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-system-settings-topic.html#configuring-system-settings_de","title":"Konfigurieren allgemeiner Einstellungen"}},[_vm._v("\n     Konfigurieren allgemeiner Einstellungen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-email-settings-topic.html#configuring-email-settings_de","title":"Konfigurieren der E-Mail-Einstellungen"}},[_vm._v("\n     Konfigurieren der E-Mail-Einstellungen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adding-login-disclaimer-topic.html#adding-login-disclaimer_de","title":"Hinzuf&uuml;gen eines Haftungsausschlusses bei Anmeldung"}},[_vm._v("\n     Hinzufügen eines Haftungsausschlusses bei Anmeldung\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"signing-mve-certificate-topic.html#signing-mve-certificate_de","title":"Signieren des MVE-Zertifikats"}},[_vm._v("\n     Signieren des MVE-Zertifikats\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"removing-user-information-topic.html#removing-user-information_de","title":"Entfernen von Benutzerinformationen und Verweisen"}},[_vm._v("\n     Entfernen von Benutzerinformationen und Verweisen\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"faq-chapter.html#faq-chapter_de","title":"H&auml;ufig gestellte Fragen"}},[_vm._v("\n    Häufig gestellte Fragen\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10908"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"faq-chapter.html#frequently-asked-questions_de","title":"Markvision Enterprise&nbsp;&ndash; FAQ"}},[_vm._v("\n     Markvision Enterprise – FAQ\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_de","title":"Fehlerbehebung"}},[_vm._v("\n    Fehlerbehebung\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11102"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_de","title":"Benutzer hat das Passwort vergessen"}},[_vm._v("\n     Benutzer hat das Passwort vergessen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_de","title":"Administrator hat das Kennwort vergessen."}},[_vm._v("\n     Administrator hat das Kennwort vergessen.\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_de","title":"Seite wird nicht geladen"}},[_vm._v("\n     Seite wird nicht geladen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_de","title":"Netzwerkdrucker kann nicht gefunden werden"}},[_vm._v("\n     Netzwerkdrucker kann nicht gefunden werden\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-incorrect-device-information-topic.html#trb-incorrect-device-information_de","title":"Falsche Druckerinformationen"}},[_vm._v("\n     Falsche Druckerinformationen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_de","title":"MVE erkennt einen Drucker nicht als gesicherten Drucker."}},[_vm._v("\n     MVE erkennt einen Drucker nicht als gesicherten Drucker.\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_de","title":"Das Erzwingen von Konfigurationen mit mehreren Anwendungen schl&auml;gt beim ersten Versuch fehl, ist jedoch bei den nachfolgenden Versuchen erfolgreich."}},[_vm._v("\n     Das Erzwingen von Konfigurationen mit mehreren Anwendungen schlägt beim ersten Versuch fehl, ist jedoch bei den nachfolgenden Versuchen erfolgreich.\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_de","title":"Die Durchsetzung von Konfigurationen mit Druckerzertifikat schl&auml;gt fehl"}},[_vm._v("\n     Die Durchsetzung von Konfigurationen mit Druckerzertifikat schlägt fehl\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-openxpki-ca-group.html#d0e11321","title":"OpenXPKI Zertifizierungsstelle"}},[_vm._v("\n     OpenXPKI Zertifizierungsstelle\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"appendix-chapter.html#appendix-chapter_de","title":"Anhang"}},[_vm._v("\n    Anhang\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11491"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_de","title":"Erl&auml;uterungen zu Anschl&uuml;ssen und Protokollen"}},[_vm._v("\n     Erläuterungen zu Anschlüssen und Protokollen\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_de","title":"Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in Microsoft CA"}},[_vm._v("\n     Aktivieren der automatischen Genehmigung von Zertifikatsanforderungen in Microsoft CA\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"revoking-certificates-topic.html#revoking-certificates_de","title":"Widerrufen von Zertifikaten"}},[_vm._v("\n     Widerrufen von Zertifikaten\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"leap_notices.html#leap_notices_de","title":"Hinweise"}},[_vm._v("\n    Hinweise\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11867"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#d0e11870","title":"Hinweis zur Ausgabe"}},[_vm._v("\n     Hinweis zur Ausgabe\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#d0e11906","title":"Marken"}},[_vm._v("\n     Marken\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#us-government-rights_de","title":"GOVERNMENT END USERS"}},[_vm._v("\n     GOVERNMENT END USERS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#jmdns-license_de","title":"JmDNS License"}},[_vm._v("\n     JmDNS License\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#licensing-notices-program-folder_de","title":"Lizenzhinweise"}},[_vm._v("\n     Lizenzhinweise\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"glossary.html#glossary_de","title":"Glossar"}},[_vm._v("\n    Glossar\n   ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js